webpackJsonp([1],{

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/components/sba-confirm-button.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189589905
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/components/sba-formatted-obj.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189589888
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/components/sba-icon-button.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189589908
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/components/sba-panel.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189589882
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/components/sba-status.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189589885
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/shell/navbar.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189589878
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/about/index.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590184
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/applications/applications-list.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590389
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/applications/index.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590288
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/applications/notification-filter-settings.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590620
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/auditevents/auditevents-list.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590347
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/cache-chart.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590967
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/datasource-chart.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590962
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-cache.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590922
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-datasource.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590876
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-info.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590584
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-memory.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590640
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-metadata.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590600
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-threads.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590341
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/health-details.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590872
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/index.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590317
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/mem-chart.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590834
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/threads-chart.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590671
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/heapdump/index.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590167
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/httptrace/traces-chart.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590904
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/httptrace/traces-list.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590779
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/jolokia/index.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590259
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/jolokia/m-bean-attribute.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590716
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/logfile/index.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590576
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/loggers/index.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189589896
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/loggers/logger-control.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590366
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/metrics/metric.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590385
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/sessions/sessions-list.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590931
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/shell/index.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590100
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/shell/sidebar.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590483
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/threaddump/thread-tag.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590925
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/threaddump/threads-list.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189590573
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/wallboard/hex-mesh.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189589894
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/wallboard/index.vue":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189589891
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/moment/locale recursive ^\\.\\/.*$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "./node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/moment/locale/af.js",
	"./ar": "./node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/moment/locale/ar.js",
	"./az": "./node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/moment/locale/az.js",
	"./be": "./node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/moment/locale/be.js",
	"./bg": "./node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/moment/locale/bg.js",
	"./bm": "./node_modules/moment/locale/bm.js",
	"./bm.js": "./node_modules/moment/locale/bm.js",
	"./bn": "./node_modules/moment/locale/bn.js",
	"./bn.js": "./node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/moment/locale/bo.js",
	"./br": "./node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/moment/locale/br.js",
	"./bs": "./node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/moment/locale/cy.js",
	"./da": "./node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/moment/locale/da.js",
	"./de": "./node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/moment/locale/de.js",
	"./dv": "./node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/moment/locale/dv.js",
	"./el": "./node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/moment/locale/el.js",
	"./en-au": "./node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
	"./en-il": "./node_modules/moment/locale/en-il.js",
	"./en-il.js": "./node_modules/moment/locale/en-il.js",
	"./en-nz": "./node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
	"./eo": "./node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/moment/locale/eo.js",
	"./es": "./node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/moment/locale/es-do.js",
	"./es-us": "./node_modules/moment/locale/es-us.js",
	"./es-us.js": "./node_modules/moment/locale/es-us.js",
	"./es.js": "./node_modules/moment/locale/es.js",
	"./et": "./node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/moment/locale/et.js",
	"./eu": "./node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/moment/locale/fi.js",
	"./fo": "./node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/moment/locale/fy.js",
	"./gd": "./node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/moment/locale/gl.js",
	"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
	"./gu": "./node_modules/moment/locale/gu.js",
	"./gu.js": "./node_modules/moment/locale/gu.js",
	"./he": "./node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/moment/locale/he.js",
	"./hi": "./node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/moment/locale/id.js",
	"./is": "./node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/moment/locale/is.js",
	"./it": "./node_modules/moment/locale/it.js",
	"./it.js": "./node_modules/moment/locale/it.js",
	"./ja": "./node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/moment/locale/kk.js",
	"./km": "./node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/moment/locale/km.js",
	"./kn": "./node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/moment/locale/ko.js",
	"./ky": "./node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/moment/locale/lv.js",
	"./me": "./node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/moment/locale/me.js",
	"./mi": "./node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/moment/locale/ml.js",
	"./mn": "./node_modules/moment/locale/mn.js",
	"./mn.js": "./node_modules/moment/locale/mn.js",
	"./mr": "./node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/moment/locale/ms.js",
	"./mt": "./node_modules/moment/locale/mt.js",
	"./mt.js": "./node_modules/moment/locale/mt.js",
	"./my": "./node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/moment/locale/my.js",
	"./nb": "./node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/moment/locale/nn.js",
	"./pa-in": "./node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/moment/locale/pl.js",
	"./pt": "./node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/moment/locale/sd.js",
	"./se": "./node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/moment/locale/se.js",
	"./si": "./node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/moment/locale/si.js",
	"./sk": "./node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/moment/locale/ta.js",
	"./te": "./node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/moment/locale/te.js",
	"./tet": "./node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/moment/locale/tet.js",
	"./tg": "./node_modules/moment/locale/tg.js",
	"./tg.js": "./node_modules/moment/locale/tg.js",
	"./th": "./node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/moment/locale/th.js",
	"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/moment/locale/tzm.js",
	"./ug-cn": "./node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "./node_modules/moment/locale/ug-cn.js",
	"./uk": "./node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/moment/locale recursive ^\\.\\/.*$";

/***/ }),

/***/ "./src/main/frontend/assets/css/base.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1540189592210
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./src/main/frontend/assets/img/favicon-danger.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/favicon-danger.png";

/***/ }),

/***/ "./src/main/frontend/assets/img/favicon.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/favicon.png";

/***/ }),

/***/ "./src/main/frontend/assets/img/icon-spring-boot-admin.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/icon-spring-boot-admin.svg";

/***/ }),

/***/ "./src/main/frontend/components ^(?:(?!.*\\.spec\\.(js|vue)$).)*\\.(js|vue)$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./font-awesome-icon.js": "./src/main/frontend/components/font-awesome-icon.js",
	"./index.js": "./src/main/frontend/components/index.js",
	"./sba-confirm-button.vue": "./src/main/frontend/components/sba-confirm-button.vue",
	"./sba-formatted-obj.vue": "./src/main/frontend/components/sba-formatted-obj.vue",
	"./sba-icon-button.vue": "./src/main/frontend/components/sba-icon-button.vue",
	"./sba-panel.vue": "./src/main/frontend/components/sba-panel.vue",
	"./sba-status.vue": "./src/main/frontend/components/sba-status.vue",
	"./sba-tags.vue": "./src/main/frontend/components/sba-tags.vue",
	"./sba-time-ago.js": "./src/main/frontend/components/sba-time-ago.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/main/frontend/components ^(?:(?!.*\\.spec\\.(js|vue)$).)*\\.(js|vue)$";

/***/ }),

/***/ "./src/main/frontend/components/font-awesome-icon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__("./node_modules/@fortawesome/fontawesome-svg-core/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_brands_svg_icons_faGithub__ = __webpack_require__("./node_modules/@fortawesome/free-brands-svg-icons/faGithub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_brands_svg_icons_faGithub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_brands_svg_icons_faGithub__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_free_brands_svg_icons_faGitter__ = __webpack_require__("./node_modules/@fortawesome/free-brands-svg-icons/faGitter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_free_brands_svg_icons_faGitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_free_brands_svg_icons_faGitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_brands_svg_icons_faStackOverflow__ = __webpack_require__("./node_modules/@fortawesome/free-brands-svg-icons/faStackOverflow.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_brands_svg_icons_faStackOverflow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_free_brands_svg_icons_faStackOverflow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_regular_svg_icons_faTimesCircle__ = __webpack_require__("./node_modules/@fortawesome/free-regular-svg-icons/faTimesCircle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_regular_svg_icons_faTimesCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_regular_svg_icons_faTimesCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons_faBan__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faBan.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons_faBan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons_faBan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons_faBell__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faBell.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons_faBell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons_faBell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_solid_svg_icons_faBellSlash__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faBellSlash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_solid_svg_icons_faBellSlash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fortawesome_free_solid_svg_icons_faBellSlash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons_faBook__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faBook.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons_faBook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons_faBook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons_faCheck__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons_faCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons_faCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons_faDownload__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faDownload.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons_faDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons_faDownload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fortawesome_free_solid_svg_icons_faExclamation__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faExclamation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fortawesome_free_solid_svg_icons_faExclamation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__fortawesome_free_solid_svg_icons_faExclamation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons_faExclamationTriangle__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faExclamationTriangle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons_faExclamationTriangle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons_faExclamationTriangle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fortawesome_free_solid_svg_icons_faHeartbeat__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faHeartbeat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fortawesome_free_solid_svg_icons_faHeartbeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__fortawesome_free_solid_svg_icons_faHeartbeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons_faHome__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faHome.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons_faHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons_faHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fortawesome_free_solid_svg_icons_faMinusCircle__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faMinusCircle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fortawesome_free_solid_svg_icons_faMinusCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__fortawesome_free_solid_svg_icons_faMinusCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fortawesome_free_solid_svg_icons_faPencilAlt__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faPencilAlt.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fortawesome_free_solid_svg_icons_faPencilAlt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__fortawesome_free_solid_svg_icons_faPencilAlt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fortawesome_free_solid_svg_icons_faQuestionCircle__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faQuestionCircle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fortawesome_free_solid_svg_icons_faQuestionCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__fortawesome_free_solid_svg_icons_faQuestionCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__fortawesome_free_solid_svg_icons_faSignOutAlt__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faSignOutAlt.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__fortawesome_free_solid_svg_icons_faSignOutAlt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__fortawesome_free_solid_svg_icons_faSignOutAlt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fortawesome_free_solid_svg_icons_faStepBackward__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faStepBackward.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fortawesome_free_solid_svg_icons_faStepBackward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__fortawesome_free_solid_svg_icons_faStepBackward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__fortawesome_free_solid_svg_icons_faStepForward__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faStepForward.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__fortawesome_free_solid_svg_icons_faStepForward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__fortawesome_free_solid_svg_icons_faStepForward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__fortawesome_free_solid_svg_icons_faTimesCircle__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faTimesCircle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__fortawesome_free_solid_svg_icons_faTimesCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__fortawesome_free_solid_svg_icons_faTimesCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__fortawesome_free_solid_svg_icons_faTrash__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faTrash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__fortawesome_free_solid_svg_icons_faTrash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__fortawesome_free_solid_svg_icons_faTrash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__fortawesome_free_solid_svg_icons_faUserCircle__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faUserCircle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__fortawesome_free_solid_svg_icons_faUserCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__fortawesome_free_solid_svg_icons_faUserCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__fortawesome_free_solid_svg_icons_faWrench__ = __webpack_require__("./node_modules/@fortawesome/free-solid-svg-icons/faWrench.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__fortawesome_free_solid_svg_icons_faWrench___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__fortawesome_free_solid_svg_icons_faWrench__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__fortawesome_vue_fontawesome__ = __webpack_require__("./node_modules/@fortawesome/vue-fontawesome/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__fortawesome_vue_fontawesome__);
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




























__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["library"].add(
//solid
__WEBPACK_IMPORTED_MODULE_22__fortawesome_free_solid_svg_icons_faTrash__["faTrash"], __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons_faDownload__["faDownload"], __WEBPACK_IMPORTED_MODULE_20__fortawesome_free_solid_svg_icons_faStepForward__["faStepForward"], __WEBPACK_IMPORTED_MODULE_19__fortawesome_free_solid_svg_icons_faStepBackward__["faStepBackward"], __WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons_faCheck__["faCheck"], __WEBPACK_IMPORTED_MODULE_17__fortawesome_free_solid_svg_icons_faQuestionCircle__["faQuestionCircle"], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons_faBan__["faBan"], __WEBPACK_IMPORTED_MODULE_21__fortawesome_free_solid_svg_icons_faTimesCircle__["faTimesCircle"], __WEBPACK_IMPORTED_MODULE_15__fortawesome_free_solid_svg_icons_faMinusCircle__["faMinusCircle"], __WEBPACK_IMPORTED_MODULE_11__fortawesome_free_solid_svg_icons_faExclamation__["faExclamation"], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons_faBook__["faBook"], __WEBPACK_IMPORTED_MODULE_18__fortawesome_free_solid_svg_icons_faSignOutAlt__["faSignOutAlt"], __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons_faExclamationTriangle__["faExclamationTriangle"], __WEBPACK_IMPORTED_MODULE_16__fortawesome_free_solid_svg_icons_faPencilAlt__["faPencilAlt"], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons_faBell__["faBell"], __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_solid_svg_icons_faBellSlash__["faBellSlash"], __WEBPACK_IMPORTED_MODULE_23__fortawesome_free_solid_svg_icons_faUserCircle__["faUserCircle"], __WEBPACK_IMPORTED_MODULE_13__fortawesome_free_solid_svg_icons_faHeartbeat__["faHeartbeat"], __WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons_faHome__["faHome"], __WEBPACK_IMPORTED_MODULE_24__fortawesome_free_solid_svg_icons_faWrench__["faWrench"],
//regular,
__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_regular_svg_icons_faTimesCircle__["faTimesCircle"],
//brands
__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_brands_svg_icons_faGithub__["faGithub"], __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_brands_svg_icons_faStackOverflow__["faStackOverflow"], __WEBPACK_IMPORTED_MODULE_2__fortawesome_free_brands_svg_icons_faGitter__["faGitter"]);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_25__fortawesome_vue_fontawesome__["FontAwesomeIcon"]);

/***/ }),

/***/ "./src/main/frontend/components/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var components = [];

/* global require */
var context = __webpack_require__("./src/main/frontend/components ^(?:(?!.*\\.spec\\.(js|vue)$).)*\\.(js|vue)$");
context.keys().forEach(function (key) {
  var name = /^(.\/)+(.*)\.(vue|js)$/.exec(key)[2];
  components.push({ name: name, component: context(key).default });
});

/* harmony default export */ __webpack_exports__["default"] = ({
  install: function install(Vue) {
    components.forEach(function (component) {
      return Vue.component(component.name, component.component);
    });
  }
});

/***/ }),

/***/ "./src/main/frontend/components/sba-confirm-button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue-clickaway/dist/vue-clickaway.common.js
var vue_clickaway_common = __webpack_require__("./node_modules/vue-clickaway/dist/vue-clickaway.common.js");
var vue_clickaway_common_default = /*#__PURE__*/__webpack_require__.n(vue_clickaway_common);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/components/sba-confirm-button.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var sba_confirm_button = ({
  directives: { onClickaway: vue_clickaway_common["directive"] },
  data: function data() {
    return {
      confirm: false
    };
  },
  methods: {
    abort: function abort() {
      this.confirm = false;
    },
    click: function click(event) {
      if (this.confirm) {
        this.$el.style.width = null;
        this.$emit('click', event);
      } else {
        var width = this.$el.getBoundingClientRect().width;
        this.$el.style.width = width + 'px';
      }
      this.confirm = !this.confirm;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db9d1b46","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/sba-confirm-button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.abort),expression:"abort"}],staticClass:"confirm-button",class:{ 'is-warning' : _vm.confirm },on:{"click":_vm.click}},[(_vm.confirm)?_vm._t("confirm",[_vm._v("Confirm")]):_vm._t("default")],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/components/sba-confirm-button.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/components/sba-confirm-button.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sba_confirm_button,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_sba_confirm_button = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/components/sba-formatted-obj.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/utils/autolink.js
var autolink = __webpack_require__("./src/main/frontend/utils/autolink.js");

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("./node_modules/lodash/isEmpty.js");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/isObject.js
var isObject = __webpack_require__("./node_modules/lodash/isObject.js");
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);

// CONCATENATED MODULE: ./src/main/frontend/utils/objToString.js

 /*
                                          * Copyright 2014-2018 the original author or authors.
                                          *
                                          * Licensed under the Apache License, Version 2.0 (the "License");
                                          * you may not use this file except in compliance with the License.
                                          * You may obtain a copy of the License at
                                          *
                                          *     http://www.apache.org/licenses/LICENSE-2.0
                                          *
                                          * Unless required by applicable law or agreed to in writing, software
                                          * distributed under the License is distributed on an "AS IS" BASIS,
                                          * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                          * See the License for the specific language governing permissions and
                                          * limitations under the License.
                                          */

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var objToString_nonEmptyComplexValue = function nonEmptyComplexValue(value) {
  return (Array.isArray(value) || isObject_default()(value)) && !isEmpty_default()(value);
};

var objToString_objToString = function objToString(obj) {
  var indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (Array.isArray(obj)) {
    if (isEmpty_default()(obj)) {
      return indent + '[]';
    }

    return obj.map(function (value) {
      if (objToString_nonEmptyComplexValue(value)) {
        return indent + '-\n' + objToString(value, indent + '  ');
      }
      return indent + '- ' + objToString(value, '');
    }).join('\n');
  }

  if (isObject_default()(obj)) {
    if (isEmpty_default()(obj)) {
      return indent + '{}';
    }

    return Object.entries(obj).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      if (objToString_nonEmptyComplexValue(value)) {
        return '' + indent + key + ':\n' + objToString(value, indent + '  ');
      }
      return '' + indent + key + ': ' + objToString(value, '');
    }).join('\n');
  }

  if (obj === null) {
    return indent + 'null';
  }

  if (typeof obj === 'undefined' || obj === '') {
    return '';
  }

  return indent + obj;
};

/* harmony default export */ var utils_objToString = (objToString_objToString);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/components/sba-formatted-obj.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var sba_formatted_obj_autolink = new autolink["a" /* Autolink */]({ truncate: {
    length: 50,
    location: 'smart'
  } });

/* harmony default export */ var sba_formatted_obj = ({
  props: {
    value: {
      type: null,
      required: true
    }
  },
  computed: {
    formatted: function formatted() {
      return sba_formatted_obj_autolink(utils_objToString(this.value));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bafcd518","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/sba-formatted-obj.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"formatted",domProps:{"innerHTML":_vm._s(_vm.formatted)}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/components/sba-formatted-obj.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/components/sba-formatted-obj.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sba_formatted_obj,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_sba_formatted_obj = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/components/sba-icon-button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/components/sba-icon-button.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var sba_icon_button = ({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: [String, Array],
      required: true
    },
    size: {
      type: String,
      default: null
    },
    iconClass: {
      type: String,
      default: null
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f29d9f78","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/sba-icon-button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"icon-button",attrs:{"type":"button","disabled":_vm.disabled}},_vm.$listeners),[_c('font-awesome-icon',{class:_vm.iconClass,attrs:{"icon":_vm.icon,"size":_vm.size}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/components/sba-icon-button.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/components/sba-icon-button.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sba_icon_button,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_sba_icon_button = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/components/sba-panel.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/directives/sticks-below.js
var sticks_below = __webpack_require__("./src/main/frontend/directives/sticks-below.js");

// EXTERNAL MODULE: ./src/main/frontend/components/sba-icon-button.vue + 2 modules
var sba_icon_button = __webpack_require__("./src/main/frontend/components/sba-icon-button.vue");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/components/sba-panel.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var sba_panel = ({
  components: { SbaIconButton: sba_icon_button["default"] },
  directives: { sticksBelow: sticks_below["a" /* default */] },
  props: {
    title: {
      type: String,
      required: true
    },
    closeable: {
      type: Boolean,
      default: false
    },
    headerSticksBelow: {
      type: Array,
      default: undefined
    }
  },
  methods: {
    close: function close(event) {
      this.$emit('close', event);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1b64820","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/sba-panel.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card panel"},[(_vm.title || _vm.$slots['header'])?_c('header',{directives:[{name:"sticks-below",rawName:"v-sticks-below",value:(_vm.headerSticksBelow),expression:"headerSticksBelow"}],staticClass:"card-header",class:{'panel__header--sticky': _vm.headerSticksBelow}},[_c('p',{staticClass:"card-header-title"},[_c('span',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"panel__close"},[(_vm.closeable)?_c('sba-icon-button',{attrs:{"icon":['far', 'times-circle']},on:{"click":function($event){$event.stopPropagation();return _vm.close($event)}}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.$slots['default'])?_c('div',{staticClass:"card-content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/components/sba-panel.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/components/sba-panel.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sba_panel,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_sba_panel = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/components/sba-status.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/components/sba-time-ago.js
var sba_time_ago = __webpack_require__("./src/main/frontend/components/sba-time-ago.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/components/sba-status.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {
  'UP': 'check',
  'RESTRICTED': 'exclamation',
  'OUT_OF_SERVICE': 'ban',
  'DOWN': 'times-circle',
  'OFFLINE': 'minus-circle',
  'UNKNOWN': 'question-circle'
};

/* harmony default export */ var sba_status = ({
  components: {
    sbaTimeAgo: sba_time_ago["default"]
  },
  props: {
    status: {
      type: String,
      default: 'UNKNOWN'
    },
    date: {
      type: null,
      default: null
    }
  },
  computed: {
    icon: function icon() {
      return icons[this.status];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aeaed28","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/sba-status.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application-status"},[_c('font-awesome-icon',{staticClass:"application-status__icon",class:("application-status__icon--" + _vm.status),attrs:{"icon":_vm.icon}}),_vm._v(" "),(_vm.date)?_c('small',[_c('sba-time-ago',{attrs:{"date":_vm.date}})],1):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/components/sba-status.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/components/sba-status.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sba_status,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_sba_status = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/components/sba-tags.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/components/sba-tags.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var sba_tags = ({
  props: {
    tags: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasTags: function hasTags() {
      return Object.keys(this.tags).length > 0;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fc69064","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/sba-tags.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasTags)?_c('div',{staticClass:"field is-grouped is-grouped-multiline"},_vm._l((_vm.tags),function(value,key){return _c('div',{key:key,staticClass:"control"},[_c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag is-dark",domProps:{"textContent":_vm._s(key)}}),_vm._v(" "),_c('span',{staticClass:"tag is-light",domProps:{"textContent":_vm._s(value)}})])])})):_vm._e()}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/components/sba-tags.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sba_tags,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_sba_tags = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/components/sba-time-ago.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_shortformat__ = __webpack_require__("./node_modules/moment-shortformat/moment-shortformat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_shortformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_shortformat__);
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    date: {
      type: null,
      default: null
    }
  },
  data: function data() {
    return {
      now: __WEBPACK_IMPORTED_MODULE_0_moment_shortformat___default()(),
      timer: null
    };
  },
  computed: {
    timeAgo: function timeAgo() {
      return __WEBPACK_IMPORTED_MODULE_0_moment_shortformat___default()(this.date).short(true, this.now);
    }
  },
  created: function created() {
    var _this = this;

    this.timer = window.setInterval(function () {
      _this.now = __WEBPACK_IMPORTED_MODULE_0_moment_shortformat___default()();
    }, 1000);
  },
  render: function render() {
    return this._v(this.timeAgo);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      window.clearInterval(this.timer);
    }
  }
});

/***/ }),

/***/ "./src/main/frontend/directives/sticks-below.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var bind = function bind(el, binding) {
  if (!binding.value) {
    return;
  }
  var top = binding.value.map(function (v) {
    return document.querySelector(v);
  }).filter(function (v) {
    return Boolean(v);
  }).map(function (v) {
    return v.getBoundingClientRect().height;
  }).reduce(function (a, b) {
    return a + b;
  }, 0);
  el.style.top = top + 'px';
  el.style.position = 'sticky';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: bind,
  update: function update(el, binding) {
    if (binding.value === binding.oldValue) {
      return;
    }
    bind(el, binding);
  }
});

/***/ }),

/***/ "./src/main/frontend/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/assets/css/base.scss
var base = __webpack_require__("./src/main/frontend/assets/css/base.scss");
var base_default = /*#__PURE__*/__webpack_require__.n(base);

// EXTERNAL MODULE: ./src/main/frontend/assets/img/icon-spring-boot-admin.svg
var icon_spring_boot_admin = __webpack_require__("./src/main/frontend/assets/img/icon-spring-boot-admin.svg");
var icon_spring_boot_admin_default = /*#__PURE__*/__webpack_require__.n(icon_spring_boot_admin);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("./node_modules/moment/moment.js");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("./node_modules/vue/dist/vue.runtime.esm.js");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("./node_modules/vue-router/dist/vue-router.esm.js");

// EXTERNAL MODULE: ./src/main/frontend/components/index.js
var components = __webpack_require__("./src/main/frontend/components/index.js");

// EXTERNAL MODULE: ./src/main/frontend/assets/img/favicon-danger.png
var favicon_danger = __webpack_require__("./src/main/frontend/assets/img/favicon-danger.png");
var favicon_danger_default = /*#__PURE__*/__webpack_require__.n(favicon_danger);

// EXTERNAL MODULE: ./src/main/frontend/assets/img/favicon.png
var favicon = __webpack_require__("./src/main/frontend/assets/img/favicon.png");
var favicon_default = /*#__PURE__*/__webpack_require__.n(favicon);

// CONCATENATED MODULE: ./src/main/frontend/notifications.js
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var granted = false;

var requestPermissions = function requestPermissions() {
  if ('Notification' in window) {
    granted = window.Notification.permission === 'granted';
    if (!granted && window.Notification.permission !== 'denied') {
      window.Notification.requestPermission(function (permission) {
        return granted = permission === 'granted';
      });
    }
  }
};

var notify = function notify(title, options) {
  if (granted) {
    var note = new window.Notification(title, options);
    if (options.url !== null) {
      note.onclick = function () {
        window.focus();
        window.open(options.url, '_self');
      };
    }
    if (options.timeout > 0) {
      note.onshow = function () {
        return setTimeout(function () {
          return note.close();
        }, options.timeout);
      };
    }
  }
};

/* harmony default export */ var notifications = ({
  install: function install(_ref) {
    var applicationStore = _ref.applicationStore;

    requestPermissions();

    applicationStore.addEventListener('updated', function (newVal, oldVal) {
      if (newVal.status !== oldVal.status) {
        notify(newVal.name + ' is now ' + newVal.status, {
          tag: newVal.name + '-' + newVal.status,
          lang: 'en',
          body: 'was ' + oldVal.status + '.',
          icon: newVal.status === 'UP' ? favicon_default.a : favicon_danger_default.a,
          renotify: true,
          timeout: 10000
        });
      }
    });
  }
});
// EXTERNAL MODULE: ./src/main/frontend/utils/collections.js
var collections = __webpack_require__("./src/main/frontend/utils/collections.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/shell/navbar.vue
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var readCookie = function readCookie(name) {
  var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
  return match ? decodeURIComponent(match[3]) : null;
};

/* harmony default export */ var navbar = ({
  data: function data() {
    return {
      showMenu: false,
      brand: '<img src="assets/img/icon-spring-boot-admin.svg"><span>Spring Boot Admin</span>',
      userName: null,
      csrfToken: null,
      csrfParameterName: null
    };
  },
  props: {
    views: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    applications: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: null,
      default: null
    }
  },
  computed: {
    enabledViews: function enabledViews() {
      return [].concat(_toConsumableArray(this.views)).filter(function (view) {
        return view.handle && (typeof view.isEnabled === 'undefined' || view.isEnabled());
      }).sort(Object(collections["a" /* compareBy */])(function (v) {
        return v.order;
      }));
    }
  },
  created: function created() {
    /* global SBA */
    if (SBA) {
      if (SBA.uiSettings) {
        this.brand = SBA.uiSettings.brand || this.brand;
      }

      if (SBA.user) {
        this.userName = SBA.user.name;
      }
    }
    this.csrfToken = readCookie('XSRF-TOKEN');
    /* global SBA */
    this.csrfParameterName = SBA && SBA.csrf && SBA.csrf.parameterName || '_csrf';
  },
  mounted: function mounted() {
    document.documentElement.classList.add('has-navbar-fixed-top');
  },
  beforeDestroy: function beforeDestroy() {
    document.documentElement.classList.remove('has-navbar-fixed-top');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cdf225a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/shell/navbar.vue
var navbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar is-fixed-top",attrs:{"id":"navigation"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-brand"},[_c('router-link',{staticClass:"navbar-item logo",attrs:{"to":"/"},domProps:{"innerHTML":_vm._s(_vm.brand)}}),_vm._v(" "),_c('div',{staticClass:"navbar-burger burger",on:{"click":function($event){$event.stopPropagation();_vm.showMenu = !_vm.showMenu}}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])],1),_vm._v(" "),_c('div',{staticClass:"navbar-menu",class:{'is-active' : _vm.showMenu}},[_c('div',{staticClass:"navbar-end"},[_vm._l((_vm.enabledViews),function(view){return _c('router-link',{key:view.name,staticClass:"navbar-item",attrs:{"to":{name: view.name}}},[_c(view.handle,{tag:"component",attrs:{"applications":_vm.applications,"error":_vm.error}})],1)}),_vm._v(" "),(_vm.userName)?_c('div',{staticClass:"navbar-item has-dropdown is-hoverable"},[_c('a',{staticClass:"navbar-link"},[_c('font-awesome-icon',{attrs:{"icon":"user-circle","size":"lg"}}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.userName)}})],1),_vm._v(" "),_c('div',{staticClass:"navbar-dropdown"},[_c('a',{staticClass:"navbar-item"},[_c('form',{attrs:{"action":"logout","method":"post"}},[(_vm.csrfToken)?_c('input',{attrs:{"type":"hidden","name":_vm.csrfParameterName},domProps:{"value":_vm.csrfToken}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button is-icon",attrs:{"type":"submit","value":"logout"}},[_c('font-awesome-icon',{attrs:{"icon":"sign-out-alt"}}),_vm._v(" Log out\n                ")],1)])])])]):_vm._e()],2)])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/shell/navbar.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/shell/navbar.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  navbar,
  navbar_render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var shell_navbar = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/shell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var shell = ({
  props: {
    views: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    applications: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: null,
      default: null
    }
  },
  components: { sbaNavbar: shell_navbar },
  computed: {
    mainViews: function mainViews() {
      return this.views.filter(function (view) {
        return !view.parent;
      });
    },
    activeMainViewName: function activeMainViewName() {
      var currentView = this.$route.meta.view;
      return currentView && (currentView.parent || currentView.name);
    },
    childViews: function childViews() {
      var _this = this;

      return this.views.filter(function (view) {
        return view.parent === _this.activeMainViewName;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0937cd2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/shell/index.vue
var shell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('sba-navbar',{attrs:{"views":_vm.mainViews,"applications":_vm.applications,"error":_vm.error}}),_vm._v(" "),_c('router-view',{attrs:{"views":_vm.childViews,"applications":_vm.applications,"error":_vm.error}})],1)}
var shell_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/shell/index.vue
/* script */


/* template */

/* template functional */
var shell___vue_template_functional__ = false
/* styles */
var shell___vue_styles__ = null
/* scopeId */
var shell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var shell___vue_module_identifier__ = null

var shell_Component = Object(component_normalizer["a" /* default */])(
  shell,
  shell_render,
  shell_staticRenderFns,
  shell___vue_template_functional__,
  shell___vue_styles__,
  shell___vue_scopeId__,
  shell___vue_module_identifier__
)

/* harmony default export */ var frontend_shell = (shell_Component.exports);

// EXTERNAL MODULE: ./src/main/frontend/services/application.js
var application = __webpack_require__("./src/main/frontend/services/application.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/rxjs.js
var rxjs = __webpack_require__("./src/main/frontend/utils/rxjs.js");

// CONCATENATED MODULE: ./src/main/frontend/store.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var store__class = function () {
  function _class() {
    var _this = this;

    _classCallCheck(this, _class);

    this.applications = [];
    this.applications.findInstance = function (instanceId) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _this.applications[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var application = _step.value;

          var instance = application.findInstance(instanceId);
          if (instance) {
            return instance;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return undefined;
    };
    this.applications.findApplicationForInstance = function (instanceId) {
      return _this.applications.find(function (application) {
        return !!application.findInstance(instanceId);
      });
    };
    this.applications.indexOfApplication = function (name) {
      return _this.applications.findIndex(function (application) {
        return application.name === name;
      });
    };

    this._listeners = {
      added: [],
      updated: [],
      removed: []
    };
  }

  _createClass(_class, [{
    key: 'addEventListener',
    value: function addEventListener(type, listener) {
      if (!(type in this._listeners)) {
        this._listeners[type] = [];
      }
      this._listeners[type].push(listener);
    }
  }, {
    key: 'removeEventListener',
    value: function removeEventListener(type, listener) {
      if (!(type in this._listeners)) {
        return;
      }

      var idx = this._listeners[type].indexOf(listener);
      if (idx > 0) {
        this._listeners[type].splice(idx, 1);
      }
    }
  }, {
    key: '_dispatchEvent',
    value: function _dispatchEvent(type) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (!(type in this._listeners)) {
        return;
      }
      var target = this;
      this._listeners[type].forEach(function (listener) {
        return listener.call.apply(listener, [target].concat(args));
      });
    }
  }, {
    key: 'start',
    value: function start() {
      var _this2 = this;

      var list = Object(rxjs["i" /* defer */])(function () {
        return application["a" /* default */].list();
      }).pipe(Object(rxjs["g" /* concatMap */])(function (message) {
        return message.data;
      }));
      var stream = application["a" /* default */].getStream().pipe(Object(rxjs["p" /* map */])(function (message) {
        return message.data;
      }));
      this.subscription = Object(rxjs["e" /* concat */])(list, stream).pipe(Object(rxjs["k" /* doFirst */])(function () {
        return _this2._dispatchEvent('connected');
      }), Object(rxjs["s" /* retryWhen */])(function (errors) {
        return errors.pipe(Object(rxjs["t" /* tap */])(function (error) {
          return _this2._dispatchEvent('error', error);
        }), Object(rxjs["j" /* delay */])(5000));
      })).subscribe({
        next: function next(application) {
          var idx = _this2.applications.indexOfApplication(application.name);
          if (idx >= 0) {
            var oldApplication = _this2.applications[idx];
            if (application.instances.length > 0) {
              _this2.applications.splice(idx, 1, application);
              _this2._dispatchEvent('updated', application, oldApplication);
            } else {
              _this2.applications.splice(idx, 1);
              _this2._dispatchEvent('removed', oldApplication);
            }
          } else {
            _this2.applications.push(application);
            _this2._dispatchEvent('added', application);
          }
        }
      });
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this.subscription) {
        try {
          !this.subscription.closed && this.subscription.unsubscribe();
        } finally {
          this.subscription = null;
        }
      }
    }
  }]);

  return _class;
}();

/* harmony default export */ var store = (store__class);
// CONCATENATED MODULE: ./src/main/frontend/viewRegistry.js
var viewRegistry__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function viewRegistry__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function viewRegistry__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var createTextVNode = function createTextVNode(label) {
  return {
    render: function render() {
      return this._v(label);
    }
  };
};

var ViewRegistry = function () {
  function ViewRegistry() {
    viewRegistry__classCallCheck(this, ViewRegistry);

    this._views = [];
    this._redirects = [];
  }

  viewRegistry__createClass(ViewRegistry, [{
    key: "addView",
    value: function addView() {
      var _this = this;

      for (var _len = arguments.length, views = Array(_len), _key = 0; _key < _len; _key++) {
        views[_key] = arguments[_key];
      }

      views.forEach(function (view) {
        return _this._addView(view);
      });
    }
  }, {
    key: "addRedirect",
    value: function addRedirect(path, redirectToView) {
      this._redirects.push({ path: path, redirect: { name: redirectToView } });
    }
  }, {
    key: "_addView",
    value: function _addView(view) {
      if (view.label && !view.handle) {
        view.handle = createTextVNode(view.label);
      }
      this._views.push(view);
    }
  }, {
    key: "_toRoutes",
    value: function _toRoutes(views, filter) {
      var _this2 = this;

      return views.filter(filter).map(function (p) {
        var children = _this2._toRoutes(views, function (v) {
          return v.parent === p.name;
        });
        return {
          path: p.path,
          name: children.length === 0 ? p.name : undefined,
          component: p.component,
          props: p.props,
          meta: { view: p },
          children: children
        };
      });
    }
  }, {
    key: "views",
    get: function get() {
      return this._views;
    }
  }, {
    key: "routes",
    get: function get() {
      return [].concat(viewRegistry__toConsumableArray(this._toRoutes(this._views, function (v) {
        return !v.parent;
      })), viewRegistry__toConsumableArray(this._redirects));
    }
  }]);

  return ViewRegistry;
}();

/* harmony default export */ var viewRegistry = (ViewRegistry);
// CONCATENATED MODULE: ./src/main/frontend/views/index.js
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var views = [];

/* global require */
var context = __webpack_require__("./src/main/frontend/views recursive ^\\.\\/.+\\/index\\.(js|vue)$");
context.keys().forEach(function (key) {
  var defaultExport = context(key).default;
  if (defaultExport && defaultExport.install) {
    views.push(defaultExport);
  }
});

/* harmony default export */ var frontend_views = (views);
// CONCATENATED MODULE: ./src/main/frontend/index.js
function frontend__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */













moment_default.a.locale(window.navigator.language);
vue_runtime_esm["default"].use(vue_router_esm["a" /* default */]);
vue_runtime_esm["default"].use(components["default"]);

var frontend_applicationStore = new store();
var frontend_viewRegistry = new viewRegistry();

var installables = [notifications].concat(frontend__toConsumableArray(frontend_views), frontend__toConsumableArray(SBA.extensions));

installables.forEach(function (view) {
  return view.install({
    viewRegistry: frontend_viewRegistry,
    applicationStore: frontend_applicationStore,
    vue: vue_runtime_esm["default"]
  });
});

new vue_runtime_esm["default"]({
  router: new vue_router_esm["a" /* default */]({
    linkActiveClass: 'is-active',
    routes: frontend_viewRegistry.routes
  }),
  el: '#app',
  render: function render(h) {
    return h(frontend_shell, {
      props: {
        views: this.views,
        applications: this.applications,
        error: this.error
      }
    });
  },

  data: {
    views: frontend_viewRegistry.views,
    applications: frontend_applicationStore.applications,
    error: null
  },
  methods: {
    onError: function onError(error) {
      console.warn('Connection to server failed:', error);
      this.error = error;
    },
    onConnected: function onConnected() {
      this.error = null;
    }
  },
  created: function created() {
    frontend_applicationStore.addEventListener('connected', this.onConnected);
    frontend_applicationStore.addEventListener('error', this.onError);
    frontend_applicationStore.start();
  },
  beforeDestroy: function beforeDestroy() {
    frontend_applicationStore.stop();
    frontend_applicationStore.removeEventListener('connected', this.onConnected);
    frontend_applicationStore.removeEventListener('error', this.onError);
  }
});

/***/ }),

/***/ "./src/main/frontend/mixins/subscribing.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.subscribe();
  },
  beforeDestroy: function beforeDestroy() {
    this.unsubscribe();
  },

  methods: {
    subscribe: function subscribe() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.subscription) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return _this.createSubscription();

              case 3:
                _this.subscription = _context.sent;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    unsubscribe: function unsubscribe() {
      if (this.subscription) {
        try {
          !this.subscription.closed && this.subscription.unsubscribe();
        } finally {
          this.subscription = null;
        }
      }
    }
  }
});

/***/ }),

/***/ "./src/main/frontend/services/application.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__("./node_modules/lodash/sortBy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_axios__ = __webpack_require__("./src/main/frontend/utils/axios.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_eventsource_polyfill__ = __webpack_require__("./src/main/frontend/utils/eventsource-polyfill.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_rxjs__ = __webpack_require__("./src/main/frontend/utils/rxjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_uri__ = __webpack_require__("./src/main/frontend/utils/uri.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__instance__ = __webpack_require__("./src/main/frontend/services/instance.js");


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['applications/', '/'], ['applications/', '/']);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var Application = function () {
  function Application(name) {
    _classCallCheck(this, Application);

    this.name = name;
    this.axios = __WEBPACK_IMPORTED_MODULE_1__utils_axios__["a" /* default */].create({
      baseURL: Object(__WEBPACK_IMPORTED_MODULE_4__utils_uri__["a" /* default */])(_templateObject, this.name)
    });
    this.axios.interceptors.response.use(function (response) {
      return response;
    }, Object(__WEBPACK_IMPORTED_MODULE_1__utils_axios__["b" /* redirectOn401 */])());
  }

  _createClass(Application, [{
    key: 'findInstance',
    value: function findInstance(instanceId) {
      return this.instances.find(function (instance) {
        return instance.id === instanceId;
      });
    }
  }, {
    key: 'unregister',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.axios.delete(''));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function unregister() {
        return _ref.apply(this, arguments);
      }

      return unregister;
    }()
  }, {
    key: 'isUnregisterable',
    get: function get() {
      return this.instances.findIndex(function (i) {
        return i.isUnregisterable;
      }) >= 0;
    }
  }], [{
    key: 'list',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_1__utils_axios__["a" /* default */].get('applications', {
                  transformResponse: Application._transformResponse
                });

              case 2:
                return _context2.abrupt('return', _context2.sent);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function list() {
        return _ref2.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'getStream',
    value: function getStream() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils_rxjs__["e" /* concat */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_rxjs__["m" /* from */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_eventsource_polyfill__["a" /* default */])()).pipe(Object(__WEBPACK_IMPORTED_MODULE_3__utils_rxjs__["n" /* ignoreElements */])()), __WEBPACK_IMPORTED_MODULE_3__utils_rxjs__["b" /* Observable */].create(function (observer) {
        var eventSource = new EventSource('applications');
        eventSource.onmessage = function (message) {
          return observer.next(_extends({}, message, {
            data: Application._transformResponse(message.data)
          }));
        };

        eventSource.onerror = function (err) {
          return observer.error(err);
        };
        return function () {
          eventSource.close();
        };
      }));
    }
  }, {
    key: '_transformResponse',
    value: function _transformResponse(data) {
      if (!data) {
        return data;
      }
      var json = JSON.parse(data);
      if (json instanceof Array) {
        var applications = json.map(Application._toApplication);
        return __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(applications, [function (item) {
          return item.name;
        }]);
      }
      return Application._toApplication(json);
    }
  }, {
    key: '_toApplication',
    value: function _toApplication(application) {
      var instances = application.instances.map(function (instance) {
        return Object.assign(new __WEBPACK_IMPORTED_MODULE_5__instance__["a" /* default */](instance.id), instance);
      });
      return Object.assign(new Application(application.name), _extends({}, application, {
        instances: __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(instances, [function (instance) {
          return instance.registration.healthUrl;
        }])
      }));
    }
  }]);

  return Application;
}();

/* harmony default export */ __webpack_exports__["a"] = (Application);

/***/ }),

/***/ "./src/main/frontend/services/instance.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash/transform.js
var transform = __webpack_require__("./node_modules/lodash/transform.js");
var transform_default = /*#__PURE__*/__webpack_require__.n(transform);

// EXTERNAL MODULE: ./node_modules/lodash/entries.js
var entries = __webpack_require__("./node_modules/lodash/entries.js");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./src/main/frontend/utils/axios.js
var axios = __webpack_require__("./src/main/frontend/utils/axios.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/eventsource-polyfill.js
var eventsource_polyfill = __webpack_require__("./src/main/frontend/utils/eventsource-polyfill.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/rxjs.js
var rxjs = __webpack_require__("./src/main/frontend/utils/rxjs.js");

// CONCATENATED MODULE: ./src/main/frontend/utils/logtail.js
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ var logtail = (function (getFn, interval) {
  var initialSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300 * 1024;

  var range = 'bytes=-' + initialSize;
  var size = 0;

  return Object(rxjs["u" /* timer */])(0, interval).pipe(Object(rxjs["g" /* concatMap */])(function () {
    return getFn({ headers: { range: range, 'Accept': 'text/plain, */*' } });
  }), Object(rxjs["g" /* concatMap */])(function (response) {
    var initial = size === 0;
    var contentLength = response.data.length;
    if (response.status === 200) {
      if (!initial) {
        throw 'Expected 206 - Partial Content on subsequent requests.';
      }
      size = contentLength;
    } else if (response.status === 206) {
      size = parseInt(response.headers['content-range'].split('/')[1]);
    } else {
      throw 'Unexpected response status: ' + response.status;
    }

    // Reload the last byte to avoid a 416: Range unsatisfiable.
    // If the response has length = 1 the file hasn't beent changed.
    // If the response status is 416 the logfile has been truncated.
    range = 'bytes=' + (size - 1) + '-';

    var addendum = null;
    var skipped = 0;

    if (initial) {
      if (contentLength >= size) {
        addendum = response.data;
      } else {
        // In case of a partial response find the first line break.
        addendum = response.data.substring(response.data.indexOf('\n') + 1);
        skipped = size - addendum.length;
      }
    } else if (response.data.length > 1) {
      // Remove the first byte which has been part of the previos response.
      addendum = response.data.substring(1);
    }

    return addendum ? Object(rxjs["r" /* of */])({
      totalBytes: size,
      skipped: skipped,
      addendum: addendum
    }) : rxjs["a" /* EMPTY */];
  }));
});
// EXTERNAL MODULE: ./src/main/frontend/utils/uri.js
var uri = __webpack_require__("./src/main/frontend/utils/uri.js");

// CONCATENATED MODULE: ./src/main/frontend/services/instance.js



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['instances/', '/'], ['instances/', '/']),
    _templateObject2 = _taggedTemplateLiteral(['actuator/info'], ['actuator/info']),
    _templateObject3 = _taggedTemplateLiteral(['actuator/metrics'], ['actuator/metrics']),
    _templateObject4 = _taggedTemplateLiteral(['actuator/metrics/', ''], ['actuator/metrics/', '']),
    _templateObject5 = _taggedTemplateLiteral(['actuator/health'], ['actuator/health']),
    _templateObject6 = _taggedTemplateLiteral(['actuator/env/', ''], ['actuator/env/', '']),
    _templateObject7 = _taggedTemplateLiteral(['actuator/configprops'], ['actuator/configprops']),
    _templateObject8 = _taggedTemplateLiteral(['actuator/env'], ['actuator/env']),
    _templateObject9 = _taggedTemplateLiteral(['actuator/refresh'], ['actuator/refresh']),
    _templateObject10 = _taggedTemplateLiteral(['actuator/liquibase'], ['actuator/liquibase']),
    _templateObject11 = _taggedTemplateLiteral(['actuator/scheduledtasks'], ['actuator/scheduledtasks']),
    _templateObject12 = _taggedTemplateLiteral(['actuator/flyway'], ['actuator/flyway']),
    _templateObject13 = _taggedTemplateLiteral(['actuator/loggers'], ['actuator/loggers']),
    _templateObject14 = _taggedTemplateLiteral(['actuator/loggers/', ''], ['actuator/loggers/', '']),
    _templateObject15 = _taggedTemplateLiteral(['actuator/httptrace'], ['actuator/httptrace']),
    _templateObject16 = _taggedTemplateLiteral(['actuator/threaddump'], ['actuator/threaddump']),
    _templateObject17 = _taggedTemplateLiteral(['actuator/auditevents'], ['actuator/auditevents']),
    _templateObject18 = _taggedTemplateLiteral(['actuator/sessions'], ['actuator/sessions']),
    _templateObject19 = _taggedTemplateLiteral(['actuator/sessions/', ''], ['actuator/sessions/', '']),
    _templateObject20 = _taggedTemplateLiteral(['actuator/logfile'], ['actuator/logfile']),
    _templateObject21 = _taggedTemplateLiteral(['actuator/jolokia/list'], ['actuator/jolokia/list']),
    _templateObject22 = _taggedTemplateLiteral(['actuator/jolokia'], ['actuator/jolokia']),
    _templateObject23 = _taggedTemplateLiteral(['actuator/mappings'], ['actuator/mappings']),
    _templateObject24 = _taggedTemplateLiteral(['instances/', ''], ['instances/', '']);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var actuatorMimeTypes = ['application/vnd.spring-boot.actuator.v2+json', 'application/vnd.spring-boot.actuator.v1+json', 'application/json'];

var isInstanceActuatorRequest = function isInstanceActuatorRequest(url) {
  return url.match(/^instances[/][^/]+[/]actuator([/].*)?$/);
};

var instance_Instance = function () {
  function Instance(id) {
    _classCallCheck(this, Instance);

    this.id = id;
    this.axios = axios["a" /* default */].create({
      baseURL: Object(uri["a" /* default */])(_templateObject, this.id)
    });
    this.axios.interceptors.response.use(function (response) {
      return response;
    }, Object(axios["b" /* redirectOn401 */])(function (error) {
      return !isInstanceActuatorRequest(error.config.url);
    }));
  }

  _createClass(Instance, [{
    key: 'hasEndpoint',
    value: function hasEndpoint(endpointId) {
      return this.endpoints.findIndex(function (endpoint) {
        return endpoint.id === endpointId;
      }) >= 0;
    }
  }, {
    key: 'unregister',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.axios.delete(''));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function unregister() {
        return _ref.apply(this, arguments);
      }

      return unregister;
    }()
  }, {
    key: 'fetchInfo',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject2), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchInfo() {
        return _ref2.apply(this, arguments);
      }

      return fetchInfo;
    }()
  }, {
    key: 'fetchMetrics',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject3), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchMetrics() {
        return _ref3.apply(this, arguments);
      }

      return fetchMetrics;
    }()
  }, {
    key: 'fetchMetric',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(metric, tags) {
        var params;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = tags ? {
                  tag: entries_default()(tags).filter(function (_ref5) {
                    var _ref6 = _slicedToArray(_ref5, 2),
                        value = _ref6[1];

                    return typeof value !== 'undefined' && value !== null;
                  }).map(function (_ref7) {
                    var _ref8 = _slicedToArray(_ref7, 2),
                        name = _ref8[0],
                        value = _ref8[1];

                    return name + ':' + value;
                  }).join(',')
                } : {};
                return _context4.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject4, metric), {
                  headers: { 'Accept': actuatorMimeTypes },
                  params: params
                }));

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchMetric(_x, _x2) {
        return _ref4.apply(this, arguments);
      }

      return fetchMetric;
    }()
  }, {
    key: 'fetchHealth',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.axios.get(Object(uri["a" /* default */])(_templateObject5), {
                  headers: { 'Accept': actuatorMimeTypes }
                });

              case 2:
                return _context5.abrupt('return', _context5.sent);

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchHealth() {
        return _ref9.apply(this, arguments);
      }

      return fetchHealth;
    }()
  }, {
    key: 'fetchEnv',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(name) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject6, name || ''), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetchEnv(_x3) {
        return _ref10.apply(this, arguments);
      }

      return fetchEnv;
    }()
  }, {
    key: 'fetchConfigprops',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject7), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function fetchConfigprops() {
        return _ref11.apply(this, arguments);
      }

      return fetchConfigprops;
    }()
  }, {
    key: 'hasEnvManagerSupport',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.axios.options(Object(uri["a" /* default */])(_templateObject8));

              case 2:
                response = _context8.sent;
                return _context8.abrupt('return', response.headers['allow'] && response.headers['allow'].includes('POST'));

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function hasEnvManagerSupport() {
        return _ref12.apply(this, arguments);
      }

      return hasEnvManagerSupport;
    }()
  }, {
    key: 'resetEnv',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt('return', this.axios.delete(Object(uri["a" /* default */])(_templateObject8)));

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function resetEnv() {
        return _ref13.apply(this, arguments);
      }

      return resetEnv;
    }()
  }, {
    key: 'setEnv',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(name, value) {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt('return', this.axios.post(Object(uri["a" /* default */])(_templateObject8), { name: name, value: value }, {
                  headers: { 'Content-Type': 'application/json' }
                }));

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function setEnv(_x4, _x5) {
        return _ref14.apply(this, arguments);
      }

      return setEnv;
    }()
  }, {
    key: 'refreshContext',
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt('return', this.axios.post(Object(uri["a" /* default */])(_templateObject9)));

              case 1:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function refreshContext() {
        return _ref15.apply(this, arguments);
      }

      return refreshContext;
    }()
  }, {
    key: 'fetchLiquibase',
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject10), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function fetchLiquibase() {
        return _ref16.apply(this, arguments);
      }

      return fetchLiquibase;
    }()
  }, {
    key: 'fetchScheduledTasks',
    value: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject11), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function fetchScheduledTasks() {
        return _ref17.apply(this, arguments);
      }

      return fetchScheduledTasks;
    }()
  }, {
    key: 'fetchFlyway',
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject12), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function fetchFlyway() {
        return _ref18.apply(this, arguments);
      }

      return fetchFlyway;
    }()
  }, {
    key: 'fetchLoggers',
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject13), {
                  headers: { 'Accept': actuatorMimeTypes },
                  transformResponse: Instance._toLoggers
                }));

              case 1:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function fetchLoggers() {
        return _ref19.apply(this, arguments);
      }

      return fetchLoggers;
    }()
  }, {
    key: 'configureLogger',
    value: function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(name, level) {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt('return', this.axios.post(Object(uri["a" /* default */])(_templateObject14, name), { configuredLevel: level }, {
                  headers: { 'Content-Type': 'application/json' }
                }));

              case 1:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function configureLogger(_x6, _x7) {
        return _ref20.apply(this, arguments);
      }

      return configureLogger;
    }()
  }, {
    key: 'fetchHttptrace',
    value: function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject15), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function fetchHttptrace() {
        return _ref21.apply(this, arguments);
      }

      return fetchHttptrace;
    }()
  }, {
    key: 'fetchThreaddump',
    value: function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject16), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function fetchThreaddump() {
        return _ref22.apply(this, arguments);
      }

      return fetchThreaddump;
    }()
  }, {
    key: 'fetchAuditevents',
    value: function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(_ref24) {
        var after = _ref24.after,
            type = _ref24.type,
            principal = _ref24.principal;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject17), {
                  headers: { 'Accept': actuatorMimeTypes },
                  params: {
                    after: after.toISOString(),
                    type: type || undefined,
                    principal: principal || undefined
                  }
                }));

              case 1:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function fetchAuditevents(_x8) {
        return _ref23.apply(this, arguments);
      }

      return fetchAuditevents;
    }()
  }, {
    key: 'fetchSessionsByUsername',
    value: function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(username) {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject18), {
                  headers: { 'Accept': actuatorMimeTypes },
                  params: {
                    username: username || undefined
                  }
                }));

              case 1:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function fetchSessionsByUsername(_x9) {
        return _ref25.apply(this, arguments);
      }

      return fetchSessionsByUsername;
    }()
  }, {
    key: 'fetchSession',
    value: function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(sessionId) {
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject19, sessionId), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function fetchSession(_x10) {
        return _ref26.apply(this, arguments);
      }

      return fetchSession;
    }()
  }, {
    key: 'deleteSession',
    value: function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(sessionId) {
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt('return', this.axios.delete(Object(uri["a" /* default */])(_templateObject19, sessionId), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function deleteSession(_x11) {
        return _ref27.apply(this, arguments);
      }

      return deleteSession;
    }()
  }, {
    key: 'streamLogfile',
    value: function streamLogfile(interval) {
      var _this = this;

      return logtail(function (opt) {
        return _this.axios.get(Object(uri["a" /* default */])(_templateObject20), opt);
      }, interval);
    }
  }, {
    key: 'listMBeans',
    value: function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject21), {
                  headers: { 'Accept': 'application/json' },
                  params: { canonicalNaming: false },
                  transformResponse: Instance._toMBeans
                }));

              case 1:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function listMBeans() {
        return _ref28.apply(this, arguments);
      }

      return listMBeans;
    }()
  }, {
    key: 'readMBeanAttributes',
    value: function () {
      var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(domain, mBean) {
        var body;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                body = {
                  type: 'read',
                  mbean: domain + ':' + mBean,
                  config: { ignoreErrors: true }
                };
                return _context24.abrupt('return', this.axios.post(Object(uri["a" /* default */])(_templateObject22), body, {
                  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
                }));

              case 2:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function readMBeanAttributes(_x12, _x13) {
        return _ref29.apply(this, arguments);
      }

      return readMBeanAttributes;
    }()
  }, {
    key: 'writeMBeanAttribute',
    value: function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(domain, mBean, attribute, value) {
        var body;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                body = {
                  type: 'write',
                  mbean: domain + ':' + mBean,
                  attribute: attribute,
                  value: value
                };
                return _context25.abrupt('return', this.axios.post(Object(uri["a" /* default */])(_templateObject22), body, {
                  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
                }));

              case 2:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function writeMBeanAttribute(_x14, _x15, _x16, _x17) {
        return _ref30.apply(this, arguments);
      }

      return writeMBeanAttribute;
    }()
  }, {
    key: 'invokeMBeanOperation',
    value: function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(domain, mBean, operation, args) {
        var body;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                body = {
                  type: 'exec',
                  mbean: domain + ':' + mBean,
                  operation: operation,
                  'arguments': args
                };
                return _context26.abrupt('return', this.axios.post(Object(uri["a" /* default */])(_templateObject22), body, {
                  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
                }));

              case 2:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function invokeMBeanOperation(_x18, _x19, _x20, _x21) {
        return _ref31.apply(this, arguments);
      }

      return invokeMBeanOperation;
    }()
  }, {
    key: 'fetchMappings',
    value: function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt('return', this.axios.get(Object(uri["a" /* default */])(_templateObject23), {
                  headers: { 'Accept': actuatorMimeTypes }
                }));

              case 1:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function fetchMappings() {
        return _ref32.apply(this, arguments);
      }

      return fetchMappings;
    }()
  }, {
    key: 'isUnregisterable',
    get: function get() {
      return this.registration.source === 'http-api';
    }
  }], [{
    key: 'fetchEvents',
    value: function () {
      var _ref33 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt('return', axios["a" /* default */].get('instances/events'));

              case 1:
              case 'end':
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function fetchEvents() {
        return _ref33.apply(this, arguments);
      }

      return fetchEvents;
    }()
  }, {
    key: 'getEventStream',
    value: function getEventStream() {
      return Object(rxjs["e" /* concat */])(Object(rxjs["m" /* from */])(Object(eventsource_polyfill["a" /* default */])()).pipe(Object(rxjs["n" /* ignoreElements */])()), rxjs["b" /* Observable */].create(function (observer) {
        var eventSource = new EventSource('instances/events');
        eventSource.onmessage = function (message) {
          return observer.next(_extends({}, message, {
            data: JSON.parse(message.data)
          }));
        };
        eventSource.onerror = function (err) {
          return observer.error(err);
        };
        return function () {
          eventSource.close();
        };
      }));
    }
  }, {
    key: 'get',
    value: function () {
      var _ref34 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(id) {
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt('return', axios["a" /* default */].get(Object(uri["a" /* default */])(_templateObject24, id), {
                  transformResponse: Instance._toInstance
                }));

              case 1:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function get(_x22) {
        return _ref34.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: '_toInstance',
    value: function _toInstance(data) {
      if (!data) {
        return data;
      }
      var instance = JSON.parse(data);
      return Object.assign(new Instance(instance.id), instance);
    }
  }, {
    key: '_toLoggers',
    value: function _toLoggers(data) {
      if (!data) {
        return data;
      }
      var raw = JSON.parse(data);
      var loggers = transform_default()(raw.loggers, function (result, value, key) {
        return result.push(_extends({ name: key }, value));
      }, []);
      return { levels: raw.levels, loggers: loggers };
    }
  }, {
    key: '_toMBeans',
    value: function _toMBeans(data) {
      if (!data) {
        return data;
      }
      var raw = JSON.parse(data);
      return entries_default()(raw.value).map(function (_ref35) {
        var _ref36 = _slicedToArray(_ref35, 2),
            domain = _ref36[0],
            mBeans = _ref36[1];

        return {
          domain: domain,
          mBeans: entries_default()(mBeans).map(function (_ref37) {
            var _ref38 = _slicedToArray(_ref37, 2),
                descriptor = _ref38[0],
                mBean = _ref38[1];

            return _extends({
              descriptor: descriptor
            }, mBean);
          })
        };
      });
    }
  }]);

  return Instance;
}();

/* harmony default export */ var instance = __webpack_exports__["a"] = (instance_Instance);

/***/ }),

/***/ "./src/main/frontend/utils/autolink.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaults */
/* harmony export (immutable) */ __webpack_exports__["a"] = Autolink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autolinker__ = __webpack_require__("./node_modules/autolinker/dist/Autolinker.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autolinker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_autolinker__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var defaults = {
  urls: {
    schemeMatches: true,
    wwwMatches: false,
    tldMatches: false
  },
  email: false,
  phone: false,
  mention: false,
  hashtag: false,

  stripPrefix: false,
  stripTrailingSlash: false,
  newWindow: true,

  truncate: {
    length: 0,
    location: 'smart'
  },

  className: ''
};
var autolinker = new __WEBPACK_IMPORTED_MODULE_0_autolinker___default.a(defaults);

/* harmony default export */ __webpack_exports__["b"] = (function (s) {
  return autolinker.link(s);
});
function Autolink(cfg) {
  var _this = this;

  this.autolinker = new __WEBPACK_IMPORTED_MODULE_0_autolinker___default.a(_extends({}, defaults, cfg));
  return function (s) {
    return _this.autolinker.link(s);
  };
}

/***/ }),

/***/ "./src/main/frontend/utils/axios.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return redirectOn401; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("./node_modules/axios/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
/* global SBA */
if (SBA && SBA.csrf && SBA.csrf.headerName) {
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.xsrfHeaderName = SBA.csrf.headerName;
}

var redirectOn401 = function redirectOn401() {
  var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return true;
  };
  return function (error) {
    if (error.response && error.response.status === 401 && predicate(error)) {
      window.location.assign('login?redirectTo=' + encodeURIComponent(window.location.href));
    }
    return Promise.reject(error);
  };
};

var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();
instance.interceptors.response.use(function (response) {
  return response;
}, redirectOn401());
instance.create = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create;

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),

/***/ "./src/main/frontend/utils/collections.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compareBy; });
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var compareBy = function compareBy(mapper) {
  return function (a, b) {
    var valA = mapper(a);
    var valB = mapper(b);
    return valA > valB ? 1 : valA < valB ? -1 : 0;
  };
};

/***/ }),

/***/ "./src/main/frontend/utils/d3.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__("./node_modules/d3-array/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_axis__ = __webpack_require__("./node_modules/d3-axis/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_brush__ = __webpack_require__("./node_modules/d3-brush/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_scale__ = __webpack_require__("./node_modules/d3-scale/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_selection__ = __webpack_require__("./node_modules/d3-selection/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_shape__ = __webpack_require__("./node_modules/d3-shape/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_time__ = __webpack_require__("./node_modules/d3-time/src/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_0_d3_array__, __WEBPACK_IMPORTED_MODULE_1_d3_axis__, __WEBPACK_IMPORTED_MODULE_2_d3_brush__, __WEBPACK_IMPORTED_MODULE_3_d3_scale__, __WEBPACK_IMPORTED_MODULE_4_d3_selection__, __WEBPACK_IMPORTED_MODULE_5_d3_shape__, __WEBPACK_IMPORTED_MODULE_6_d3_time__));

/***/ }),

/***/ "./src/main/frontend/utils/eventsource-polyfill.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = (_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof window.EventSource === 'undefined')) {
            _context.next = 2;
            break;
          }

          return _context.abrupt('return', __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./node_modules/event-source-polyfill/src/eventsource.js")));

        case 2:
          return _context.abrupt('return', Promise.resolve());

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, _this);
})));

/***/ }),

/***/ "./src/main/frontend/utils/rxjs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export doOnSubscribe */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return doFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return listen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_internal_observable_defer__ = __webpack_require__("./node_modules/rxjs/internal/observable/defer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_internal_observable_defer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_internal_observable_defer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_internal_operators_tap__ = __webpack_require__("./node_modules/rxjs/internal/operators/tap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_internal_operators_tap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_internal_operators_tap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_internal_observable_throwError__ = __webpack_require__("./node_modules/rxjs/internal/observable/throwError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_internal_observable_throwError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_internal_observable_throwError__);
/* unused harmony reexport throwError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_internal_observable_of__ = __webpack_require__("./node_modules/rxjs/internal/observable/of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_internal_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_internal_observable_of__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_3_rxjs_internal_observable_of__, "of")) __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_3_rxjs_internal_observable_of__["of"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_rxjs_internal_observable_defer__, "defer")) __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0_rxjs_internal_observable_defer__["defer"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_internal_observable_concat__ = __webpack_require__("./node_modules/rxjs/internal/observable/concat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_internal_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_internal_observable_concat__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4_rxjs_internal_observable_concat__, "concat")) __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4_rxjs_internal_observable_concat__["concat"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_internal_observable_empty__ = __webpack_require__("./node_modules/rxjs/internal/observable/empty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_internal_observable_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_internal_observable_empty__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_5_rxjs_internal_observable_empty__, "EMPTY")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5_rxjs_internal_observable_empty__["EMPTY"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_internal_observable_from__ = __webpack_require__("./node_modules/rxjs/internal/observable/from.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_internal_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_internal_observable_from__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6_rxjs_internal_observable_from__, "from")) __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6_rxjs_internal_observable_from__["from"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_internal_observable_timer__ = __webpack_require__("./node_modules/rxjs/internal/observable/timer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_internal_observable_timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_internal_observable_timer__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_7_rxjs_internal_observable_timer__, "timer")) __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_7_rxjs_internal_observable_timer__["timer"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_internal_Observable__ = __webpack_require__("./node_modules/rxjs/internal/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_internal_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_internal_Observable__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_8_rxjs_internal_Observable__, "Observable")) __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8_rxjs_internal_Observable__["Observable"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_internal_Subject__ = __webpack_require__("./node_modules/rxjs/internal/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_internal_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_internal_Subject__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_9_rxjs_internal_Subject__, "Subject")) __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9_rxjs_internal_Subject__["Subject"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_internal_scheduler_animationFrame__ = __webpack_require__("./node_modules/rxjs/internal/scheduler/animationFrame.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_internal_scheduler_animationFrame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_internal_scheduler_animationFrame__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10_rxjs_internal_scheduler_animationFrame__, "animationFrame")) __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10_rxjs_internal_scheduler_animationFrame__["animationFrame"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_internal_operators_concatMap__ = __webpack_require__("./node_modules/rxjs/internal/operators/concatMap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_internal_operators_concatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_internal_operators_concatMap__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_11_rxjs_internal_operators_concatMap__, "concatMap")) __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_11_rxjs_internal_operators_concatMap__["concatMap"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_internal_operators_delay__ = __webpack_require__("./node_modules/rxjs/internal/operators/delay.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_internal_operators_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_rxjs_internal_operators_delay__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_12_rxjs_internal_operators_delay__, "delay")) __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_12_rxjs_internal_operators_delay__["delay"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_internal_operators_debounceTime__ = __webpack_require__("./node_modules/rxjs/internal/operators/debounceTime.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_internal_operators_debounceTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_rxjs_internal_operators_debounceTime__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_13_rxjs_internal_operators_debounceTime__, "debounceTime")) __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_13_rxjs_internal_operators_debounceTime__["debounceTime"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_internal_operators_merge__ = __webpack_require__("./node_modules/rxjs/internal/operators/merge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_internal_operators_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_rxjs_internal_operators_merge__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_14_rxjs_internal_operators_merge__, "merge")) __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_14_rxjs_internal_operators_merge__["merge"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_internal_operators_map__ = __webpack_require__("./node_modules/rxjs/internal/operators/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_internal_operators_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_rxjs_internal_operators_map__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_15_rxjs_internal_operators_map__, "map")) __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15_rxjs_internal_operators_map__["map"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_internal_operators_retryWhen__ = __webpack_require__("./node_modules/rxjs/internal/operators/retryWhen.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_internal_operators_retryWhen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_rxjs_internal_operators_retryWhen__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_16_rxjs_internal_operators_retryWhen__, "retryWhen")) __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_16_rxjs_internal_operators_retryWhen__["retryWhen"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1_rxjs_internal_operators_tap__, "tap")) __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1_rxjs_internal_operators_tap__["tap"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_internal_operators_filter__ = __webpack_require__("./node_modules/rxjs/internal/operators/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_internal_operators_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_rxjs_internal_operators_filter__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_17_rxjs_internal_operators_filter__, "filter")) __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_17_rxjs_internal_operators_filter__["filter"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_internal_operators_concatAll__ = __webpack_require__("./node_modules/rxjs/internal/operators/concatAll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_internal_operators_concatAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_rxjs_internal_operators_concatAll__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18_rxjs_internal_operators_concatAll__, "concatAll")) __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_18_rxjs_internal_operators_concatAll__["concatAll"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_internal_operators_ignoreElements__ = __webpack_require__("./node_modules/rxjs/internal/operators/ignoreElements.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_internal_operators_ignoreElements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_rxjs_internal_operators_ignoreElements__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_19_rxjs_internal_operators_ignoreElements__, "ignoreElements")) __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_19_rxjs_internal_operators_ignoreElements__["ignoreElements"]; });
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

























var doOnSubscribe = function doOnSubscribe(cb) {
  return function (source) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs_internal_observable_defer__["defer"])(function () {
      cb();
      return source;
    });
  };
};

var doFirst = function doFirst(cb) {
  return function (source) {
    var triggered = void 0;
    return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs_internal_observable_defer__["defer"])(function () {
      triggered = false;
      return source;
    }).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_internal_operators_tap__["tap"])(function (v) {
      if (!triggered) {
        triggered = true;
        cb(v);
      }
    }));
  };
};

var listen = function listen(cb) {
  var execDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
  return function (source) {
    var handle = null;
    return source.pipe(doOnSubscribe(function () {
      return handle = setTimeout(function () {
        return cb('executing');
      }, execDelay);
    }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_internal_operators_tap__["tap"])({
      complete: function complete() {
        handle && clearTimeout(handle);
        cb('completed');
      },
      error: function error(_error) {
        console.warn('Operation failed:', _error);
        handle && clearTimeout(handle);
        cb('failed');
      }
    }));
  };
};

/***/ }),

/***/ "./src/main/frontend/utils/uri.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = (function (strings) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var result = strings[0];
  for (var i = 0; i < values.length; ++i) {
    result += encodeURIComponent(values[i]) + strings[i + 1];
  }
  return result;
});

/***/ }),

/***/ "./src/main/frontend/views recursive ^\\.\\/.+\\/index\\.(js|vue)$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./about/index.vue": "./src/main/frontend/views/about/index.vue",
	"./applications/index.vue": "./src/main/frontend/views/applications/index.vue",
	"./instances/auditevents/index.vue": "./src/main/frontend/views/instances/auditevents/index.vue",
	"./instances/configprops/index.vue": "./src/main/frontend/views/instances/configprops/index.vue",
	"./instances/details/index.vue": "./src/main/frontend/views/instances/details/index.vue",
	"./instances/env/index.vue": "./src/main/frontend/views/instances/env/index.vue",
	"./instances/flyway/index.vue": "./src/main/frontend/views/instances/flyway/index.vue",
	"./instances/heapdump/index.vue": "./src/main/frontend/views/instances/heapdump/index.vue",
	"./instances/httptrace/index.vue": "./src/main/frontend/views/instances/httptrace/index.vue",
	"./instances/jolokia/index.vue": "./src/main/frontend/views/instances/jolokia/index.vue",
	"./instances/liquibase/index.vue": "./src/main/frontend/views/instances/liquibase/index.vue",
	"./instances/logfile/index.vue": "./src/main/frontend/views/instances/logfile/index.vue",
	"./instances/loggers/index.vue": "./src/main/frontend/views/instances/loggers/index.vue",
	"./instances/mappings/index.vue": "./src/main/frontend/views/instances/mappings/index.vue",
	"./instances/metrics/index.vue": "./src/main/frontend/views/instances/metrics/index.vue",
	"./instances/scheduledtasks/index.vue": "./src/main/frontend/views/instances/scheduledtasks/index.vue",
	"./instances/sessions/index.vue": "./src/main/frontend/views/instances/sessions/index.vue",
	"./instances/shell/index.vue": "./src/main/frontend/views/instances/shell/index.vue",
	"./instances/threaddump/index.vue": "./src/main/frontend/views/instances/threaddump/index.vue",
	"./journal/index.vue": "./src/main/frontend/views/journal/index.vue",
	"./wallboard/index.vue": "./src/main/frontend/views/wallboard/index.vue"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/main/frontend/views recursive ^\\.\\/.+\\/index\\.(js|vue)$";

/***/ }),

/***/ "./src/main/frontend/views/about/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/about/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var about = ({
  data: function data() {
    return {
      // eslint-disable-next-line no-undef
      version: '2.0.4'
    };
  },
  computed: {
    documentationBaseUrl: function documentationBaseUrl() {
      return 'https://codecentric.github.io/spring-boot-admin/' + (this.version || 'current');
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      path: '/about',
      name: 'about',
      label: 'About',
      order: 200,
      component: this
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a04e7b1","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/about/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("About Spring Boot Admin")]),_vm._v(" "),(_vm.version)?_c('h2',{staticClass:"subtitle",domProps:{"textContent":_vm._s(("Version " + _vm.version))}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v("\n        This is an administration UI for Spring Boot applications.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        To monitor applications, they must be registered at this server. This is either done by including the\n        "),_c('a',{attrs:{"href":(_vm.documentationBaseUrl + "/#register-clients-via-spring-boot-admin")}},[_vm._v("\n          Spring Boot Admin Client\n        ")]),_vm._v("\n        or using a\n        "),_c('a',{attrs:{"href":(_vm.documentationBaseUrl + "/#discover-clients-via-spring-cloud-discovery")}},[_vm._v("\n          Spring Cloud Discovery Client\n        ")]),_vm._v(" implementation.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        If you have any question please consult the\n        "),_c('a',{attrs:{"href":("" + _vm.documentationBaseUrl)}},[_vm._v("Reference Guide")]),_vm._v(", ask\n        on "),_c('a',{attrs:{"href":"https://stackoverflow.com/questions/tagged/spring-boot-admin"}},[_vm._v(" Stack Overflow")]),_vm._v(" or\n        have a chat on the "),_c('a',{attrs:{"href":"https://gitter.im/codecentric/spring-boot-admin"}},[_vm._v("Gitter")]),_vm._v(" channel.\n      ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"about-links"},[_c('a',{staticClass:"button is-primary is-outlined",attrs:{"href":("" + _vm.documentationBaseUrl)}},[_c('font-awesome-icon',{attrs:{"size":"lg","icon":"book"}}),_vm._v(" Reference Guide\n        ")],1),_vm._v(" "),_c('a',{staticClass:"button is-black is-outlined",attrs:{"href":"https://github.com/codecentric/spring-boot-admin"}},[_c('font-awesome-icon',{attrs:{"size":"lg","icon":['fab', 'github']}}),_vm._v(" Sources\n        ")],1),_vm._v(" "),_c('a',{staticClass:"button is-stackoverflow is-outlined",attrs:{"href":"https://stackoverflow.com/questions/tagged/spring-boot-admin"}},[_c('font-awesome-icon',{attrs:{"size":"lg","icon":['fab', 'stack-overflow']}}),_vm._v(" Stack Overflow\n        ")],1),_vm._v(" "),_c('a',{staticClass:"button is-gitter is-outlined",attrs:{"href":"https://gitter.im/codecentric/spring-boot-admin"}},[_c('font-awesome-icon',{attrs:{"size":"lg","icon":['fab', 'gitter']}}),_vm._v(" Gitter\n        ")],1)])]),_vm._v(" "),_c('h1',{staticClass:"title is-5"},[_vm._v("Trademarks and Licenses")]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        If you found a bug, want to propose a feature or submit a pull request please use the\n        "),_c('a',{attrs:{"href":"https://github.com/codecentric/spring-boot-admin/issues"}},[_vm._v("issue tracker")]),_vm._v(".\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('p',[_vm._v("\n        The source code of Spring Boot Admin is licensed under "),_c('a',{attrs:{"href":"https://www.apache.org/licenses/LICENSE-2.0"}},[_vm._v("Apache License 2.0")]),_vm._v(".\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Spring, Spring Boot and Spring Cloud are trademarks of "),_c('a',{attrs:{"href":"https://pivotal.io/"}},[_vm._v("Pivotal\n        Software, Inc.")]),_vm._v(" in the U.S. and other countries.\n      ")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/about/index.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/about/index.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  about,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_about = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/applications/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("./node_modules/lodash/sortBy.js");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./node_modules/lodash/transform.js
var transform = __webpack_require__("./node_modules/lodash/transform.js");
var transform_default = /*#__PURE__*/__webpack_require__.n(transform);

// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__("./node_modules/lodash/groupBy.js");
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);

// EXTERNAL MODULE: ./node_modules/popper.js/dist/esm/popper.js
var esm_popper = __webpack_require__("./node_modules/popper.js/dist/esm/popper.js");

// CONCATENATED MODULE: ./src/main/frontend/directives/popper.js
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var poppers = new WeakMap();

var popper_bind = function bind(el, binding) {
  var reference = typeof binding.value === 'string' ? document.getElementById(binding.value) : binding.value;
  if (reference) {
    var popper = new esm_popper["a" /* default */](reference, el);
    poppers.set(el, popper);
  }
};

var unbind = function unbind(el) {
  var popper = poppers.get(el);
  if (popper) {
    popper.destroy(el);
  }
};

/* harmony default export */ var directives_popper = ({
  bind: popper_bind,
  update: function update(el, binding) {
    if (binding.value === binding.oldValue) {
      return;
    }
    popper_bind(el, binding);
  },

  unbind: unbind
});
// EXTERNAL MODULE: ./src/main/frontend/mixins/subscribing.js
var subscribing = __webpack_require__("./src/main/frontend/mixins/subscribing.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/axios.js
var axios = __webpack_require__("./src/main/frontend/utils/axios.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/uri.js
var uri = __webpack_require__("./src/main/frontend/utils/uri.js");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("./node_modules/moment/moment.js");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/main/frontend/services/notification-filter.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['notifications/filters/', ''], ['notifications/filters/', '']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var notification_filter_NotificationFilter = function () {
  function NotificationFilter(_ref) {
    var expiry = _ref.expiry,
        filter = _objectWithoutProperties(_ref, ['expiry']);

    _classCallCheck(this, NotificationFilter);

    Object.assign(this, filter);
    this.expiry = expiry ? moment_default()(expiry) : null;
  }

  _createClass(NotificationFilter, [{
    key: 'affects',
    value: function affects(obj) {
      if (!obj) {
        return false;
      }

      if (this.isApplicationFilter) {
        return this.applicationName === obj.name;
      }

      if (this.isInstanceFilter) {
        return this.instanceId === obj.id;
      }

      return false;
    }
  }, {
    key: 'delete',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', axios["a" /* default */].delete(Object(uri["a" /* default */])(_templateObject, this.id)));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _delete() {
        return _ref2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: 'isApplicationFilter',
    get: function get() {
      return this.hasOwnProperty('applicationName');
    }
  }, {
    key: 'isInstanceFilter',
    get: function get() {
      return this.hasOwnProperty('instanceId');
    }
  }], [{
    key: 'isSupported',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return axios["a" /* default */].options('notifications/filters');

              case 3:
                response = _context2.sent;
                return _context2.abrupt('return', response.headers['allow'] && response.headers['allow'].includes('POST'));

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return', false);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function isSupported() {
        return _ref3.apply(this, arguments);
      }

      return isSupported;
    }()
  }, {
    key: 'getFilters',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', axios["a" /* default */].get('notifications/filters', {
                  transformResponse: NotificationFilter._transformResponse
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getFilters() {
        return _ref4.apply(this, arguments);
      }

      return getFilters;
    }()
  }, {
    key: 'addFilter',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(object, ttl) {
        var params;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = { ttl: ttl };

                if (object.hasOwnProperty('name')) {
                  params.applicationName = object.name;
                } else if (object.hasOwnProperty('id')) {
                  params.instanceId = object.id;
                }
                return _context4.abrupt('return', axios["a" /* default */].post('notifications/filters', null, {
                  params: params,
                  transformResponse: NotificationFilter._transformResponse
                }));

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addFilter(_x, _x2) {
        return _ref5.apply(this, arguments);
      }

      return addFilter;
    }()
  }, {
    key: '_transformResponse',
    value: function _transformResponse(data) {
      if (!data) {
        return data;
      }
      var json = JSON.parse(data);
      if (json instanceof Array) {
        return json.map(NotificationFilter._toNotificationFilters).filter(function (f) {
          return !f.expired;
        });
      }
      return NotificationFilter._toNotificationFilters(json);
    }
  }, {
    key: '_toNotificationFilters',
    value: function _toNotificationFilters(notificationFilter) {
      return new NotificationFilter(notificationFilter);
    }
  }]);

  return NotificationFilter;
}();

/* harmony default export */ var notification_filter = (notification_filter_NotificationFilter);
// EXTERNAL MODULE: ./src/main/frontend/utils/rxjs.js
var rxjs = __webpack_require__("./src/main/frontend/utils/rxjs.js");

// EXTERNAL MODULE: ./node_modules/vue-clickaway/dist/vue-clickaway.common.js
var vue_clickaway_common = __webpack_require__("./node_modules/vue-clickaway/dist/vue-clickaway.common.js");
var vue_clickaway_common_default = /*#__PURE__*/__webpack_require__.n(vue_clickaway_common);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/applications/notification-filter-settings.vue
function notification_filter_settings__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var notification_filter_settings = ({
  props: {
    object: {
      type: Object,
      required: true
    },
    notificationFilters: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      ttl: 5 * 60 * 1000,
      ttlOptions: [{ label: '5 minutes', value: 5 * 60 * 1000 }, { label: '15 minutes', value: 15 * 60 * 1000 }, { label: '30 minutes', value: 30 * 60 * 1000 }, { label: '1 hour', value: 60 * 60 * 1000 }, { label: '3 hours', value: 3 * 60 * 60 * 1000 }, { label: '8 hours', value: 8 * 60 * 60 * 1000 }, { label: '24 hours', value: 24 * 60 * 60 * 1000 }, { label: 'ever', value: -1 }],
      actionState: null
    };
  },
  computed: {
    activeFilter: function activeFilter() {
      var _this = this;

      return this.notificationFilters.find(function (f) {
        return f.affects(_this.object);
      });
    }
  },
  methods: {
    addFilter: function addFilter() {
      var _this2 = this;

      return notification_filter_settings__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.actionState = 'executing';
                _context.prev = 1;
                _context.next = 4;
                return notification_filter.addFilter(_this2.object, _this2.ttl);

              case 4:
                response = _context.sent;

                _this2.actionState = 'completed';
                _this2.$emit('filter-added', response.data);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                console.warn('Adding notification filter failed:', _context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 9]]);
      }))();
    },
    deleteActiveFilter: function deleteActiveFilter() {
      var _this3 = this;

      return notification_filter_settings__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.actionState = 'executing';
                _context2.prev = 1;
                _context2.next = 4;
                return _this3.activeFilter.delete();

              case 4:
                _this3.actionState = 'completed';
                _this3.$emit('filter-deleted', _this3.activeFilter.id);
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                _this3.actionState = 'failed';
                console.warn('Deleting notification filter failed:', _context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 8]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70e5bac4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/applications/notification-filter-settings.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[(!_vm.activeFilter)?[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control has-inline-text"},[_vm._v("\n        Suppress notifications on "),_c('code',{domProps:{"textContent":_vm._s(_vm.object.id || _vm.object.name)}}),_vm._v(" for\n        "),_c('span',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ttl),expression:"ttl"}],on:{"click":function($event){$event.stopPropagation();},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ttl=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.ttlOptions),function(option){return _c('option',{key:("ttl-instance-" + (option.value)),domProps:{"value":option.value,"textContent":_vm._s(option.label)}})}))])])]),_vm._v(" "),_c('div',{staticClass:"field is-grouped is-grouped-right"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-warning",class:{'is-loading' : _vm.actionState === 'executing'},on:{"click":function($event){$event.stopPropagation();return _vm.addFilter($event)}}},[_c('font-awesome-icon',{attrs:{"icon":"bell-slash"}}),_vm._v(" Suppress\n        ")],1)])])]:[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control has-inline-text"},[_vm._v("\n        Notifications on "),_c('code',{domProps:{"textContent":_vm._s(_vm.object.id || _vm.object.name)}}),_vm._v(" are suppressed for\n        "),_c('strong',{domProps:{"textContent":_vm._s(_vm.activeFilter.expiry ? _vm.activeFilter.expiry.locale('en').fromNow(true) : 'ever' )}}),_vm._v(".\n      ")])]),_vm._v(" "),_c('div',{staticClass:"field is-grouped is-grouped-right"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button",class:{'is-loading' : _vm.actionState === 'executing'},on:{"click":function($event){$event.stopPropagation();return _vm.deleteActiveFilter($event)}}},[_c('font-awesome-icon',{attrs:{"icon":"bell"}}),_vm._v(" Unsuppress\n        ")],1)])])]],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/applications/notification-filter-settings.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/applications/notification-filter-settings.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  notification_filter_settings,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var applications_notification_filter_settings = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/applications/applications-list.vue
function applications_list__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var applications_list = ({
  props: {
    applications: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selected: {
      type: String,
      default: null
    }
  },
  directives: { onClickaway: vue_clickaway_common["directive"], Popper: directives_popper },
  mixins: [subscribing["a" /* default */]],
  components: { NotificationFilterSettings: applications_notification_filter_settings },
  data: function data() {
    return {
      errors: [],
      hasNotificationFiltersSupport: false,
      notificationFilters: [],
      showNotificationFilterSettingsObject: null
    };
  },
  computed: {},
  methods: {
    select: function select(name) {
      this.$router.replace({ name: 'applications', params: { selected: name } });
    },
    deselect: function deselect(event, expectedSelected) {
      this.toggleNotificationFilterSettingsFor(null);
      if (event && event.target instanceof HTMLAnchorElement) {
        return;
      }
      if (this.selected === expectedSelected || !expectedSelected) {
        this.$router.replace({ name: 'applications' });
      }
    },
    showDetails: function showDetails(instance) {
      this.$router.push({ name: 'instances/details', params: { instanceId: instance.id } });
    },
    scrollIntoView: function scrollIntoView(id, behavior) {
      var _this = this;

      return applications_list__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var el, top;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!id) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return _this.$nextTick();

              case 3:
                el = document.getElementById(id);

                if (el) {
                  top = el.getBoundingClientRect().top + window.scrollY - 100;

                  window.scroll({ top: top, left: window.scrollX, behavior: behavior || 'smooth' });
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getHeaderClass: function getHeaderClass(application) {
      if (this.selected !== application.name) {
        return 'is-selectable';
      }
      if (application.status === 'UP') {
        return 'is-primary';
      }
      if (application.status === 'RESTRICTED') {
        return 'is-warning';
      }
      if (application.status === 'DOWN') {
        return 'is-danger';
      }
      if (application.status === 'OUT_OF_SERVICE') {
        return 'is-danger';
      }
      if (application.status === 'OFFLINE') {
        return 'is-light';
      }
      return 'is-light';
    },
    unregister: function unregister(item) {
      var _this2 = this;

      return applications_list__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  item.unregister();
                } catch (e) {
                  _this2.errors.push(e);
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      vm.notificationFilterSubject = new rxjs["c" /* Subject */]();
      return Object(rxjs["u" /* timer */])(0, 60000).pipe(Object(rxjs["q" /* merge */])(vm.notificationFilterSubject), Object(rxjs["g" /* concatMap */])(this.fetchNotificationFilters)).subscribe({
        next: function next(data) {
          vm.notificationFilters = data;
        },
        error: function error(_error) {
          console.warn('Fetching notification filters failed:', _error);
          vm.errors.push(_error);
        }
      });
    },
    fetchNotificationFilters: function fetchNotificationFilters() {
      var _this3 = this;

      return applications_list__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.hasNotificationFiltersSupport) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return notification_filter.getFilters();

              case 3:
                response = _context3.sent;
                return _context3.abrupt('return', response.data);

              case 5:
                return _context3.abrupt('return', []);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleFilterChange: function handleFilterChange(event) {
      this.toggleNotificationFilterSettingsFor(null);
      this.notificationFilterSubject.next(event);
    },
    toggleNotificationFilterSettingsFor: function toggleNotificationFilterSettingsFor(obj) {
      this.showNotificationFilterSettingsObject = obj ? obj : null;
    },
    hasActiveFilter: function hasActiveFilter(object) {
      return this.notificationFilters.findIndex(function (f) {
        return f.affects(object);
      }) >= 0;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return applications_list__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this4.scrollIntoView(_this4.selected, 'instant');
              _context4.next = 3;
              return notification_filter.isSupported();

            case 3:
              _this4.hasNotificationFiltersSupport = _context4.sent;

              _this4.fetchNotificationFilters();

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },

  watch: {
    selected: function selected(newVal) {
      this.scrollIntoView(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b8b75aa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/applications/applications-list.vue
var applications_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"applications-list"},[_vm._l((_vm.applications),function(application){return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(function (event) { return _vm.deselect(event, application.name); }),expression:"(event) => deselect(event, application.name)"}],key:application.name,staticClass:"application-list__item card",class:{'is-active': _vm.selected === application.name},attrs:{"id":application.name}},[_c('header',{staticClass:"hero application-list__item__header",class:_vm.getHeaderClass(application),on:{"click":function($event){$event.stopPropagation();_vm.select(application.name)}}},[(_vm.selected !== application.name)?[_c('sba-status',{staticClass:"application-list__item__header__status",attrs:{"status":application.status,"date":application.statusTimestamp}}),_vm._v(" "),_c('p',{staticClass:"application-list__item__header__name"},[_c('span',{domProps:{"textContent":_vm._s(application.name)}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"is-muted"},[(application.instances.length === 1)?_c('a',{attrs:{"href":application.instances[0].registration.serviceUrl || application.instances[0].registration.healthUrl},domProps:{"textContent":_vm._s(application.instances[0].registration.serviceUrl || application.instances[0].registration.healthUrl)}}):_c('span',{domProps:{"textContent":_vm._s(((application.instances.length) + " instances"))}})])]),_vm._v(" "),_c('p',{staticClass:"application-list__item__header__version",domProps:{"textContent":_vm._s(application.buildVersion)}})]:[_c('h1',{staticClass:"title is-size-5 application-list__item__header__name",domProps:{"textContent":_vm._s(application.name)}})],_vm._v(" "),_c('div',{staticClass:"application-list__item__header__actions"},[(_vm.hasNotificationFiltersSupport)?_c('sba-icon-button',{attrs:{"id":("nf-settings-" + (application.name)),"icon":_vm.hasActiveFilter(application) ? 'bell-slash' : 'bell'},on:{"click":function($event){$event.stopPropagation();_vm.toggleNotificationFilterSettingsFor(application)}}}):_vm._e(),_vm._v(" \n        "),(application.isUnregisterable)?_c('sba-icon-button',{attrs:{"icon":"trash"},on:{"click":function($event){$event.stopPropagation();_vm.unregister(application)}}}):_vm._e()],1)],2),_vm._v(" "),(_vm.selected === application.name)?_c('div',{staticClass:"card-content"},[_c('table',{staticClass:"table is-hoverable is-selectable is-fullwidth application__instances"},[_c('tbody',_vm._l((application.instances),function(instance){return _c('tr',{key:instance.id,on:{"click":function($event){$event.stopPropagation();_vm.showDetails(instance)}}},[_c('td',{staticClass:"instance__status"},[_c('sba-status',{attrs:{"status":instance.statusInfo.status,"date":instance.statusTimestamp}})],1),_vm._v(" "),_c('td',{staticClass:"is-narrow"},[_c('a',{attrs:{"href":instance.registration.serviceUrl || instance.registration.healthUrl},domProps:{"textContent":_vm._s(instance.registration.serviceUrl || instance.registration.healthUrl)},on:{"click":function($event){$event.stopPropagation();}}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"is-muted",domProps:{"textContent":_vm._s(instance.id)}})]),_vm._v(" "),_c('td',[_c('sba-tags',{attrs:{"tags":instance.tags}})],1),_vm._v(" "),_c('td',[_c('span',{domProps:{"textContent":_vm._s(instance.buildVersion)}})]),_vm._v(" "),_c('td',{staticClass:"instance__actions"},[(_vm.hasNotificationFiltersSupport)?_c('sba-icon-button',{attrs:{"id":("nf-settings-" + (instance.id)),"icon":_vm.hasActiveFilter(instance) ? 'bell-slash' : 'bell'},on:{"click":function($event){$event.stopPropagation();_vm.toggleNotificationFilterSettingsFor(instance)}}}):_vm._e(),_vm._v(" "),(instance.isUnregisterable)?_c('sba-icon-button',{attrs:{"icon":"trash"},on:{"click":function($event){$event.stopPropagation();_vm.unregister(instance)}}}):_vm._e()],1)])}))])]):_vm._e()])}),_vm._v(" "),(_vm.showNotificationFilterSettingsObject)?_c('notification-filter-settings',{directives:[{name:"popper",rawName:"v-popper",value:(("nf-settings-" + (_vm.showNotificationFilterSettingsObject.id || _vm.showNotificationFilterSettingsObject.name))),expression:"`nf-settings-${showNotificationFilterSettingsObject.id || showNotificationFilterSettingsObject.name}`"}],attrs:{"notification-filters":_vm.notificationFilters,"object":_vm.showNotificationFilterSettingsObject},on:{"filter-added":_vm.handleFilterChange,"filter-deleted":_vm.handleFilterChange}}):_vm._e()],2)}
var applications_list_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/applications/applications-list.vue
function applications_list_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/applications/applications-list.vue")
}
/* script */


/* template */

/* template functional */
var applications_list___vue_template_functional__ = false
/* styles */
var applications_list___vue_styles__ = applications_list_injectStyle
/* scopeId */
var applications_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var applications_list___vue_module_identifier__ = null

var applications_list_Component = Object(component_normalizer["a" /* default */])(
  applications_list,
  applications_list_render,
  applications_list_staticRenderFns,
  applications_list___vue_template_functional__,
  applications_list___vue_styles__,
  applications_list___vue_scopeId__,
  applications_list___vue_module_identifier__
)

/* harmony default export */ var applications_applications_list = (applications_list_Component.exports);

// EXTERNAL MODULE: ./src/main/frontend/assets/img/favicon-danger.png
var favicon_danger = __webpack_require__("./src/main/frontend/assets/img/favicon-danger.png");
var favicon_danger_default = /*#__PURE__*/__webpack_require__.n(favicon_danger);

// EXTERNAL MODULE: ./src/main/frontend/assets/img/favicon.png
var favicon = __webpack_require__("./src/main/frontend/assets/img/favicon.png");
var favicon_default = /*#__PURE__*/__webpack_require__.n(favicon);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/applications/handle.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var handle = ({
  props: {
    applications: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: null,
      default: null
    }
  },
  computed: {
    downCount: function downCount() {
      return this.applications.reduce(function (current, next) {
        return current + next.instances.filter(function (instance) {
          return instance.statusInfo.status !== 'UP';
        }).length;
      }, 0);
    }
  },
  watch: {
    downCount: function downCount(newVal, oldVal) {
      if (newVal === 0 !== (oldVal === 0)) {
        this.updateFavicon(newVal === 0);
      }
    }
  },
  methods: {
    updateFavicon: function updateFavicon(up) {
      document.querySelector('link[rel*="icon"]').href = up ? favicon_default.a : favicon_danger_default.a;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b48c98c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/applications/handle.vue
var handle_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.error)?_c('span',{staticClass:"has-text-warning"},[_c('font-awesome-icon',{attrs:{"icon":"exclamation-triangle"}})],1):_vm._e(),_vm._v(" "),_c('span',{class:{ 'badge is-badge-danger' : _vm.downCount > 0 },attrs:{"data-badge":_vm.downCount}},[_vm._v("\n    Applications\n  ")])])}
var handle_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/applications/handle.vue
/* script */


/* template */

/* template functional */
var handle___vue_template_functional__ = false
/* styles */
var handle___vue_styles__ = null
/* scopeId */
var handle___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var handle___vue_module_identifier__ = null

var handle_Component = Object(component_normalizer["a" /* default */])(
  handle,
  handle_render,
  handle_staticRenderFns,
  handle___vue_template_functional__,
  handle___vue_styles__,
  handle___vue_scopeId__,
  handle___vue_module_identifier__
)

/* harmony default export */ var applications_handle = (handle_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/applications/index.vue


 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var applications = ({
  props: {
    applications: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: null,
      default: null
    },
    selected: {
      type: String,
      default: null
    }
  },
  components: {
    applicationsList: applications_applications_list
  },
  computed: {
    statusGroups: function statusGroups() {
      var byStatus = groupBy_default()(this.applications, function (application) {
        return application.status;
      });
      var list = transform_default()(byStatus, function (result, value, key) {
        result.push({ status: key, applications: sortBy_default()(value, [function (application) {
            return application.name;
          }]) });
      }, []);
      return sortBy_default()(list, [function (item) {
        return item.status;
      }]);
    },
    applicationsCount: function applicationsCount() {
      return this.applications.length;
    },
    instancesCount: function instancesCount() {
      return this.applications.reduce(function (current, next) {
        return current + next.instances.length;
      }, 0);
    },
    downCount: function downCount() {
      return this.applications.reduce(function (current, next) {
        return current + next.instances.filter(function (instance) {
          return instance.statusInfo.status !== 'UP';
        }).length;
      }, 0);
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      path: '/applications/:selected?',
      props: true,
      name: 'applications',
      label: 'Applications',
      handle: applications_handle,
      order: 0,
      component: this
    });
    viewRegistry.addRedirect('/', 'applications');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7f74236","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/applications/index.vue
var applications_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[(_vm.error)?_c('div',{staticClass:"message is-warning"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-warning",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Server connection failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"level applications-stats"},[_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Applications")]),_vm._v(" "),_c('p',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.applicationsCount)}},[_vm._v("1")])])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Instances")]),_vm._v(" "),_c('p',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.instancesCount)}},[_vm._v("1")])])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[(_vm.downCount === 0)?_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Status")]),_vm._v(" "),_c('p',{staticClass:"title has-text-success"},[_vm._v("all up")])]):_c('div',[_c('p',{staticClass:"heading"},[_vm._v("instances down")]),_vm._v(" "),_c('p',{staticClass:"title has-text-danger",domProps:{"textContent":_vm._s(_vm.downCount)}})])])]),_vm._v(" "),_vm._l((_vm.statusGroups),function(group){return _c('div',{key:group.status,staticClass:"application-group"},[_c('p',{staticClass:"heading",domProps:{"textContent":_vm._s(group.status)}}),_vm._v(" "),_c('applications-list',{attrs:{"applications":group.applications,"selected":_vm.selected}})],1)}),_vm._v(" "),(_vm.statusGroups.length === 0)?_c('div',[_c('p',{staticClass:"is-muted"},[_vm._v("No applications registered.")])]):_vm._e()],2)])}
var applications_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/applications/index.vue
function applications_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/applications/index.vue")
}
/* script */


/* template */

/* template functional */
var applications___vue_template_functional__ = false
/* styles */
var applications___vue_styles__ = applications_injectStyle
/* scopeId */
var applications___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var applications___vue_module_identifier__ = null

var applications_Component = Object(component_normalizer["a" /* default */])(
  applications,
  applications_render,
  applications_staticRenderFns,
  applications___vue_template_functional__,
  applications___vue_styles__,
  applications___vue_scopeId__,
  applications___vue_module_identifier__
)

/* harmony default export */ var views_applications = __webpack_exports__["default"] = (applications_Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/auditevents/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("./node_modules/lodash/uniqBy.js");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: ./src/main/frontend/mixins/subscribing.js
var subscribing = __webpack_require__("./src/main/frontend/mixins/subscribing.js");

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/rxjs.js
var rxjs = __webpack_require__("./src/main/frontend/utils/rxjs.js");

// EXTERNAL MODULE: ./node_modules/pretty-bytes/index.js
var pretty_bytes = __webpack_require__("./node_modules/pretty-bytes/index.js");
var pretty_bytes_default = /*#__PURE__*/__webpack_require__.n(pretty_bytes);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/auditevents/auditevents-list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var auditevents_list = ({
  props: {
    events: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    instance: {
      type: instance["a" /* default */],
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showDetails: {}
    };
  },
  computed: {
    hasSessionEndpoint: function hasSessionEndpoint() {
      return this.instance.hasEndpoint('sessions');
    }
  },
  methods: {
    prettyBytes: pretty_bytes_default.a,
    toJson: function toJson(obj) {
      return JSON.stringify(obj, null, 4);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a259272","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/auditevents/auditevents-list.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"auditevents table is-hoverable is-fullwidth"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.events),function(event){return [_c('tr',{key:event.key,staticClass:"is-selectable",class:{ 'auditevents__event--is-detailed' : _vm.showDetails[event.key] },on:{"click":function($event){_vm.showDetails[event.key] ? _vm.$delete(_vm.showDetails, event.key) : _vm.$set(_vm.showDetails, event.key, true)}}},[_c('td',{domProps:{"textContent":_vm._s(event.timestamp.format('L HH:mm:ss.SSS'))}}),_vm._v(" "),_c('td',[_c('span',{staticClass:"tag",class:{ 'is-success' : event.isSuccess(), 'is-danger' : event.isFailure() },domProps:{"textContent":_vm._s(event.type)}})]),_vm._v(" "),(_vm.hasSessionEndpoint && event.principal)?_c('td',[_c('router-link',{attrs:{"to":{ name: 'instances/sessions', params: { 'instanceId' : _vm.instance.id }, query: { username : event.principal} }},domProps:{"textContent":_vm._s(event.principal)}})],1):_c('td',{domProps:{"textContent":_vm._s(event.principal)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(event.remoteAddress)}}),_vm._v(" "),(_vm.hasSessionEndpoint && event.sessionId)?_c('td',[_c('router-link',{attrs:{"to":{ name: 'instances/sessions', params: { 'instanceId' : _vm.instance.id }, query: { sessionId : event.sessionId } }},domProps:{"textContent":_vm._s(event.sessionId)}})],1):_c('td',{domProps:{"textContent":_vm._s(event.sessionId)}})]),_vm._v(" "),(_vm.showDetails[event.key])?_c('tr',{key:((event.key) + "-detail")},[_c('td',{attrs:{"colspan":"5"}},[_c('pre',{staticClass:"auditevents__event-detail",domProps:{"textContent":_vm._s(_vm.toJson(event.data))}})])]):_vm._e()]}),_vm._v(" "),(_vm.events.length === 0)?_c('tr',[_c('td',{staticClass:"is-muted",attrs:{"colspan":"5"}},[(_vm.isLoading)?_c('p',{staticClass:"is-loading"},[_vm._v("Loading Audit Events...")]):_c('p',[_vm._v("No Audit Events found.")])])]):_vm._e()],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Timestamp")]),_vm._v(" "),_c('th',[_vm._v("Event")]),_vm._v(" "),_c('th',[_vm._v("Principal")]),_vm._v(" "),_c('th',[_vm._v("Remote address")]),_vm._v(" "),_c('th',[_vm._v("Session Id")])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/auditevents/auditevents-list.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/auditevents/auditevents-list.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  auditevents_list,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var auditevents_auditevents_list = (Component.exports);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("./node_modules/moment/moment.js");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/auditevents/index.vue


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var auditevents_Auditevent = function () {
  function Auditevent(_ref) {
    var timestamp = _ref.timestamp,
        event = _objectWithoutProperties(_ref, ['timestamp']);

    _classCallCheck(this, Auditevent);

    Object.assign(this, event);
    this.timestamp = moment_default()(timestamp);
  }

  _createClass(Auditevent, [{
    key: 'isSuccess',
    value: function isSuccess() {
      return this.type.toLowerCase().includes('success');
    }
  }, {
    key: 'isFailure',
    value: function isFailure() {
      return this.type.toLowerCase().includes('failure');
    }
  }, {
    key: 'key',
    get: function get() {
      return this.timestamp + '-' + this.type + '-' + this.principal;
    }
  }, {
    key: 'remoteAddress',
    get: function get() {
      return this.data && this.data.details && this.data.details.remoteAddress || null;
    }
  }, {
    key: 'sessionId',
    get: function get() {
      return this.data && this.data.details && this.data.details.sessionId || null;
    }
  }]);

  return Auditevent;
}();

/* harmony default export */ var auditevents = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  components: { AuditeventsList: auditevents_auditevents_list },
  data: function data() {
    return {
      isLoading: false,
      error: null,
      events: [],
      filter: {
        after: moment_default()().startOf('day'),
        type: null,
        principal: null
      },
      isOldAuditevents: false
    };
  },
  watch: {
    filter: {
      deep: true,
      handler: function handler() {
        this.filterChanged.next();
      }
    }
  },
  methods: {
    formatDate: function formatDate(value) {
      return value.format(moment_default.a.HTML5_FMT.DATETIME_LOCAL);
    },
    parseDate: function parseDate(value) {
      return moment_default()(value, moment_default.a.HTML5_FMT.DATETIME_LOCAL, true);
    },
    fetchAuditevents: function fetchAuditevents() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, converted;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _context.next = 3;
                return _this.instance.fetchAuditevents(_this.filter);

              case 3:
                response = _context.sent;
                converted = response.data.events.map(function (event) {
                  return new auditevents_Auditevent(event);
                });

                converted.reverse();
                _this.isLoading = false;
                return _context.abrupt('return', converted);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      vm.filterChanged = new rxjs["c" /* Subject */]();
      vm.error = null;
      return Object(rxjs["u" /* timer */])(0, 5000).pipe(Object(rxjs["q" /* merge */])(vm.filterChanged.pipe(Object(rxjs["h" /* debounceTime */])(250), Object(rxjs["t" /* tap */])({
        next: function next() {
          return vm.events = [];
        }
      }))), Object(rxjs["g" /* concatMap */])(this.fetchAuditevents)).subscribe({
        next: function next(events) {
          vm.addEvents(events);
        },
        error: function error(_error) {
          console.warn('Fetching audit events failed:', _error);
          if (_error.response.headers['content-type'].includes('application/vnd.spring-boot.actuator.v2')) {
            vm.error = _error;
          } else {
            vm.isOldAuditevents = true;
          }
        }
      });
    },
    addEvents: function addEvents(events) {
      this.events = uniqBy_default()(this.events ? events.concat(this.events) : events, function (event) {
        return event.key;
      });
    }
  },
  install: function install(_ref2) {
    var viewRegistry = _ref2.viewRegistry;

    viewRegistry.addView({
      name: 'instances/auditevents',
      parent: 'instances',
      path: 'auditevents',
      component: this,
      label: 'Audit Log',
      group: 'Security',
      order: 600,
      isEnabled: function isEnabled(_ref3) {
        var instance = _ref3.instance;
        return instance.hasEndpoint('auditevents');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73ead090","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/auditevents/index.vue
var auditevents_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"field is-horizontal"},[_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.filter.principal),expression:"filter.principal",modifiers:{"trim":true}}],staticClass:"input",attrs:{"type":"search","placeholder":"Principal"},domProps:{"value":(_vm.filter.principal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filter, "principal", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.type),expression:"filter.type"}],staticClass:"input",attrs:{"list":"auditevent-type","type":"search","placeholder":"Type"},domProps:{"value":(_vm.filter.type)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filter, "type", $event.target.value)}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{staticClass:"input",attrs:{"type":"datetime-local","placeholder":"Date"},domProps:{"value":_vm.formatDate(_vm.filter.after)},on:{"input":function($event){_vm.filter.after = _vm.parseDate($event.target.value)}}})])])])]),_vm._v(" "),[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching audit events failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.isOldAuditevents)?_c('div',{staticClass:"message is-warning"},[_c('div',{staticClass:"message-body"},[_vm._v("\n        Audit Log is not supported for Spring Boot 1.x applications.\n      ")])]):_vm._e(),_vm._v(" "),_c('auditevents-list',{attrs:{"instance":_vm.instance,"events":_vm.events,"is-loading":_vm.isLoading}})]],2)}
var auditevents_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{attrs:{"id":"auditevent-type"}},[_c('option',{attrs:{"value":"AUTHENTICATION_FAILURE"}}),_vm._v(" "),_c('option',{attrs:{"value":"AUTHENTICATION_SUCCESS"}}),_vm._v(" "),_c('option',{attrs:{"value":"AUTHENTICATION_SWITCH"}}),_vm._v(" "),_c('option',{attrs:{"value":"AUTHORIZATION_FAILURE"}})])}]

// CONCATENATED MODULE: ./src/main/frontend/views/instances/auditevents/index.vue
/* script */


/* template */

/* template functional */
var auditevents___vue_template_functional__ = false
/* styles */
var auditevents___vue_styles__ = null
/* scopeId */
var auditevents___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var auditevents___vue_module_identifier__ = null

var auditevents_Component = Object(component_normalizer["a" /* default */])(
  auditevents,
  auditevents_render,
  auditevents_staticRenderFns,
  auditevents___vue_template_functional__,
  auditevents___vue_styles__,
  auditevents___vue_scopeId__,
  auditevents___vue_module_identifier__
)

/* harmony default export */ var instances_auditevents = __webpack_exports__["default"] = (auditevents_Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/configprops/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/mapKeys.js
var mapKeys = __webpack_require__("./node_modules/lodash/mapKeys.js");
var mapKeys_default = /*#__PURE__*/__webpack_require__.n(mapKeys);

// EXTERNAL MODULE: ./node_modules/lodash/toPairs.js
var toPairs = __webpack_require__("./node_modules/lodash/toPairs.js");
var toPairs_default = /*#__PURE__*/__webpack_require__.n(toPairs);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("./node_modules/lodash/isEmpty.js");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/pickBy.js
var pickBy = __webpack_require__("./node_modules/lodash/pickBy.js");
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/configprops/index.vue





var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var filterProperty = function filterProperty(needle) {
  return function (value, name) {
    return name.toString().toLowerCase().includes(needle) || value.toString().toLowerCase().includes(needle);
  };
};
var configprops_filterProperties = function filterProperties(needle, properties) {
  return pickBy_default()(properties, filterProperty(needle));
};
var filterConfigurationProperties = function filterConfigurationProperties(needle) {
  return function (propertySource) {
    if (!propertySource || !propertySource.properties) {
      return null;
    }
    return _extends({}, propertySource, {
      properties: configprops_filterProperties(needle, propertySource.properties)
    });
  };
};

function flattenBean(obj) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (Object(obj) !== obj) {
    return _defineProperty({}, prefix, obj);
  }

  if (Array.isArray(obj)) {
    if (obj.length === 0) {
      return _defineProperty({}, prefix, []);
    } else {
      return obj.map(function (value, idx) {
        return flattenBean(value, prefix + '[' + idx + ']');
      }).reduce(function (c, n) {
        return _extends({}, c, n);
      }, {});
    }
  } else {
    if (isEmpty_default()(obj)) {
      return _defineProperty({}, prefix, {});
    } else {
      return toPairs_default()(obj).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            name = _ref5[0],
            value = _ref5[1];

        return flattenBean(value, prefix ? prefix + '.' + name : name);
      }).reduce(function (c, n) {
        return _extends({}, c, n);
      }, {});
    }
  }
}

var configprops_flattenConfigurationPropertiesBeans = function flattenConfigurationPropertiesBeans(configprops) {
  var propertySources = [];
  var contextNames = Object.keys(configprops.contexts);

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = contextNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var contextName = _step.value;

      var context = configprops.contexts[contextName];
      var beanNames = Object.keys(context.beans);

      var _loop = function _loop(beanName) {
        var bean = context.beans[beanName];
        var properties = mapKeys_default()(flattenBean(bean.properties), function (value, key) {
          return bean.prefix + '.' + key;
        });
        propertySources.push({
          name: contextNames.length > 1 ? contextName + ': ' + beanName : beanName,
          properties: properties
        });
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = beanNames[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var beanName = _step2.value;

          _loop(beanName);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return propertySources;
};

/* harmony default export */ var instances_configprops = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      configprops: null,
      filter: null
    };
  },
  computed: {
    configurationPropertiesBeans: function configurationPropertiesBeans() {
      if (!this.configprops) {
        return [];
      }
      var configurationProperties = configprops_flattenConfigurationPropertiesBeans(this.configprops);
      if (!this.filter) {
        return configurationProperties;
      }
      return configurationProperties.map(filterConfigurationProperties(this.filter.toLowerCase())).filter(function (ps) {
        return ps && Object.keys(ps.properties).length > 0;
      });
    }
  },
  created: function created() {
    this.fetchConfigprops();
  },

  methods: {
    fetchConfigprops: function fetchConfigprops() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var configprops;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.error = null;
                _context.prev = 1;
                _context.next = 4;
                return _this.instance.fetchConfigprops();

              case 4:
                configprops = _context.sent;

                _this.configprops = configprops.data;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.warn('Fetching configuration properties failed:', _context.t0);
                _this.error = _context.t0;

              case 12:
                _this.hasLoaded = true;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    }
  },
  install: function install(_ref6) {
    var viewRegistry = _ref6.viewRegistry;

    viewRegistry.addView({
      name: 'instances/configprops',
      parent: 'instances',
      path: 'configprops',
      component: this,
      label: 'Configuration Properties',
      group: 'Insights',
      order: 110,
      isEnabled: function isEnabled(_ref7) {
        var instance = _ref7.instance;
        return instance.hasEndpoint('configprops');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-481fe42b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/configprops/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:{ 'is-loading' : !_vm.hasLoaded }},[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n        Fetching configuration properties failed.\n      ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.configprops)?_c('div',{staticClass:"field has-addons"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"input",attrs:{"type":"search","placeholder":"name / value filter"},domProps:{"value":(_vm.filter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.configurationPropertiesBeans),function(bean){return _c('sba-panel',{key:bean.name,attrs:{"header-sticks-below":['#navigation'],"title":bean.name}},[(Object.keys(bean.properties).length > 0)?_c('table',{staticClass:"table is-fullwidth"},_vm._l((bean.properties),function(value,name){return _c('tr',{key:((bean.name) + "-" + name)},[_c('td',{domProps:{"textContent":_vm._s(name)}}),_vm._v(" "),_c('td',{staticClass:"is-breakable",domProps:{"textContent":_vm._s(value)}})])})):_c('p',{staticClass:"is-muted"},[_vm._v("No properties set")])])})],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/configprops/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  instances_configprops,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_instances_configprops = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/details/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__("./node_modules/lodash/uniq.js");
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// EXTERNAL MODULE: ./src/main/frontend/mixins/subscribing.js
var subscribing = __webpack_require__("./src/main/frontend/mixins/subscribing.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/rxjs.js
var rxjs = __webpack_require__("./src/main/frontend/utils/rxjs.js");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("./node_modules/moment/moment.js");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/main/frontend/utils/d3.js
var d3 = __webpack_require__("./src/main/frontend/utils/d3.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/cache-chart.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var cache_chart = ({
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    drawChart: function drawChart(_data) {
      var vm = this;
      var data = _data.length === 1 ? _data.concat([_extends({}, _data[0], { timestamp: _data[0].timestamp + 1 })]) : _data;

      ///setup x and y scale
      var extent = d3["a" /* default */].extent(data, function (d) {
        return d.timestamp;
      });
      var x = d3["a" /* default */].scaleTime().range([0, vm.width]).domain(extent);

      var y = d3["a" /* default */].scaleLinear().range([vm.height, 0]).domain([0, d3["a" /* default */].max(data, function (d) {
        return d.total;
      }) * 1.05]);

      //draw areas
      var miss = vm.areas.selectAll('.cache-chart__area--miss').data([data]);
      miss.enter().append('path').merge(miss).attr('class', 'cache-chart__area--miss').attr('d', d3["a" /* default */].area().x(function (d) {
        return x(d.timestamp);
      }).y0(function (d) {
        return y(d.hit);
      }).y1(function (d) {
        return y(d.total);
      }));
      miss.exit().remove();

      var hit = vm.areas.selectAll('.cache-chart__area--hit').data([data]);
      hit.enter().append('path').merge(hit).attr('class', 'cache-chart__area--hit').attr('d', d3["a" /* default */].area().x(function (d) {
        return x(d.timestamp);
      }).y0(y(0)).y1(function (d) {
        return y(d.hit);
      }));
      hit.exit().remove();

      //draw axis
      vm.xAxis.call(d3["a" /* default */].axisBottom(x).ticks(5).tickFormat(function (d) {
        return moment_default()(d).format('HH:mm:ss');
      }));

      vm.yAxis.call(d3["a" /* default */].axisLeft(y).ticks(5).tickFormat(function (d) {
        return d <= 1000 ? d : (d / 1000).toFixed(1) + 'K';
      }));
    }
  },
  mounted: function mounted() {
    var margin = {
      top: 5,
      right: 5,
      bottom: 30,
      left: 50
    };

    this.width = this.$el.getBoundingClientRect().width - margin.left - margin.right;
    this.height = this.$el.getBoundingClientRect().height - margin.top - margin.bottom;

    this.chartLayer = d3["a" /* default */].select(this.$el.querySelector('.cache-chart__svg')).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    this.xAxis = this.chartLayer.append('g').attr('class', 'cache-chart__axis-x').attr('transform', 'translate(0,' + this.height + ')');

    this.yAxis = this.chartLayer.append('g').attr('class', 'cache-chart__axis-y').attr('stroke', null);

    this.areas = this.chartLayer.append('g');

    this.drawChart(this.data);
  },

  watch: {
    data: 'drawChart'
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d48f8f8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/cache-chart.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cache-chart"},[_c('svg',{staticClass:"cache-chart__svg"})])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/cache-chart.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/cache-chart.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  cache_chart,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var details_cache_chart = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/details-cache.vue
var details_cache__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var details_cache = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    },
    cacheName: {
      type: String,
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  components: { cacheChart: details_cache_chart },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      current: null,
      disableSize: false,
      chartData: []
    };
  },
  computed: {
    ratio: function ratio() {
      if (this.current.total > 0) {
        return (this.current.hit / this.current.total * 100).toFixed(2) + '%';
      }
      return '-';
    }
  },
  methods: {
    fetchMetrics: function fetchMetrics() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var responseHit, responseMiss, size, responsSize, hit, miss;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                responseHit = _this.instance.fetchMetric('cache.gets', { name: _this.cacheName, result: 'hit' });
                responseMiss = _this.instance.fetchMetric('cache.gets', { name: _this.cacheName, result: 'miss' });
                size = undefined;

                if (_this.disableSize) {
                  _context.next = 15;
                  break;
                }

                responsSize = _this.instance.fetchMetric('cache.size', { name: _this.cacheName });
                _context.prev = 5;
                _context.next = 8;
                return responsSize;

              case 8:
                size = _context.sent.data.measurements[0].value;
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                _this.disableSize = true;
                console.warn('Fetching cache size failed - error is ignored', _context.t0);

              case 15:
                _context.next = 17;
                return responseHit;

              case 17:
                hit = _context.sent.data.measurements[0].value;
                _context.next = 20;
                return responseMiss;

              case 20:
                miss = _context.sent.data.measurements[0].value;
                return _context.abrupt('return', {
                  hit: hit,
                  miss: miss,
                  total: hit + miss,
                  size: size
                });

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[5, 11]]);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      return Object(rxjs["u" /* timer */])(0, 2500).pipe(Object(rxjs["g" /* concatMap */])(vm.fetchMetrics)).subscribe({
        next: function next(data) {
          vm.hasLoaded = true;
          vm.current = data;
          vm.chartData.push(details_cache__extends({}, data, { timestamp: moment_default()().valueOf() }));
        },
        error: function error(_error) {
          vm.hasLoaded = true;
          console.warn('Fetching cache ' + vm.cacheName + ' metrics failed:', _error);
          vm.error = _error;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73fc0660","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-cache.vue
var details_cache_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLoaded)?_c('sba-panel',{attrs:{"title":("Cache: " + _vm.cacheName)}},[_c('div',[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching cache metrics failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.current)?_c('div',{staticClass:"level cache-current"},[_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading has-bullet has-bullet-info"},[_vm._v("Hits")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.current.hit)}})])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading has-bullet has-bullet-warning"},[_vm._v("Misses")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.current.miss)}})])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Hit ratio")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.ratio)}})])]),_vm._v(" "),(_vm.current.size)?_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Size")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.current.size)}})])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.chartData.length > 0)?_c('cache-chart',{attrs:{"data":_vm.chartData}}):_vm._e()],1)]):_vm._e()}
var details_cache_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/details-cache.vue
function details_cache_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-cache.vue")
}
/* script */


/* template */

/* template functional */
var details_cache___vue_template_functional__ = false
/* styles */
var details_cache___vue_styles__ = details_cache_injectStyle
/* scopeId */
var details_cache___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details_cache___vue_module_identifier__ = null

var details_cache_Component = Object(component_normalizer["a" /* default */])(
  details_cache,
  details_cache_render,
  details_cache_staticRenderFns,
  details_cache___vue_template_functional__,
  details_cache___vue_styles__,
  details_cache___vue_scopeId__,
  details_cache___vue_module_identifier__
)

/* harmony default export */ var details_details_cache = (details_cache_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/details-caches.vue


function details_caches__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var details_caches = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  components: { detailsCache: details_details_cache },
  data: function data() {
    return {
      caches: []
    };
  },
  methods: {
    fetchCaches: function fetchCaches() {
      var _this = this;

      return details_caches__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.instance.fetchMetric('cache.gets');

              case 2:
                response = _context.sent;
                return _context.abrupt('return', uniq_default()(response.data.availableTags.filter(function (tag) {
                  return tag.tag === 'name';
                })[0].values));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      return Object(rxjs["u" /* timer */])(0, 2500).pipe(Object(rxjs["g" /* concatMap */])(this.fetchCaches)).subscribe({
        next: function next(names) {
          vm.caches = names;
        },
        error: function error(_error) {
          console.warn('Fetching caches failed:', _error);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-707461b1","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-caches.vue
var details_caches_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.caches),function(cache){return _c('details-cache',{key:cache,attrs:{"instance":_vm.instance,"cache-name":cache}})}))}
var details_caches_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/details-caches.vue
/* script */


/* template */

/* template functional */
var details_caches___vue_template_functional__ = false
/* styles */
var details_caches___vue_styles__ = null
/* scopeId */
var details_caches___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details_caches___vue_module_identifier__ = null

var details_caches_Component = Object(component_normalizer["a" /* default */])(
  details_caches,
  details_caches_render,
  details_caches_staticRenderFns,
  details_caches___vue_template_functional__,
  details_caches___vue_styles__,
  details_caches___vue_scopeId__,
  details_caches___vue_module_identifier__
)

/* harmony default export */ var details_details_caches = (details_caches_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/datasource-chart.vue
var datasource_chart__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var datasource_chart = ({
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    drawChart: function drawChart(_data) {
      var vm = this;
      var data = _data.length === 1 ? _data.concat([datasource_chart__extends({}, _data[0], { timestamp: _data[0].timestamp + 1 })]) : _data;

      ///setup x and y scale
      var extent = d3["a" /* default */].extent(data, function (d) {
        return d.timestamp;
      });
      var x = d3["a" /* default */].scaleTime().range([0, vm.width]).domain(extent);

      var y = d3["a" /* default */].scaleLinear().range([vm.height, 0]).domain([0, d3["a" /* default */].max(data, function (d) {
        return d.active;
      }) * 1.05]);

      //draw max
      var max = vm.areas.selectAll('.datasource-chart__line--max').data([data]);
      max.enter().append('path').merge(max).attr('class', 'datasource-chart__line--max').attr('d', d3["a" /* default */].line().x(function (d) {
        return x(d.timestamp);
      }).y(function (d) {
        return y(d.max);
      }));
      max.exit().remove();

      //draw areas
      var active = vm.areas.selectAll('.datasource-chart__area--active').data([data]);
      active.enter().append('path').merge(active).attr('class', 'datasource-chart__area--active').attr('d', d3["a" /* default */].area().x(function (d) {
        return x(d.timestamp);
      }).y0(y(0)).y1(function (d) {
        return y(d.active);
      }));
      active.exit().remove();

      //draw axis
      vm.xAxis.call(d3["a" /* default */].axisBottom(x).ticks(5).tickFormat(function (d) {
        return moment_default()(d).format('HH:mm:ss');
      }));

      vm.yAxis.call(d3["a" /* default */].axisLeft(y).ticks(5));
    }
  },
  mounted: function mounted() {
    var margin = {
      top: 5,
      right: 5,
      bottom: 30,
      left: 50
    };

    this.width = this.$el.getBoundingClientRect().width - margin.left - margin.right;
    this.height = this.$el.getBoundingClientRect().height - margin.top - margin.bottom;

    this.chartLayer = d3["a" /* default */].select(this.$el.querySelector('.datasource-chart__svg')).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    this.xAxis = this.chartLayer.append('g').attr('class', 'datasource-chart__axis-x').attr('transform', 'translate(0,' + this.height + ')');

    this.yAxis = this.chartLayer.append('g').attr('class', 'datasource-chart__axis-y').attr('stroke', null);

    this.areas = this.chartLayer.append('g');

    this.drawChart(this.data);
  },

  watch: {
    data: 'drawChart'
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5239a037","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/datasource-chart.vue
var datasource_chart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datasource-chart"},[_c('svg',{staticClass:"datasource-chart__svg"})])}
var datasource_chart_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/datasource-chart.vue
function datasource_chart_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/datasource-chart.vue")
}
/* script */


/* template */

/* template functional */
var datasource_chart___vue_template_functional__ = false
/* styles */
var datasource_chart___vue_styles__ = datasource_chart_injectStyle
/* scopeId */
var datasource_chart___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasource_chart___vue_module_identifier__ = null

var datasource_chart_Component = Object(component_normalizer["a" /* default */])(
  datasource_chart,
  datasource_chart_render,
  datasource_chart_staticRenderFns,
  datasource_chart___vue_template_functional__,
  datasource_chart___vue_styles__,
  datasource_chart___vue_scopeId__,
  datasource_chart___vue_module_identifier__
)

/* harmony default export */ var details_datasource_chart = (datasource_chart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/details-datasource.vue
var details_datasource__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function details_datasource__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var details_datasource = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    },
    dataSource: {
      type: String,
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  components: { datasourceChart: details_datasource_chart },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      current: null,
      chartData: []
    };
  },
  methods: {
    fetchMetrics: function fetchMetrics() {
      var _this = this;

      return details_datasource__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var responseActive, responseMin, responseMax;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                responseActive = _this.instance.fetchMetric('data.source.active.connections', { name: _this.dataSource });
                responseMin = _this.instance.fetchMetric('data.source.min.connections', { name: _this.dataSource });
                responseMax = _this.instance.fetchMetric('data.source.max.connections', { name: _this.dataSource });
                _context.next = 5;
                return responseActive;

              case 5:
                _context.t0 = _context.sent.data.measurements[0].value;
                _context.next = 8;
                return responseMin;

              case 8:
                _context.t1 = _context.sent.data.measurements[0].value;
                _context.next = 11;
                return responseMax;

              case 11:
                _context.t2 = _context.sent.data.measurements[0].value;
                return _context.abrupt('return', {
                  active: _context.t0,
                  min: _context.t1,
                  max: _context.t2
                });

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      return Object(rxjs["u" /* timer */])(0, 2500).pipe(Object(rxjs["g" /* concatMap */])(vm.fetchMetrics)).subscribe({
        next: function next(data) {
          vm.hasLoaded = true;
          vm.current = data;
          vm.chartData.push(details_datasource__extends({}, data, { timestamp: moment_default()().valueOf() }));
        },
        error: function error(_error) {
          vm.hasLoaded = true;
          console.warn('Fetching datasource ' + vm.dataSource + ' metrics failed:', _error);
          vm.error = _error;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-331ad766","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-datasource.vue
var details_datasource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLoaded)?_c('sba-panel',{attrs:{"title":("Datasource: " + _vm.dataSource)}},[_c('div',[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching datasource metrics failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.current)?_c('div',{staticClass:"level datasource-current"},[_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading has-bullet has-bullet-info"},[_vm._v("Active connections")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.current.active)}})])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Min connections")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.current.min)}})])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Max connections")]),_vm._v(" "),(_vm.current.max >= 0)?_c('p',{domProps:{"textContent":_vm._s(_vm.current.max)}}):_c('p',[_vm._v("unlimited")])])])]):_vm._e(),_vm._v(" "),(_vm.chartData.length > 0)?_c('datasource-chart',{attrs:{"data":_vm.chartData}}):_vm._e()],1)]):_vm._e()}
var details_datasource_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/details-datasource.vue
function details_datasource_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-datasource.vue")
}
/* script */


/* template */

/* template functional */
var details_datasource___vue_template_functional__ = false
/* styles */
var details_datasource___vue_styles__ = details_datasource_injectStyle
/* scopeId */
var details_datasource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details_datasource___vue_module_identifier__ = null

var details_datasource_Component = Object(component_normalizer["a" /* default */])(
  details_datasource,
  details_datasource_render,
  details_datasource_staticRenderFns,
  details_datasource___vue_template_functional__,
  details_datasource___vue_styles__,
  details_datasource___vue_scopeId__,
  details_datasource___vue_module_identifier__
)

/* harmony default export */ var details_details_datasource = (details_datasource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/details-datasources.vue
function details_datasources__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var details_datasources = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  components: { detailsDatasource: details_details_datasource },
  data: function data() {
    return {
      dataSources: []
    };
  },
  methods: {
    fetchDataSources: function fetchDataSources() {
      var _this = this;

      return details_datasources__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.instance.fetchMetric('data.source.active.connections');

              case 2:
                response = _context.sent;
                return _context.abrupt('return', response.data.availableTags.filter(function (tag) {
                  return tag.tag === 'name';
                })[0].values);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      return Object(rxjs["u" /* timer */])(0, 2500).pipe(Object(rxjs["g" /* concatMap */])(this.fetchDataSources)).subscribe({
        next: function next(names) {
          vm.dataSources = names;
        },
        error: function error(_error) {
          console.warn('Fetching datasources failed:', _error);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5fd4ef6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-datasources.vue
var details_datasources_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.dataSources),function(dataSource){return _c('details-datasource',{key:dataSource,attrs:{"instance":_vm.instance,"data-source":dataSource}})}))}
var details_datasources_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/details-datasources.vue
/* script */


/* template */

/* template functional */
var details_datasources___vue_template_functional__ = false
/* styles */
var details_datasources___vue_styles__ = null
/* scopeId */
var details_datasources___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details_datasources___vue_module_identifier__ = null

var details_datasources_Component = Object(component_normalizer["a" /* default */])(
  details_datasources,
  details_datasources_render,
  details_datasources_staticRenderFns,
  details_datasources___vue_template_functional__,
  details_datasources___vue_styles__,
  details_datasources___vue_scopeId__,
  details_datasources___vue_module_identifier__
)

/* harmony default export */ var details_details_datasources = (details_datasources_Component.exports);

// EXTERNAL MODULE: ./src/main/frontend/views/instances/metrics/metric.vue + 2 modules
var metric = __webpack_require__("./src/main/frontend/views/instances/metrics/metric.vue");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/details-gc.vue
var details_gc__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function details_gc__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var details_gc = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      current: null
    };
  },
  methods: {
    fetchMetrics: function fetchMetrics() {
      var _this = this;

      return details_gc__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, measurements;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.instance.fetchMetric('jvm.gc.pause');

              case 2:
                response = _context.sent;
                measurements = response.data.measurements.reduce(function (current, measurement) {
                  return details_gc__extends({}, current, _defineProperty({}, measurement.statistic.toLowerCase(), measurement.value));
                }, {});
                return _context.abrupt('return', details_gc__extends({}, measurements, {
                  total_time: moment_default.a.duration(Object(metric["b" /* toMillis */])(measurements.total_time, response.baseUnit)),
                  max: moment_default.a.duration(Object(metric["b" /* toMillis */])(measurements.max, response.baseUnit))
                }));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      return Object(rxjs["u" /* timer */])(0, 2500).pipe(Object(rxjs["g" /* concatMap */])(this.fetchMetrics)).subscribe({
        next: function next(data) {
          vm.hasLoaded = true;
          vm.current = data;
        },
        error: function error(_error) {
          vm.hasLoaded = true;
          console.warn('Fetching GC metrics failed:', _error);
          vm.error = _error;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0974c34c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-gc.vue
var details_gc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLoaded)?_c('sba-panel',{attrs:{"title":"Garbage Collection Pauses"}},[_c('div',[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching GC metrics failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.current)?_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Count")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.current.count)}})])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Total time spent")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(((_vm.current.total_time.asSeconds().toFixed(4)) + "s"))}})])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Max time spent")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(((_vm.current.max.asSeconds().toFixed(4)) + "s"))}})])])]):_vm._e()])]):_vm._e()}
var details_gc_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/details-gc.vue
/* script */


/* template */

/* template functional */
var details_gc___vue_template_functional__ = false
/* styles */
var details_gc___vue_styles__ = null
/* scopeId */
var details_gc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details_gc___vue_module_identifier__ = null

var details_gc_Component = Object(component_normalizer["a" /* default */])(
  details_gc,
  details_gc_render,
  details_gc_staticRenderFns,
  details_gc___vue_template_functional__,
  details_gc___vue_styles__,
  details_gc___vue_scopeId__,
  details_gc___vue_module_identifier__
)

/* harmony default export */ var details_details_gc = (details_gc_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/entries.js
var entries = __webpack_require__("./node_modules/lodash/entries.js");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/pretty-bytes/index.js
var pretty_bytes = __webpack_require__("./node_modules/pretty-bytes/index.js");
var pretty_bytes_default = /*#__PURE__*/__webpack_require__.n(pretty_bytes);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/health-details.vue
 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var isChildHealth = function isChildHealth(value) {
  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.hasOwnProperty('status');
};

/* harmony default export */ var health_details = ({
  name: 'HealthDetails',
  props: {
    name: {
      type: String,
      required: true
    },
    health: {
      type: Object,
      required: true
    }
  },
  methods: {
    prettyBytes: pretty_bytes_default.a
  },
  computed: {
    details: function details() {
      if (this.health.details) {
        return entries_default()(this.health.details).filter(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              value = _ref2[1];

          return !isChildHealth(value);
        }).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              name = _ref4[0],
              value = _ref4[1];

          return { name: name, value: value };
        });
      }
      return [];
    },
    childHealth: function childHealth() {
      if (this.health.details) {
        return entries_default()(this.health.details).filter(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
              value = _ref6[1];

          return isChildHealth(value);
        }).map(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
              name = _ref8[0],
              value = _ref8[1];

          return { name: name, value: value };
        });
      }
      return [];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fbdda68","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/health-details.vue
var health_details_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"health-details table is-fullwidth"},[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('span',{domProps:{"textContent":_vm._s(_vm.name)}}),_vm._v(" "),_c('span',{staticClass:"health-details__status",class:("health-details__status--" + (_vm.health.status)),domProps:{"textContent":_vm._s(_vm.health.status)}})])]),_vm._v(" "),(_vm.details && _vm.details.length > 0)?_c('tr',[_c('td',{staticClass:"health-details__nested",attrs:{"colspan":"2"}},[_c('table',{staticClass:"health-details table is-fullwidth"},_vm._l((_vm.details),function(detail){return _c('tr',{key:detail.name,staticClass:"health-details__detail"},[_c('td',{domProps:{"textContent":_vm._s(detail.name)}}),_vm._v(" "),(_vm.name === 'diskSpace')?_c('td',{domProps:{"textContent":_vm._s(_vm.prettyBytes(detail.value))}}):_c('td',{staticClass:"is-breakable",domProps:{"textContent":_vm._s(detail.value)}})])}))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.childHealth),function(child){return _c('tr',{key:child.name},[_c('td',{staticClass:"health-details__nested",attrs:{"colspan":"2"}},[_c('health-details',{attrs:{"name":child.name,"health":child.value}})],1)])})],2)}
var health_details_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/health-details.vue
function health_details_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/health-details.vue")
}
/* script */


/* template */

/* template functional */
var health_details___vue_template_functional__ = false
/* styles */
var health_details___vue_styles__ = health_details_injectStyle
/* scopeId */
var health_details___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var health_details___vue_module_identifier__ = null

var health_details_Component = Object(component_normalizer["a" /* default */])(
  health_details,
  health_details_render,
  health_details_staticRenderFns,
  health_details___vue_template_functional__,
  health_details___vue_styles__,
  health_details___vue_scopeId__,
  health_details___vue_module_identifier__
)

/* harmony default export */ var details_health_details = (health_details_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/details-health.vue
function details_health__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var details_health = ({
  components: { healthDetails: details_health_details },
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  data: function data() {
    return {
      error: null,
      liveHealth: null
    };
  },
  created: function created() {
    this.fetchHealth();
  },

  computed: {
    health: function health() {
      return this.liveHealth || this.instance.statusInfo;
    }
  },
  methods: {
    fetchHealth: function fetchHealth() {
      var _this = this;

      return details_health__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.error = null;
                _context.prev = 1;
                _context.next = 4;
                return _this.instance.fetchHealth();

              case 4:
                res = _context.sent;

                _this.liveHealth = res.data;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.warn('Fetching live health failed:', _context.t0);
                _this.error = _context.t0;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc34484c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-health.vue
var details_health_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sba-panel',{attrs:{"title":"Health"}},[_c('div',[(_vm.error)?_c('div',{staticClass:"message is-warning"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-warning",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching live health status failed. This is the last known information.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),_c('health-details',{attrs:{"name":"Instance","health":_vm.health}})],1)])}
var details_health_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/details-health.vue
/* script */


/* template */

/* template functional */
var details_health___vue_template_functional__ = false
/* styles */
var details_health___vue_styles__ = null
/* scopeId */
var details_health___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details_health___vue_module_identifier__ = null

var details_health_Component = Object(component_normalizer["a" /* default */])(
  details_health,
  details_health_render,
  details_health_staticRenderFns,
  details_health___vue_template_functional__,
  details_health___vue_styles__,
  details_health___vue_scopeId__,
  details_health___vue_module_identifier__
)

/* harmony default export */ var details_details_health = (details_health_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/details-info.vue
function details_info__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var details_info = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  data: function data() {
    return {
      error: null,
      liveInfo: null
    };
  },
  computed: {
    info: function info() {
      return this.liveInfo || this.instance.info;
    },
    isEmptyInfo: function isEmptyInfo() {
      return Object.keys(this.info).length <= 0;
    }
  },
  created: function created() {
    this.fetchInfo();
  },

  methods: {
    fetchInfo: function fetchInfo() {
      var _this = this;

      return details_info__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.instance.hasEndpoint('info')) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 1;

                _this.error = null;
                _context.next = 5;
                return _this.instance.fetchInfo();

              case 5:
                res = _context.sent;

                _this.liveInfo = res.data;
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                _this.error = _context.t0;
                console.warn('Fetching info failed:', _context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acb3b7de","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-info.vue
var details_info_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sba-panel',{attrs:{"title":"Info"}},[_c('div',[(_vm.error)?_c('div',{staticClass:"message is-warning"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-warning",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching live info failed. This is the last known information.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content info"},[(!_vm.isEmptyInfo)?_c('table',{staticClass:"table"},_vm._l((_vm.info),function(value,key){return _c('tr',{key:key},[_c('td',{staticClass:"info__key",domProps:{"textContent":_vm._s(key)}}),_vm._v(" "),_c('td',[_c('sba-formatted-obj',{attrs:{"value":value}})],1)])})):_c('p',{staticClass:"is-muted"},[_vm._v("No info provided.")])])])])}
var details_info_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/details-info.vue
function details_info_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-info.vue")
}
/* script */


/* template */

/* template functional */
var details_info___vue_template_functional__ = false
/* styles */
var details_info___vue_styles__ = details_info_injectStyle
/* scopeId */
var details_info___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details_info___vue_module_identifier__ = null

var details_info_Component = Object(component_normalizer["a" /* default */])(
  details_info,
  details_info_render,
  details_info_staticRenderFns,
  details_info___vue_template_functional__,
  details_info___vue_styles__,
  details_info___vue_scopeId__,
  details_info___vue_module_identifier__
)

/* harmony default export */ var details_details_info = (details_info_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/mem-chart.vue
var mem_chart__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var mem_chart = ({
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    drawChart: function drawChart(_data) {
      var vm = this;
      var data = _data.length === 1 ? _data.concat([mem_chart__extends({}, _data[0], { timestamp: _data[0].timestamp + 1 })]) : _data;

      ///setup x and y scale
      var extent = d3["a" /* default */].extent(data, function (d) {
        return d.timestamp;
      });
      var x = d3["a" /* default */].scaleTime().range([0, vm.width]).domain(extent);

      var y = d3["a" /* default */].scaleLinear().range([vm.height, 0]).domain([0, d3["a" /* default */].max(data, function (d) {
        return d.committed;
      }) * 1.05]);

      //draw max
      var max = vm.areas.selectAll('.mem-chart__line--max').data([data]);
      max.enter().append('path').merge(max).attr('class', 'mem-chart__line--max').attr('d', d3["a" /* default */].line().x(function (d) {
        return x(d.timestamp);
      }).y(function (d) {
        return y(d.max);
      }));
      max.exit().remove();

      //draw areas
      var committed = vm.areas.selectAll('.mem-chart__area--committed').data([data]);
      committed.enter().append('path').merge(committed).attr('class', 'mem-chart__area--committed').attr('d', d3["a" /* default */].area().x(function (d) {
        return x(d.timestamp);
      }).y0(function (d) {
        return y(d.used);
      }).y1(function (d) {
        return y(d.committed);
      }));
      committed.exit().remove();

      var used = vm.areas.selectAll('.mem-chart__area--used').data([data]);
      used.enter().append('path').merge(used).attr('class', 'mem-chart__area--used').attr('d', d3["a" /* default */].area().x(function (d) {
        return x(d.timestamp);
      }).y0(function (d) {
        return y(d.metaspace || 0);
      }).y1(function (d) {
        return y(d.used);
      }));
      used.exit().remove();

      var metaspace = vm.areas.selectAll('.mem-chart__area--metaspace').data([data]);
      metaspace.enter().append('path').merge(metaspace).attr('class', 'mem-chart__area--metaspace').attr('d', d3["a" /* default */].area().x(function (d) {
        return x(d.timestamp);
      }).y0(y(0)).y1(function (d) {
        return y(d.metaspace);
      }));
      metaspace.exit().remove();

      //draw axis
      vm.xAxis.call(d3["a" /* default */].axisBottom(x).ticks(5).tickFormat(function (d) {
        return moment_default()(d).format('HH:mm:ss');
      }));

      vm.yAxis.call(d3["a" /* default */].axisLeft(y).ticks(5).tickFormat(pretty_bytes_default.a));
    }
  },
  mounted: function mounted() {
    var margin = {
      top: 5,
      right: 5,
      bottom: 30,
      left: 50
    };

    this.width = this.$el.getBoundingClientRect().width - margin.left - margin.right;
    this.height = this.$el.getBoundingClientRect().height - margin.top - margin.bottom;

    this.chartLayer = d3["a" /* default */].select(this.$el.querySelector('.mem-chart__svg')).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    this.xAxis = this.chartLayer.append('g').attr('class', 'mem-chart__axis-x').attr('transform', 'translate(0,' + this.height + ')');

    this.yAxis = this.chartLayer.append('g').attr('class', 'mem-chart__axis-y').attr('stroke', null);

    this.areas = this.chartLayer.append('g');

    this.drawChart(this.data);
  },

  watch: {
    data: 'drawChart'
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fef4e56","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/mem-chart.vue
var mem_chart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mem-chart"},[_c('svg',{staticClass:"mem-chart__svg"})])}
var mem_chart_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/mem-chart.vue
function mem_chart_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/mem-chart.vue")
}
/* script */


/* template */

/* template functional */
var mem_chart___vue_template_functional__ = false
/* styles */
var mem_chart___vue_styles__ = mem_chart_injectStyle
/* scopeId */
var mem_chart___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mem_chart___vue_module_identifier__ = null

var mem_chart_Component = Object(component_normalizer["a" /* default */])(
  mem_chart,
  mem_chart_render,
  mem_chart_staticRenderFns,
  mem_chart___vue_template_functional__,
  mem_chart___vue_styles__,
  mem_chart___vue_scopeId__,
  mem_chart___vue_module_identifier__
)

/* harmony default export */ var details_mem_chart = (mem_chart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/details-memory.vue
var details_memory__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function details_memory__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var details_memory = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  components: { memChart: details_mem_chart },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      current: null,
      chartData: []
    };
  },
  computed: {
    name: function name() {
      switch (this.type) {
        case 'heap':
          return 'Heap';
        case 'nonheap':
          return 'Non heap';
        default:
          return this.type;
      }
    }
  },
  methods: {
    prettyBytes: pretty_bytes_default.a,
    fetchMetrics: function fetchMetrics() {
      var _this = this;

      return details_memory__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var responseMax, responseUsed, responeMetaspace, responseCommitted;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                responseMax = _this.instance.fetchMetric('jvm.memory.max', { area: _this.type });
                responseUsed = _this.instance.fetchMetric('jvm.memory.used', { area: _this.type });
                responeMetaspace = _this.type === 'nonheap' ? _this.instance.fetchMetric('jvm.memory.used', { area: _this.type, id: 'Metaspace' }) : null;
                responseCommitted = _this.instance.fetchMetric('jvm.memory.committed', { area: _this.type });
                _context.next = 6;
                return responseMax;

              case 6:
                _context.t0 = _context.sent.data.measurements[0].value;
                _context.next = 9;
                return responseUsed;

              case 9:
                _context.t1 = _context.sent.data.measurements[0].value;

                if (!responeMetaspace) {
                  _context.next = 16;
                  break;
                }

                _context.next = 13;
                return responeMetaspace;

              case 13:
                _context.t2 = _context.sent.data.measurements[0].value;
                _context.next = 17;
                break;

              case 16:
                _context.t2 = null;

              case 17:
                _context.t3 = _context.t2;
                _context.next = 20;
                return responseCommitted;

              case 20:
                _context.t4 = _context.sent.data.measurements[0].value;
                return _context.abrupt('return', {
                  max: _context.t0,
                  used: _context.t1,
                  metaspace: _context.t3,
                  committed: _context.t4
                });

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      return Object(rxjs["u" /* timer */])(0, 2500).pipe(Object(rxjs["g" /* concatMap */])(this.fetchMetrics)).subscribe({
        next: function next(data) {
          vm.hasLoaded = true;
          vm.current = data;
          vm.chartData.push(details_memory__extends({}, data, { timestamp: moment_default()().valueOf() }));
        },
        error: function error(_error) {
          vm.hasLoaded = true;
          console.warn('Fetching memory metrics failed:', _error);
          vm.error = _error;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a59a18a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-memory.vue
var details_memory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLoaded)?_c('sba-panel',{attrs:{"title":("Memory: " + _vm.name)}},[_c('div',[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching memory metrics failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.current)?_c('div',{staticClass:"level memory-current"},[(_vm.current.metaspace)?_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading has-bullet has-bullet-primary"},[_vm._v("Metaspace")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.prettyBytes(_vm.current.metaspace))}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading has-bullet has-bullet-info"},[_vm._v("Used")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.prettyBytes(_vm.current.used))}})])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading has-bullet has-bullet-warning"},[_vm._v("Size")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.prettyBytes(_vm.current.committed))}})])]),_vm._v(" "),(_vm.current.max >= 0)?_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Max")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.prettyBytes(_vm.current.max))}})])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.chartData.length > 0)?_c('mem-chart',{attrs:{"data":_vm.chartData}}):_vm._e()],1)]):_vm._e()}
var details_memory_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/details-memory.vue
function details_memory_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-memory.vue")
}
/* script */


/* template */

/* template functional */
var details_memory___vue_template_functional__ = false
/* styles */
var details_memory___vue_styles__ = details_memory_injectStyle
/* scopeId */
var details_memory___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details_memory___vue_module_identifier__ = null

var details_memory_Component = Object(component_normalizer["a" /* default */])(
  details_memory,
  details_memory_render,
  details_memory_staticRenderFns,
  details_memory___vue_template_functional__,
  details_memory___vue_styles__,
  details_memory___vue_scopeId__,
  details_memory___vue_module_identifier__
)

/* harmony default export */ var details_details_memory = (details_memory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/details-metadata.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var details_metadata = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  computed: {
    metadata: function metadata() {
      return this.instance.registration.metadata;
    },
    isEmptyMetadata: function isEmptyMetadata() {
      return Object.keys(this.metadata).length <= 0;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10047e3d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-metadata.vue
var details_metadata_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sba-panel',{attrs:{"title":"Metadata"}},[(_vm.metadata)?_c('div',{staticClass:"content metadata"},[(!_vm.isEmptyMetadata)?_c('table',{staticClass:"table"},_vm._l((_vm.metadata),function(value,key){return _c('tr',{key:key},[_c('td',{staticClass:"metadata__key",domProps:{"textContent":_vm._s(key)}}),_vm._v(" "),_c('td',[_c('sba-formatted-obj',{attrs:{"value":value}})],1)])})):_c('p',{staticClass:"is-muted"},[_vm._v("No metadata provided.")])]):_vm._e()])}
var details_metadata_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/details-metadata.vue
function details_metadata_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-metadata.vue")
}
/* script */


/* template */

/* template functional */
var details_metadata___vue_template_functional__ = false
/* styles */
var details_metadata___vue_styles__ = details_metadata_injectStyle
/* scopeId */
var details_metadata___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details_metadata___vue_module_identifier__ = null

var details_metadata_Component = Object(component_normalizer["a" /* default */])(
  details_metadata,
  details_metadata_render,
  details_metadata_staticRenderFns,
  details_metadata___vue_template_functional__,
  details_metadata___vue_styles__,
  details_metadata___vue_scopeId__,
  details_metadata___vue_module_identifier__
)

/* harmony default export */ var details_details_metadata = (details_metadata_Component.exports);

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/process-uptime.js
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ var process_uptime = ({
  props: ['value'],
  mixins: [subscribing["a" /* default */]],
  data: function data() {
    return {
      startTs: null,
      offset: null
    };
  },
  render: function render() {
    return this._v(this.clock);
  },

  computed: {
    clock: function clock() {
      if (!this.value) {
        return null;
      }
      var duration = moment_default.a.duration(this.value + this.offset);
      return Math.floor(duration.asDays()) + 'd ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's';
    }
  },
  watch: {
    value: 'subscribe'
  },
  methods: {
    createSubscription: function createSubscription() {
      if (this.value) {
        var vm = this;
        vm.startTs = moment_default()();
        vm.offset = 0;
        return Object(rxjs["u" /* timer */])(0, 1000).subscribe({
          next: function next() {
            vm.offset = moment_default()().valueOf() - vm.startTs.valueOf();
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/details-process.vue
function details_process__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var details_process = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  components: { processUptime: process_uptime },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      pid: null,
      uptime: { value: null, baseUnit: null },
      systemCpuLoad: null,
      processCpuLoad: null,
      systemCpuCount: null
    };
  },
  created: function created() {
    this.fetchPid();
    this.fetchUptime();
    this.fetchCpuCount();
  },

  methods: {
    toMillis: metric["b" /* toMillis */],
    fetchUptime: function fetchUptime() {
      var _this = this;

      return details_process__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.fetchMetric('process.uptime');

              case 3:
                response = _context.sent;

                _this.uptime = { value: response.measurements[0].value, baseUnit: response.baseUnit };
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                _this.error = _context.t0;
                console.warn('Fetching Uptime failed:', _context.t0);

              case 11:
                _this.hasLoaded = true;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    fetchPid: function fetchPid() {
      var _this2 = this;

      return details_process__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.instance.hasEndpoint('env')) {
                  _context2.next = 12;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return _this2.instance.fetchEnv('PID');

              case 4:
                response = _context2.sent;

                _this2.pid = response.data.property.value;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                console.warn('Fetching PID failed:', _context2.t0);

              case 11:
                _this2.hasLoaded = true;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8]]);
      }))();
    },
    fetchCpuCount: function fetchCpuCount() {
      var _this3 = this;

      return details_process__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this3.fetchMetric('system.cpu.count');

              case 3:
                _this3.systemCpuCount = _context3.sent.measurements[0].value;
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](0);

                console.warn('Fetching Cpu Count failed:', _context3.t0);

              case 9:
                _this3.hasLoaded = true;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 6]]);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      return Object(rxjs["u" /* timer */])(0, 2500).pipe(Object(rxjs["g" /* concatMap */])(this.fetchCpuLoadMetrics)).subscribe({
        next: function next(data) {
          vm.processCpuLoad = data.processCpuLoad;
          vm.systemCpuLoad = data.systemCpuLoad;
        },
        error: function error(_error) {
          vm.hasLoaded = true;
          console.warn('Fetching CPU Usage metrics failed:', _error);
          vm.error = _error;
        }
      });
    },
    fetchCpuLoadMetrics: function fetchCpuLoadMetrics() {
      var _this4 = this;

      return details_process__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var fetchProcessCpuLoad, fetchSystemCpuLoad, processCpuLoad, systemCpuLoad;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fetchProcessCpuLoad = _this4.fetchMetric('process.cpu.usage');
                fetchSystemCpuLoad = _this4.fetchMetric('system.cpu.usage');
                processCpuLoad = void 0;
                systemCpuLoad = void 0;
                _context4.prev = 4;
                _context4.next = 7;
                return fetchProcessCpuLoad;

              case 7:
                processCpuLoad = _context4.sent.measurements[0].value;
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](4);

                console.warn('Fetching Process CPU Load failed:', _context4.t0);

              case 13:
                _context4.prev = 13;
                _context4.next = 16;
                return fetchSystemCpuLoad;

              case 16:
                systemCpuLoad = _context4.sent.measurements[0].value;
                _context4.next = 22;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t1 = _context4['catch'](13);

                console.warn('Fetching Sytem CPU Load failed:', _context4.t1);

              case 22:
                return _context4.abrupt('return', {
                  processCpuLoad: processCpuLoad,
                  systemCpuLoad: systemCpuLoad
                });

              case 23:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[4, 10], [13, 19]]);
      }))();
    },
    fetchMetric: function fetchMetric(name) {
      var _this5 = this;

      return details_process__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.instance.fetchMetric(name);

              case 2:
                response = _context5.sent;
                return _context5.abrupt('return', response.data);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43af8f3c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-process.vue
var details_process_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLoaded)?_c('sba-panel',{attrs:{"title":"Process"}},[_c('div',[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching process metrics failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"level"},[(_vm.pid)?_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("PID")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.pid)}})])]):_vm._e(),_vm._v(" "),(_vm.uptime)?_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Uptime")]),_vm._v(" "),_c('p',[_c('process-uptime',{attrs:{"value":_vm.toMillis(_vm.uptime.value, _vm.uptime.baseUnit)}})],1)])]):_vm._e(),_vm._v(" "),(_vm.processCpuLoad)?_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Process CPU Usage")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.processCpuLoad.toFixed(2))}})])]):_vm._e(),_vm._v(" "),(_vm.systemCpuLoad)?_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("System CPU Usage")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.systemCpuLoad.toFixed(2))}})])]):_vm._e(),_vm._v(" "),(_vm.systemCpuCount)?_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("CPUs")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.systemCpuCount)}})])]):_vm._e()])])]):_vm._e()}
var details_process_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/details-process.vue
/* script */


/* template */

/* template functional */
var details_process___vue_template_functional__ = false
/* styles */
var details_process___vue_styles__ = null
/* scopeId */
var details_process___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details_process___vue_module_identifier__ = null

var details_process_Component = Object(component_normalizer["a" /* default */])(
  details_process,
  details_process_render,
  details_process_staticRenderFns,
  details_process___vue_template_functional__,
  details_process___vue_styles__,
  details_process___vue_scopeId__,
  details_process___vue_module_identifier__
)

/* harmony default export */ var details_details_process = (details_process_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/threads-chart.vue
var threads_chart__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var threads_chart = ({
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    drawChart: function drawChart(_data) {
      var vm = this;
      var data = _data.length === 1 ? _data.concat([threads_chart__extends({}, _data[0], { timestamp: _data[0].timestamp + 1 })]) : _data;

      ///setup x and y scale
      var extent = d3["a" /* default */].extent(data, function (d) {
        return d.timestamp;
      });
      var x = d3["a" /* default */].scaleTime().range([0, vm.width]).domain(extent);

      var y = d3["a" /* default */].scaleLinear().range([vm.height, 0]).domain([0, d3["a" /* default */].max(data, function (d) {
        return d.live;
      }) * 1.05]);

      //draw max
      var live = vm.areas.selectAll('.threads-chart__area--live').data([data]);
      live.enter().append('path').merge(live).attr('class', 'threads-chart__area--live').attr('d', d3["a" /* default */].area().x(function (d) {
        return x(d.timestamp);
      }).y0(function (d) {
        return y(d.daemon);
      }).y1(function (d) {
        return y(d.live);
      }));
      live.exit().remove();

      //draw areas
      var daemon = vm.areas.selectAll('.threads-chart__area--daemon').data([data]);
      daemon.enter().append('path').merge(daemon).attr('class', 'threads-chart__area--daemon').attr('d', d3["a" /* default */].area().x(function (d) {
        return x(d.timestamp);
      }).y0(y(0)).y1(function (d) {
        return y(d.daemon);
      }));
      daemon.exit().remove();

      //draw axis
      vm.xAxis.call(d3["a" /* default */].axisBottom(x).ticks(5).tickFormat(function (d) {
        return moment_default()(d).format('HH:mm:ss');
      }));

      vm.yAxis.call(d3["a" /* default */].axisLeft(y).ticks(5));
    }
  },
  mounted: function mounted() {
    var margin = {
      top: 5,
      right: 5,
      bottom: 30,
      left: 50
    };

    this.width = this.$el.getBoundingClientRect().width - margin.left - margin.right;
    this.height = this.$el.getBoundingClientRect().height - margin.top - margin.bottom;

    this.chartLayer = d3["a" /* default */].select(this.$el.querySelector('.threads-chart__svg')).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    this.xAxis = this.chartLayer.append('g').attr('class', 'threads-chart__axis-x').attr('transform', 'translate(0,' + this.height + ')');

    this.yAxis = this.chartLayer.append('g').attr('class', 'threads-chart__axis-y').attr('stroke', null);

    this.areas = this.chartLayer.append('g');

    this.drawChart(this.data);
  },

  watch: {
    data: 'drawChart'
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37fde388","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/threads-chart.vue
var threads_chart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"threads-chart"},[_c('svg',{staticClass:"threads-chart__svg"})])}
var threads_chart_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/threads-chart.vue
function threads_chart_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/threads-chart.vue")
}
/* script */


/* template */

/* template functional */
var threads_chart___vue_template_functional__ = false
/* styles */
var threads_chart___vue_styles__ = threads_chart_injectStyle
/* scopeId */
var threads_chart___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var threads_chart___vue_module_identifier__ = null

var threads_chart_Component = Object(component_normalizer["a" /* default */])(
  threads_chart,
  threads_chart_render,
  threads_chart_staticRenderFns,
  threads_chart___vue_template_functional__,
  threads_chart___vue_styles__,
  threads_chart___vue_scopeId__,
  threads_chart___vue_module_identifier__
)

/* harmony default export */ var details_threads_chart = (threads_chart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/details-threads.vue
var details_threads__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function details_threads__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var details_threads = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  components: { threadsChart: details_threads_chart },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      current: null,
      chartData: []
    };
  },
  methods: {
    fetchMetrics: function fetchMetrics() {
      var _this = this;

      return details_threads__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var responseLive, responsePeak, responseDaemon;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                responseLive = _this.instance.fetchMetric('jvm.threads.live');
                responsePeak = _this.instance.fetchMetric('jvm.threads.peak');
                responseDaemon = _this.instance.fetchMetric('jvm.threads.daemon');
                _context.next = 5;
                return responseLive;

              case 5:
                _context.t0 = _context.sent.data.measurements[0].value;
                _context.next = 8;
                return responsePeak;

              case 8:
                _context.t1 = _context.sent.data.measurements[0].value;
                _context.next = 11;
                return responseDaemon;

              case 11:
                _context.t2 = _context.sent.data.measurements[0].value;
                return _context.abrupt('return', {
                  live: _context.t0,
                  peak: _context.t1,
                  daemon: _context.t2
                });

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      return Object(rxjs["u" /* timer */])(0, 2500).pipe(Object(rxjs["g" /* concatMap */])(this.fetchMetrics)).subscribe({
        next: function next(data) {
          vm.hasLoaded = true;
          vm.current = data;
          vm.chartData.push(details_threads__extends({}, data, { timestamp: moment_default()().valueOf() }));
        },
        error: function error(_error) {
          vm.hasLoaded = true;
          console.warn('Fetching threads metrics failed:', _error);
          vm.error = _error;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52fea331","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-threads.vue
var details_threads_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLoaded)?_c('sba-panel',{attrs:{"title":"Threads"}},[_c('div',[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching threads metrics failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.current)?_c('div',{staticClass:"level threads-current"},[_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading has-bullet has-bullet-warning"},[_vm._v("Live")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.current.live)}})])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading  has-bullet has-bullet-info"},[_vm._v("Daemon")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.current.daemon)}})])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("Peak Live")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.current.peak)}})])])]):_vm._e(),_vm._v(" "),(_vm.chartData.length > 0)?_c('threads-chart',{attrs:{"data":_vm.chartData}}):_vm._e()],1)]):_vm._e()}
var details_threads_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/details-threads.vue
function details_threads_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/details-threads.vue")
}
/* script */


/* template */

/* template functional */
var details_threads___vue_template_functional__ = false
/* styles */
var details_threads___vue_styles__ = details_threads_injectStyle
/* scopeId */
var details_threads___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details_threads___vue_module_identifier__ = null

var details_threads_Component = Object(component_normalizer["a" /* default */])(
  details_threads,
  details_threads_render,
  details_threads_staticRenderFns,
  details_threads___vue_template_functional__,
  details_threads___vue_styles__,
  details_threads___vue_scopeId__,
  details_threads___vue_module_identifier__
)

/* harmony default export */ var details_details_threads = (details_threads_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/details/index.vue
function details__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var instances_details = ({
  components: {
    detailsHealth: details_details_health,
    detailsInfo: details_details_info,
    detailsProcess: details_details_process,
    detailsThreads: details_details_threads,
    detailsDatasources: details_details_datasources,
    detailsMemory: details_details_memory,
    detailsGc: details_details_gc,
    detailsCaches: details_details_caches,
    detailsMetadata: details_details_metadata
  },
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      metrics: []
    };
  },
  computed: {
    hasCaches: function hasCaches() {
      return this.hasMetric('cache.gets');
    },
    hasDatasources: function hasDatasources() {
      return this.hasMetric('data.source.active.connections');
    },
    hasGc: function hasGc() {
      return this.hasMetric('jvm.gc.pause');
    },
    hasInfo: function hasInfo() {
      return this.instance.hasEndpoint('info');
    },
    hasMemory: function hasMemory() {
      return this.hasMetric('jvm.memory.max');
    },
    hasProcess: function hasProcess() {
      return this.hasMetric('process.uptime');
    },
    hasThreads: function hasThreads() {
      return this.hasMetric('jvm.threads.live');
    },
    hasMetadata: function hasMetadata() {
      return this.instance.registration && this.instance.registration.metadata;
    }
  },
  created: function created() {
    this.fetchMetricIndex();
  },

  methods: {
    hasMetric: function hasMetric(metric) {
      return this.metrics && this.metrics.includes(metric);
    },
    fetchMetricIndex: function fetchMetricIndex() {
      var _this = this;

      return details__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.instance.hasEndpoint('metrics')) {
                  _context.next = 14;
                  break;
                }

                _this.error = null;
                _context.prev = 2;
                _context.next = 5;
                return _this.instance.fetchMetrics();

              case 5:
                res = _context.sent;

                _this.metrics = res.data.names;
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](2);

                console.warn('Fetching metric index failed:', _context.t0);
                _this.error = _context.t0;

              case 13:
                _this.hasLoaded = true;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 9]]);
      }))();
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      name: 'instances/details',
      parent: 'instances',
      path: 'details',
      component: this,
      label: 'Details',
      group: 'Insights',
      order: 0
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0748bbc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/index.vue
var details_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"details-header"},[(_vm.instance)?_c('h1',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.instance.registration.name)}}):_vm._e(),_vm._v(" "),(_vm.instance)?_c('h2',{staticClass:"subtitle is-5"},[_vm._v("Id: "),_c('span',{domProps:{"textContent":_vm._s(_vm.instance.id)}})]):_vm._e(),_vm._v(" "),(_vm.instance)?_c('sba-tags',{attrs:{"tags":_vm.instance.tags}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"details-header__urls"},[_c('a',{staticClass:"button is-small ",attrs:{"href":_vm.instance.registration.serviceUrl}},[_c('font-awesome-icon',{attrs:{"icon":"home"}}),_vm._v(" \n        "),_c('span',{domProps:{"textContent":_vm._s(_vm.instance.registration.serviceUrl)}})],1),_vm._v(" "),_c('a',{staticClass:"button is-small ",attrs:{"href":_vm.instance.registration.managementUrl}},[_c('font-awesome-icon',{attrs:{"icon":"wrench"}}),_vm._v(" \n        "),_c('span',{domProps:{"textContent":_vm._s(_vm.instance.registration.managementUrl)}})],1),_vm._v(" "),_c('a',{staticClass:"button is-small ",attrs:{"href":_vm.instance.registration.healthUrl}},[_c('font-awesome-icon',{attrs:{"icon":"heartbeat"}}),_vm._v(" \n        "),_c('span',{domProps:{"textContent":_vm._s(_vm.instance.registration.healthUrl)}})],1)])],1),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n        Fetching metrics index failed.\n      ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns is-desktop"},[_c('div',{staticClass:"column is-half-desktop"},[(_vm.hasInfo)?_c('details-info',{attrs:{"instance":_vm.instance}}):_vm._e(),_vm._v(" "),(_vm.hasMetadata)?_c('details-metadata',{attrs:{"instance":_vm.instance}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"column is-half-desktop"},[_c('details-health',{attrs:{"instance":_vm.instance}})],1)]),_vm._v(" "),_c('div',{staticClass:"columns is-desktop"},[_c('div',{staticClass:"column is-half-desktop"},[(_vm.hasProcess)?_c('details-process',{attrs:{"instance":_vm.instance}}):_vm._e(),_vm._v(" "),(_vm.hasGc)?_c('details-gc',{attrs:{"instance":_vm.instance}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"column is-half-desktop"},[(_vm.hasThreads)?_c('details-threads',{attrs:{"instance":_vm.instance}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"columns is-desktop"},[_c('div',{staticClass:"column is-half-desktop"},[(_vm.hasMemory)?_c('details-memory',{attrs:{"instance":_vm.instance,"type":"heap"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"column is-half-desktop"},[(_vm.hasMemory)?_c('details-memory',{attrs:{"instance":_vm.instance,"type":"nonheap"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"columns is-desktop"},[_c('div',{staticClass:"column is-half-desktop"},[(_vm.hasDatasources)?_c('details-datasources',{attrs:{"instance":_vm.instance}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"column is-half-desktop"},[(_vm.hasCaches)?_c('details-caches',{attrs:{"instance":_vm.instance}}):_vm._e()],1)])])}
var details_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/details/index.vue
function details_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/details/index.vue")
}
/* script */


/* template */

/* template functional */
var details___vue_template_functional__ = false
/* styles */
var details___vue_styles__ = details_injectStyle
/* scopeId */
var details___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var details___vue_module_identifier__ = null

var details_Component = Object(component_normalizer["a" /* default */])(
  instances_details,
  details_render,
  details_staticRenderFns,
  details___vue_template_functional__,
  details___vue_styles__,
  details___vue_scopeId__,
  details___vue_module_identifier__
)

/* harmony default export */ var views_instances_details = __webpack_exports__["default"] = (details_Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/env/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/pickBy.js
var pickBy = __webpack_require__("./node_modules/lodash/pickBy.js");
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./node_modules/lodash/entries.js
var entries = __webpack_require__("./node_modules/lodash/entries.js");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__("./node_modules/lodash/debounce.js");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__("./node_modules/lodash/uniq.js");
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// EXTERNAL MODULE: ./src/main/frontend/utils/rxjs.js
var rxjs = __webpack_require__("./src/main/frontend/utils/rxjs.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/env/env-manager.vue




var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var env_manager = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    },
    propertySources: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      error: null,
      refreshStatus: null,
      resetStatus: null,
      updateStatus: null,
      managedProperties: [{
        name: null,
        input: null,
        value: null,
        status: null,
        validation: null
      }]
    };
  },
  computed: {
    allPropertyNames: function allPropertyNames() {
      return uniq_default()(this.propertySources.map(function (ps) {
        return Object.keys(ps.properties);
      }).reduce(function (result, names) {
        return result.concat(names);
      }).sort());
    },
    managerPropertySource: function managerPropertySource() {
      return this.propertySources.find(function (ps) {
        return ps.name === 'manager';
      }) || { name: 'manager', properties: [] };
    },
    hasManagedProperty: function hasManagedProperty() {
      return this.managedProperties.findIndex(function (property) {
        return !!property.name;
      }) >= 0;
    },
    hasChangedProperty: function hasChangedProperty() {
      return this.managedProperties.findIndex(function (property) {
        return property.input !== property.value;
      }) >= 0;
    },
    hasErrorProperty: function hasErrorProperty() {
      return this.managedProperties.findIndex(function (property) {
        return property.validation !== null;
      }) >= 0;
    }
  },
  methods: {
    handlePropertyNameChange: debounce_default()(function (prop, idx) {
      if (prop.name && idx === this.managedProperties.length - 1) {
        this.managedProperties.push({
          name: null,
          input: null,
          value: null,
          status: null,
          validation: null
        });
      }
    }, 250),
    refreshContext: function refreshContext() {
      var vm = this;
      Object(rxjs["m" /* from */])(vm.instance.refreshContext()).pipe(Object(rxjs["o" /* listen */])(function (status) {
        return vm.refreshStatus = status;
      })).subscribe({
        complete: function complete() {
          setTimeout(function () {
            return vm.refreshStatus = null;
          }, 2500);
          return vm.$emit('reset');
        },
        error: function error() {
          return vm.$emit('reset');
        }
      });
    },
    updateEnvironment: function updateEnvironment() {
      var vm = this;
      Object(rxjs["m" /* from */])(vm.managedProperties).pipe(Object(rxjs["l" /* filter */])(function (property) {
        return !!property.name && property.input !== property.value;
      }), Object(rxjs["o" /* listen */])(function (status) {
        return vm.updateStatus = status;
      }), Object(rxjs["g" /* concatMap */])(function (property) {
        return Object(rxjs["m" /* from */])(vm.instance.setEnv(property.name, property.input)).pipe(Object(rxjs["o" /* listen */])(function (status) {
          return property.status = status;
        }));
      })).subscribe({
        complete: function complete() {
          setTimeout(function () {
            return vm.updateStatus = null;
          }, 2500);
          return vm.$emit('update');
        },
        error: function error() {
          return vm.$emit('update');
        }
      });
    },
    resetEnvironment: function resetEnvironment() {
      var vm = this;
      Object(rxjs["m" /* from */])(vm.instance.resetEnv()).pipe(Object(rxjs["o" /* listen */])(function (status) {
        return vm.resetStatus = status;
      })).subscribe({
        complete: function complete() {
          vm.managedProperties = [{
            name: null,
            input: null,
            value: null,
            status: null,
            validation: null
          }];
          setTimeout(function () {
            return vm.resetStatus = null;
          }, 2500);
          return vm.$emit('refresh');
        },
        error: function error() {
          return vm.$emit('refresh');
        }
      });
    },
    updateManagedProperties: function updateManagedProperties(manager) {
      var _this = this;

      entries_default()(manager.properties).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            property = _ref2[1];

        var managedProperty = _this.managedProperties.find(function (property) {
          return property.name === name;
        });
        if (managedProperty) {
          managedProperty.value = property.value;
        } else {
          var idx = _this.managedProperties.length - 1;
          _this.managedProperties.splice(idx, 0, {
            name: name,
            input: property.value,
            value: property.value,
            status: null,
            validation: null
          });
        }
      });
    }
  },
  watch: {
    managerPropertySource: {
      handler: 'updateManagedProperties',
      immediate: true
    },
    managedProperties: {
      deep: true,
      handler: function handler() {
        var counts = this.managedProperties.reduce(function (acc, v) {
          if (v.name) {
            acc[v.name] = (acc[v.name] || 0) + 1;
          }
          return acc;
        }, {});
        this.managedProperties.forEach(function (property) {
          if (!property.name) {
            if (property.input) {
              property.validation = 'Property name is required';
            }
            return;
          }
          var count = counts[property.name] || 0;
          if (count > 1) {
            property.validation = 'Property name must be unique';
            return;
          }
          property.validation = null;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dd1ffd1","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/env/env-manager.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('h1',{staticClass:"is-size-5"},[_vm._v("Environment Manager")]),_vm._v(" "),_c('datalist',{attrs:{"id":"allPropertyNames"}},_vm._l((_vm.allPropertyNames),function(name){return _c('option',{key:name,domProps:{"textContent":_vm._s(name)}})})),_vm._v(" "),_vm._l((_vm.managedProperties),function(prop,index){return _c('div',{key:("managed-" + index),staticClass:"field is-horizontal"},[_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(prop.name),expression:"prop.name"}],staticClass:"input",attrs:{"type":"text","placeholder":"Property name","list":"allPropertyNames"},domProps:{"value":(prop.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(prop, "name", $event.target.value)},function($event){_vm.handlePropertyNameChange(prop, index)}]}})]),_vm._v(" "),_c('p',{staticClass:"help is-danger",domProps:{"textContent":_vm._s(prop.validation)}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-right",class:{'is-loading' : prop.status === 'executing'}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(prop.input),expression:"prop.input"}],staticClass:"input",attrs:{"type":"text","placeholder":"Value"},domProps:{"value":(prop.input)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(prop, "input", $event.target.value)},function($event){prop.status = null}]}}),_vm._v(" "),(prop.status === 'completed')?_c('span',{staticClass:"icon is-right has-text-success"},[_c('font-awesome-icon',{attrs:{"icon":"check"}})],1):(prop.status === 'failed')?_c('span',{staticClass:"icon is-right has-text-warning"},[_c('font-awesome-icon',{attrs:{"icon":"exclamation-triangle"}})],1):(prop.input !== prop.value)?_c('span',{staticClass:"icon is-right"},[_c('font-awesome-icon',{attrs:{"icon":"pencil-alt"}})],1):_vm._e()])])])])}),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[(_vm.instance.hasEndpoint('refresh'))?_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('sba-confirm-button',{staticClass:"button is-light",class:{'is-loading' : _vm.refreshStatus === 'executing', 'is-danger' : _vm.refreshStatus === 'failed', 'is-info' : _vm.refreshStatus === 'completed'},attrs:{"disabled":_vm.refreshStatus === 'executing'},on:{"click":_vm.refreshContext}},[(_vm.refreshStatus === 'completed')?_c('span',[_vm._v("Context refreshed")]):(_vm.refreshStatus === 'failed')?_c('span',[_vm._v("Failed")]):_c('span',[_vm._v("Refresh Context")])])],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field is-grouped is-grouped-right"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-light",class:{'is-loading' : _vm.resetStatus === 'executing', 'is-danger' : _vm.resetStatus === 'failed', 'is-success' : _vm.resetStatus === 'completed'},attrs:{"disabled":!_vm.hasManagedProperty || _vm.resetStatus === 'executing'},on:{"click":_vm.resetEnvironment}},[(_vm.resetStatus === 'completed')?_c('span',[_vm._v("Resetted")]):(_vm.resetStatus === 'failed')?_c('span',[_vm._v("Failed")]):_c('span',[_vm._v("Reset")])])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-primary",class:{'is-loading' : _vm.updateStatus === 'executing', 'is-danger' : _vm.updateStatus === 'failed', 'is-success' : _vm.updateStatus === 'completed'},attrs:{"disabled":_vm.hasErrorProperty || !_vm.hasChangedProperty || _vm.updateStatus === 'executing'},on:{"click":_vm.updateEnvironment}},[(_vm.updateStatus === 'completed')?_c('span',[_vm._v("Updated")]):(_vm.updateStatus === 'failed')?_c('span',[_vm._v("Failed")]):_c('span',[_vm._v("Update")])])])])])])],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/env/env-manager.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  env_manager,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var env_env_manager = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/env/index.vue


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var filterProperty = function filterProperty(needle) {
  return function (property, name) {
    return name.toString().toLowerCase().includes(needle) || property.value.toString().toLowerCase().includes(needle);
  };
};
var env_filterProperties = function filterProperties(needle, properties) {
  return pickBy_default()(properties, filterProperty(needle));
};
var filterPropertySource = function filterPropertySource(needle) {
  return function (propertySource) {
    if (!propertySource || !propertySource.properties) {
      return null;
    }
    return _extends({}, propertySource, {
      properties: env_filterProperties(needle, propertySource.properties)
    });
  };
};

/* harmony default export */ var env = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  components: { sbaEnvManager: env_env_manager },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      env: null,
      filter: null,
      hasEnvManagerSupport: false
    };
  },
  computed: {
    propertySources: function propertySources() {
      if (!this.env) {
        return [];
      }
      if (!this.filter) {
        return this.env.propertySources;
      }
      return this.env.propertySources.map(filterPropertySource(this.filter.toLowerCase())).filter(function (ps) {
        return ps && Object.keys(ps.properties).length > 0;
      });
    }
  },
  created: function created() {
    this.fetchEnv();
    this.determineEnvManagerSupport();
  },

  methods: {
    fetchEnv: function fetchEnv() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.error = null;
                _context.prev = 1;
                _context.next = 4;
                return _this.instance.fetchEnv();

              case 4:
                res = _context.sent;

                _this.env = res.data;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.warn('Fetching environment failed:', _context.t0);
                _this.error = _context.t0;

              case 12:
                _this.hasLoaded = true;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    determineEnvManagerSupport: function determineEnvManagerSupport() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.instance.hasEnvManagerSupport();

              case 3:
                _this2.hasEnvManagerSupport = _context2.sent;
                _context2.next = 10;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);

                console.warn('Determine env manager support failed:', _context2.t0);
                _this2.hasEnvManagerSupport = false;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 6]]);
      }))();
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      name: 'instances/env',
      parent: 'instances',
      path: 'env',
      component: this,
      label: 'Environment',
      group: 'Insights',
      order: 100,
      isEnabled: function isEnabled(_ref2) {
        var instance = _ref2.instance;
        return instance.hasEndpoint('env');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75de5d51","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/env/index.vue
var env_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:{ 'is-loading' : !_vm.hasLoaded }},[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n        Fetching environment failed.\n      ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.env && _vm.env.activeProfiles.length > 0)?_c('div',{staticClass:"field is-grouped is-grouped-multiline"},_vm._l((_vm.env.activeProfiles),function(profile){return _c('div',{key:profile,staticClass:"control"},[_c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag is-medium is-primary"},[_vm._v("Profile")]),_vm._v(" "),_c('span',{staticClass:"tag is-medium",domProps:{"textContent":_vm._s(profile)}})])])})):_vm._e(),_vm._v(" "),(_vm.env && _vm.hasEnvManagerSupport)?_c('sba-env-manager',{attrs:{"instance":_vm.instance,"property-sources":_vm.env.propertySources},on:{"refresh":function($event){_vm.fetchEnv()},"update":_vm.fetchEnv,"reset":function($event){_vm.fetchEnv()}}}):_vm._e(),_vm._v(" "),(_vm.env)?_c('div',{staticClass:"field has-addons"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"input",attrs:{"type":"search","placeholder":"name / value filter"},domProps:{"value":(_vm.filter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.propertySources),function(propertySource){return _c('sba-panel',{key:propertySource.name,attrs:{"header-sticks-below":['#navigation'],"title":propertySource.name}},[(Object.keys(propertySource.properties).length > 0)?_c('table',{staticClass:"table is-fullwidth"},_vm._l((propertySource.properties),function(value,name){return _c('tr',{key:((propertySource.name) + "-" + name)},[_c('td',[_c('span',{domProps:{"textContent":_vm._s(name)}}),_c('br'),_vm._v(" "),(value.origin)?_c('small',{staticClass:"is-muted",domProps:{"textContent":_vm._s(value.origin)}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"is-breakable",domProps:{"textContent":_vm._s(value.value)}})])})):_c('p',{staticClass:"is-muted"},[_vm._v("No properties set")])])})],2)}
var env_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/env/index.vue
/* script */


/* template */

/* template functional */
var env___vue_template_functional__ = false
/* styles */
var env___vue_styles__ = null
/* scopeId */
var env___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var env___vue_module_identifier__ = null

var env_Component = Object(component_normalizer["a" /* default */])(
  env,
  env_render,
  env_staticRenderFns,
  env___vue_template_functional__,
  env___vue_styles__,
  env___vue_scopeId__,
  env___vue_module_identifier__
)

/* harmony default export */ var instances_env = __webpack_exports__["default"] = (env_Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/flyway/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/flyway/index.vue
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var flyway = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      contexts: null
    };
  },
  computed: {},
  created: function created() {
    this.fetchFlyway();
  },

  methods: {
    fetchFlyway: function fetchFlyway() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.error = null;
                _context.prev = 1;
                _context.next = 4;
                return _this.instance.fetchFlyway();

              case 4:
                res = _context.sent;

                _this.contexts = res.data.contexts;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.warn('Fetching flyway reports failed:', _context.t0);
                _this.error = _context.t0;

              case 12:
                _this.hasLoaded = true;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    stateClass: function stateClass(state) {
      switch (state) {
        case 'BASELINE':
        case 'MISSING_SUCCESS':
        case 'SUCCESS':
        case 'OUT_OF_ORDER':
        case 'FUTURE_SUCCESS':
          return 'is-success';
        case 'PENDING':
        case 'ABOVE_TARGET':
        case 'PREINIT':
        case 'BELOW_BASELINE':
        case 'IGNORED':
          return 'is-warning';
        case 'MISSING_FAILED':
        case 'FAILED':
        case 'FUTURE_FAILED':
          return 'is-danger';
        default:
          return 'is-light';
      }
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      name: 'instances/flyway',
      parent: 'instances',
      path: 'flyway',
      component: this,
      label: 'Flyway',
      group: 'Data',
      order: 900,
      isEnabled: function isEnabled(_ref2) {
        var instance = _ref2.instance;
        return instance.hasEndpoint('flyway');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17049197","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/flyway/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:{ 'is-loading' : !_vm.hasLoaded }},[(_vm.hasLoaded)?[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching Flyway reports failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.contexts),function(context,ctxName){return [_c('h3',{key:ctxName,staticClass:"title",domProps:{"textContent":_vm._s(ctxName)}}),_vm._v(" "),_vm._l((context.flywayBeans),function(report,name){return _c('sba-panel',{key:(ctxName + "-" + name),staticClass:"migration",attrs:{"title":name,"header-sticks-below":['#navigation']}},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Checksum")]),_vm._v(" "),_c('th',[_vm._v("Version")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Script")]),_vm._v(" "),_c('th',[_vm._v("State")]),_vm._v(" "),_c('th',[_vm._v("Installed by")]),_vm._v(" "),_c('th',[_vm._v("Installed on")]),_vm._v(" "),_c('th',[_vm._v("Installed rank")]),_vm._v(" "),_c('th',[_vm._v("Execution Time")])])]),_vm._v(" "),_c('tbody',_vm._l((report.migrations),function(migration){return _c('tr',{key:migration.checksum},[_c('td',{domProps:{"textContent":_vm._s(migration.type)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(migration.checksum)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(migration.version)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(migration.description)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(migration.script)}}),_vm._v(" "),_c('td',[_c('span',{staticClass:"tag",class:_vm.stateClass(migration.state),domProps:{"textContent":_vm._s(migration.state)}})]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(migration.installedBy)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(migration.installedOn)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(migration.installedRank)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(((migration.executionTime) + "ms"))}})])}))])])})]})]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/flyway/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  flyway,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var instances_flyway = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/heapdump/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/heapdump/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var heapdump = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      name: 'instances/heapdump',
      parent: 'instances',
      path: 'heapdump',
      component: this,
      label: 'Heap Dump',
      group: 'JVM',
      order: 800,
      isEnabled: function isEnabled(_ref2) {
        var instance = _ref2.instance;
        return instance.hasEndpoint('heapdump');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af82e38","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/heapdump/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section heapdump"},[_c('div',[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('a',{staticClass:"button is-primary",attrs:{"href":("instances/" + (_vm.instance.id) + "/actuator/heapdump"),"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":"download"}}),_vm._v(" Download Heap Dump\n    ")],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message is-warning"},[_c('div',{staticClass:"message-body"},[_vm._v("\n        A heap dump may contain "),_c('strong',[_vm._v("sensitive data")]),_vm._v(". Please handle with care.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message is-warning"},[_c('div',{staticClass:"message-body"},[_vm._v("\n        Dumping the heap may be expensive in terms of cpu and disk space.\n      ")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/heapdump/index.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/heapdump/index.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  heapdump,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var instances_heapdump = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/httptrace/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/mixins/subscribing.js
var subscribing = __webpack_require__("./src/main/frontend/mixins/subscribing.js");

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/rxjs.js
var rxjs = __webpack_require__("./src/main/frontend/utils/rxjs.js");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("./node_modules/moment/moment.js");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/main/frontend/utils/d3.js
var d3 = __webpack_require__("./src/main/frontend/utils/d3.js");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/index.js + 49 modules
var src = __webpack_require__("./node_modules/d3-selection/src/index.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/httptrace/traces-chart.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//see https://github.com/d3/d3/issues/2733#issuecomment-190743489




var interval = 1000;
/* harmony default export */ var traces_chart = ({
  props: {
    traces: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      brushSelection: null,
      hovered: null
    };
  },
  computed: {
    chartData: function chartData() {
      if (this.traces.length <= 0) {
        return [];
      }
      var chartData = [];
      var now = moment_default()().valueOf();
      var idx = this.traces.length - 1;
      var oldest = this.traces[this.traces.length - 1].timestamp.valueOf();

      for (var time = Math.floor(oldest.valueOf() / interval) * interval; time < now; time += interval) {
        var bucket = {
          timeStart: time,
          timeEnd: time + interval,
          totalCount: 0,
          totalSuccess: 0,
          totalClientErrors: 0,
          totalServerErrors: 0,
          totalTime: 0,
          maxTime: 0
        };

        while (idx >= 0 && this.traces[idx].timestamp.valueOf() < time + interval) {
          var trace = this.traces[idx];
          bucket.totalCount++;
          if (trace.isSuccess()) {
            bucket.totalSuccess++;
          } else if (trace.isClientError()) {
            bucket.totalClientErrors++;
          } else if (trace.isServerError()) {
            bucket.totalServerErrors++;
          }
          if (trace.timeTaken) {
            bucket.totalTime += trace.timeTaken;
            bucket.maxTime = Math.max(bucket.maxTime, trace.timeTaken);
          }
          idx--;
        }
        chartData.push(bucket);
      }

      return chartData;
    },
    tooltipSelection: function tooltipSelection() {
      return this.brushSelection ? this.brushSelection : this.hovered ? [this.hovered, this.hovered + interval] : null;
    },
    tooltipContent: function tooltipContent() {
      var selection = this.tooltipSelection;
      var totals = this.chartData.filter(function (bucket) {
        return bucket.timeStart.valueOf() >= selection[0] && bucket.timeStart.valueOf() < selection[1];
      }).reduce(function (current, next) {
        return {
          totalCount: current.totalCount + next.totalCount,
          totalSuccess: current.totalSuccess + next.totalSuccess,
          totalClientErrors: current.totalClientErrors + next.totalClientErrors,
          totalServerErrors: current.totalServerErrors + next.totalServerErrors,
          totalTime: current.totalTime + next.totalTime,
          maxTime: Math.max(current.maxTime, next.maxTime)
        };
      }, {
        totalCount: 0,
        totalSuccess: 0,
        totalClientErrors: 0,
        totalServerErrors: 0,
        totalTime: 0,
        maxTime: 0
      });
      return _extends({}, totals, {
        avgTime: totals.totalCount > 0 ? Math.floor(totals.totalTime / totals.totalCount) : 0
      });
    }
  },
  methods: {
    drawChart: function drawChart(data) {
      var vm = this;

      ///setup x and y scale
      var x = d3["a" /* default */].scaleTime().range([0, vm.width]).domain(d3["a" /* default */].extent(data, function (d) {
        return d.timeStart;
      }));
      this.x = x;

      var y = d3["a" /* default */].scaleLinear().range([vm.height, 0]).domain([0, d3["a" /* default */].max(data, function (d) {
        return d.totalCount;
      })]);

      //draw areas
      var area = d3["a" /* default */].area().x(function (d) {
        return x(d.data.timeStart);
      }).y0(function (d) {
        return y(d[0]);
      }).y1(function (d) {
        return y(d[1]);
      });

      var stack = d3["a" /* default */].stack().keys(['totalSuccess', 'totalClientErrors', 'totalServerErrors']);

      var d = vm.areas.selectAll('.trace-chart__area').data(stack(data));

      d.enter().append('path').merge(d).attr('class', function (d) {
        return 'trace-chart__area trace-chart__area--' + d.key;
      }).attr('d', area);

      d.exit().remove();

      //draw axis
      vm.xAxis.call(d3["a" /* default */].axisBottom(x).ticks(10).tickFormat(function (d) {
        return moment_default()(d).format('HH:mm:ss');
      }));

      vm.yAxis.call(d3["a" /* default */].axisRight(y).ticks(Math.min(5, d3["a" /* default */].max(data, function (d) {
        return d.totalCount;
      }))).tickSize(this.width)).call(function (axis) {
        return axis.selectAll('.tick text').attr('x', -2).attr('dy', 2).attr('text-anchor', 'end');
      });

      //draw brush selection
      var brush = d3["a" /* default */].brushX().extent([[0, 0], [vm.width, vm.height]]).on('start', function () {
        if (src["event"].selection) {
          vm.isBrushing = true;
          vm.hovered = null;
        }
      }).on('brush', function () {
        if (src["event"].sourceEvent === null || src["event"].sourceEvent.type === 'brush') {
          return;
        }

        if (src["event"].selection) {
          var floor = Math.floor(x.invert(src["event"].selection[0]) / interval) * interval;
          var ceil = Math.ceil(x.invert(src["event"].selection[1]) / interval) * interval;
          d3["a" /* default */].select(this).call(src["event"].target.move, [floor, ceil].map(x));
          vm.brushSelection = [floor, ceil];
        }
      }).on('end', function () {
        vm.isBrushing = false;
        if (!src["event"].selection) {
          vm.brushSelection = null;
        }
      });

      vm.brushGroup.call(brush).on('mousemove', function () {
        if (vm.isBrushing) {
          return;
        }
        var mouseX = d3["a" /* default */].mouse(vm.brushGroup.select('.overlay').node())[0];
        vm.hovered = Math.floor(x.invert(mouseX) / interval) * interval;
      }).on('mouseout', function () {
        vm.hovered = null;
      });

      brush.move(vm.brushGroup, vm.brushSelection ? vm.brushSelection.map(x) : null);
    }
  },
  mounted: function mounted() {
    var margin = {
      top: 20,
      right: 20,
      bottom: 30,
      left: 20
    };

    this.width = this.$el.getBoundingClientRect().width - margin.left - margin.right;
    this.height = this.$el.getBoundingClientRect().height - margin.top - margin.bottom;

    this.chartLayer = d3["a" /* default */].select(this.$el.querySelector('.trace-chart__svg')).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    this.xAxis = this.chartLayer.append('g').attr('class', 'trace-chart__axis-x').attr('transform', 'translate(0,' + this.height + ')');

    this.yAxis = this.chartLayer.append('g').attr('class', 'trace-chart__axis-y').attr('stroke', null);

    this.areas = this.chartLayer.append('g');

    this.hover = this.chartLayer.append('path').attr('class', 'trace-chart__hover').attr('opacity', 0);

    this.brushGroup = this.chartLayer.append('g').attr('class', 'trace-chart__brush');

    this.drawChart(this.chartData);
  },

  watch: {
    chartData: 'drawChart',
    hovered: function hovered(newVal) {
      if (newVal) {
        this.hover.attr('opacity', 1).attr('d', 'M' + this.x(newVal) + ',' + this.height + ' ' + this.x(newVal) + ',0');
      } else {
        this.hover.attr('opacity', 0);
      }
    },
    brushSelection: function brushSelection(newVal) {
      this.$emit('selected', newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5ee2f16","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/httptrace/traces-chart.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trace-chart"},[(_vm.tooltipSelection )?_c('div',{staticClass:"trace-chart__tooltip",class:("trace-chart__tooltip--" + (this.x(_vm.tooltipSelection[0]) > this.width / 2 ? 'left' : 'right'))},[_c('table',{staticClass:"is-narrow is-size-7"},[_c('tr',[_c('th',[_vm._v("total requests")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.tooltipContent.totalCount)}})]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("successful")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.tooltipContent.totalSuccess)}})]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("status 4xx")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.tooltipContent.totalClientErrors)}})]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("status 5xx")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.tooltipContent.totalServerErrors)}})]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("max duration")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(((_vm.tooltipContent.maxTime) + "ms"))}})]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("ø duration")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(((_vm.tooltipContent.avgTime) + "ms"))}})])])]):_vm._e(),_vm._v(" "),_c('svg',{staticClass:"trace-chart__svg"})])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/httptrace/traces-chart.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/httptrace/traces-chart.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  traces_chart,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var httptrace_traces_chart = (Component.exports);

// EXTERNAL MODULE: ./node_modules/pretty-bytes/index.js
var pretty_bytes = __webpack_require__("./node_modules/pretty-bytes/index.js");
var pretty_bytes_default = /*#__PURE__*/__webpack_require__.n(pretty_bytes);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/httptrace/traces-list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var traces_list = ({
  props: {
    traces: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      showDetails: {}
    };
  },
  methods: {
    prettyBytes: pretty_bytes_default.a,
    toJson: function toJson(obj) {
      return JSON.stringify(obj, null, 4);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53ea4a01","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/httptrace/traces-list.vue
var traces_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"httptraces table is-hoverable is-fullwidth"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.traces),function(trace){return [_c('tr',{key:trace.key,staticClass:"is-selectable",class:{ 'httptraces__trace---is-detailed' : _vm.showDetails[trace.key] },on:{"click":function($event){_vm.showDetails[trace.key] ? _vm.$delete(_vm.showDetails, trace.key) : _vm.$set(_vm.showDetails, trace.key, true)}}},[_c('td',{staticClass:"httptraces__trace-timestamp",domProps:{"textContent":_vm._s(trace.timestamp.format('L HH:mm:ss.SSS'))}}),_vm._v(" "),_c('td',{staticClass:"httptraces__trace-method",domProps:{"textContent":_vm._s(trace.request.method)}}),_vm._v(" "),_c('td',{staticClass:"httptraces__trace-uri",domProps:{"textContent":_vm._s(trace.request.uri)}}),_vm._v(" "),_c('td',{staticClass:"httptraces__trace-status"},[_c('span',{staticClass:"tag",class:{ 'is-success' : trace.isSuccess(), 'is-warning' : trace.isClientError(), 'is-danger' : trace.isServerError() },domProps:{"textContent":_vm._s(trace.response.status)}})]),_vm._v(" "),_c('td',{staticClass:"httptraces__trace-contentType",domProps:{"textContent":_vm._s(trace.contentType)}}),_vm._v(" "),_c('td',{staticClass:"httptraces__trace-contentLength",domProps:{"textContent":_vm._s(trace.contentLength ? _vm.prettyBytes(trace.contentLength) : '')}}),_vm._v(" "),_c('td',{staticClass:"httptraces__trace-timeTaken",domProps:{"textContent":_vm._s(trace.timeTaken !== null && typeof trace.timeTaken !== 'undefined' ? ((trace.timeTaken) + " ms") : '')}})]),_vm._v(" "),(_vm.showDetails[trace.key])?_c('tr',{key:((trace.key) + "-detail")},[_c('td',{attrs:{"colspan":"7"}},[_c('pre',{staticClass:"httptraces__trace-detail",domProps:{"textContent":_vm._s(_vm.toJson(trace))}})])]):_vm._e()]}),_vm._v(" "),(_vm.traces.length === 0)?_c('tr',[_c('td',{staticClass:"is-muted",attrs:{"colspan":"7"}},[_vm._v("No traces found.")])]):_vm._e()],2)])}
var traces_list_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"httptraces__trace-timestamp"},[_vm._v("Timestamp")]),_vm._v(" "),_c('th',{staticClass:"httptraces__trace-method"},[_vm._v("Method")]),_vm._v(" "),_c('th',{staticClass:"httptraces__trace-uri"},[_vm._v("Path")]),_vm._v(" "),_c('th',{staticClass:"httptraces__trace-status"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"httptraces__trace-contentType"},[_vm._v("Content-Type")]),_vm._v(" "),_c('th',{staticClass:"httptraces__trace-contentLength"},[_vm._v("Length")]),_vm._v(" "),_c('th',{staticClass:"httptraces__trace-timeTaken"},[_vm._v("Time")])])])}]

// CONCATENATED MODULE: ./src/main/frontend/views/instances/httptrace/traces-list.vue
function traces_list_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/httptrace/traces-list.vue")
}
/* script */


/* template */

/* template functional */
var traces_list___vue_template_functional__ = false
/* styles */
var traces_list___vue_styles__ = traces_list_injectStyle
/* scopeId */
var traces_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var traces_list___vue_module_identifier__ = null

var traces_list_Component = Object(component_normalizer["a" /* default */])(
  traces_list,
  traces_list_render,
  traces_list_staticRenderFns,
  traces_list___vue_template_functional__,
  traces_list___vue_styles__,
  traces_list___vue_scopeId__,
  traces_list___vue_module_identifier__
)

/* harmony default export */ var httptrace_traces_list = (traces_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/httptrace/index.vue
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var addToFilter = function addToFilter(oldFilter, addedFilter) {
  return !oldFilter ? addedFilter : function (val, key) {
    return oldFilter(val, key) && addedFilter(val, key);
  };
};

var httptrace_Trace = function () {
  function Trace(_ref) {
    var timestamp = _ref.timestamp,
        trace = _objectWithoutProperties(_ref, ['timestamp']);

    _classCallCheck(this, Trace);

    Object.assign(this, trace);
    this.timestamp = moment_default()(timestamp);
  }

  _createClass(Trace, [{
    key: 'compareTo',
    value: function compareTo(other) {
      return this.timestamp - other.timestamp;
    }
  }, {
    key: 'isSuccess',
    value: function isSuccess() {
      return this.response.status <= 399;
    }
  }, {
    key: 'isClientError',
    value: function isClientError() {
      return this.response.status >= 400 && this.response.status <= 499;
    }
  }, {
    key: 'isServerError',
    value: function isServerError() {
      return this.response.status >= 500 && this.response.status <= 599;
    }
  }, {
    key: 'key',
    get: function get() {
      return this.timestamp + '-' + this.request.method + '-' + this.request.uri;
    }
  }, {
    key: 'contentLength',
    get: function get() {
      var contentLength = this.response.headers['Content-Length'] && this.response.headers['Content-Length'][0];
      if (contentLength && /^\d+$/.test(contentLength)) {
        return parseInt(contentLength);
      }
      return null;
    }
  }, {
    key: 'contentType',
    get: function get() {
      var contentType = this.response.headers['Content-Type'] && this.response.headers['Content-Type'][0];
      if (contentType) {
        var idx = contentType.indexOf(';');
        return idx >= 0 ? contentType.substring(0, idx) : contentType;
      }
      return null;
    }
  }]);

  return Trace;
}();

/* harmony default export */ var httptrace = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  components: {
    sbaTracesList: httptrace_traces_list, sbaTracesChart: httptrace_traces_chart
  },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      traces: null,
      filter: null,
      excludeActuator: true,
      showSuccess: true,
      showClientErrors: true,
      showServerErrors: true,
      selection: null
    };
  },
  computed: {
    actuatorPath: function actuatorPath() {
      if (this.instance.registration.managementUrl.includes(this.instance.registration.serviceUrl)) {
        var appendix = this.instance.registration.managementUrl.substring(this.instance.registration.serviceUrl.length);
        if (appendix.length > 0) {
          return appendix.startsWith('/') ? appendix : '/' + appendix;
        }
      }
      return null;
    },
    filteredTraces: function filteredTraces() {
      var filterFn = this.getFilterFn();
      return filterFn ? this.traces.filter(filterFn) : this.traces;
    },
    selectedTraces: function selectedTraces() {
      if (this.selection === null) {
        return this.filteredTraces;
      }

      var _selection = _slicedToArray(this.selection, 2),
          start = _selection[0],
          end = _selection[1];

      return this.filteredTraces.filter(function (trace) {
        return !trace.timestamp.isBefore(start) && !trace.timestamp.isAfter(end);
      });
    }
  },
  methods: {
    fetchHttptrace: function fetchHttptrace() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, traces;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.instance.fetchHttptrace();

              case 2:
                response = _context.sent;
                traces = response.data.traces.map(function (trace) {
                  return new httptrace_Trace(trace);
                }).filter(function (trace) {
                  return trace.timestamp.isAfter(_this.lastTimestamp);
                });

                traces.sort(function (a, b) {
                  return -1 * a.compareTo(b);
                });
                if (traces.length > 0) {
                  _this.lastTimestamp = traces[0].timestamp;
                }
                return _context.abrupt('return', traces);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      vm.lastTimestamp = moment_default()(0);
      vm.error = null;
      return Object(rxjs["u" /* timer */])(0, 5000).pipe(Object(rxjs["g" /* concatMap */])(vm.fetchHttptrace)).subscribe({
        next: function next(traces) {
          vm.hasLoaded = true;
          vm.traces = vm.traces ? traces.concat(vm.traces) : traces;
        },
        error: function error(_error) {
          vm.hasLoaded = true;
          console.warn('Fetching traces failed:', _error);
          vm.error = _error;
        }
      });
    },
    getFilterFn: function getFilterFn() {
      var _this2 = this;

      var filterFn = null;
      if (this.actuatorPath !== null && this.excludeActuator) {
        filterFn = addToFilter(filterFn, function (trace) {
          return !trace.request.uri.includes(_this2.actuatorPath);
        });
      }
      if (this.filter) {
        var normalizedFilter = this.filter.toLowerCase();
        filterFn = addToFilter(filterFn, function (trace) {
          return trace.request.uri.toLowerCase().includes(normalizedFilter);
        });
      }
      if (!this.showSuccess) {
        filterFn = addToFilter(filterFn, function (trace) {
          return !trace.isSuccess();
        });
      }
      if (!this.showClientErrors) {
        filterFn = addToFilter(filterFn, function (trace) {
          return !trace.isClientError();
        });
      }
      if (!this.showServerErrors) {
        filterFn = addToFilter(filterFn, function (trace) {
          return !trace.isServerError();
        });
      }
      return filterFn;
    }
  },
  install: function install(_ref2) {
    var viewRegistry = _ref2.viewRegistry;

    viewRegistry.addView({
      name: 'instances/httptrace',
      parent: 'instances',
      path: 'httptrace',
      component: this,
      label: 'Http Traces',
      group: 'Web',
      order: 500,
      isEnabled: function isEnabled(_ref3) {
        var instance = _ref3.instance;
        return instance.hasEndpoint('httptrace');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adc786ce","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/httptrace/index.vue
var httptrace_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:{ 'is-loading' : !_vm.hasLoaded}},[(_vm.hasLoaded)?[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching traces failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.traces)?[_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field has-addons"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"input",attrs:{"type":"search","placeholder":"path filter"},domProps:{"value":(_vm.filter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('span',{staticClass:"button is-static"},[_c('span',{domProps:{"textContent":_vm._s(_vm.filteredTraces.length)}}),_vm._v("\n              /\n              "),_c('span',{domProps:{"textContent":_vm._s(_vm.traces.length)}})])])])]),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field is-narrow"},[_c('div',{staticClass:"control"},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showSuccess),expression:"showSuccess"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showSuccess)?_vm._i(_vm.showSuccess,null)>-1:(_vm.showSuccess)},on:{"change":function($event){var $$a=_vm.showSuccess,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showSuccess=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showSuccess=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showSuccess=$$c}}}}),_vm._v("\n              success\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"field is-narrow"},[_c('div',{staticClass:"control"},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showClientErrors),expression:"showClientErrors"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showClientErrors)?_vm._i(_vm.showClientErrors,null)>-1:(_vm.showClientErrors)},on:{"change":function($event){var $$a=_vm.showClientErrors,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showClientErrors=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showClientErrors=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showClientErrors=$$c}}}}),_vm._v("\n              client errors\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"field is-narrow"},[_c('div',{staticClass:"control"},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showServerErrors),expression:"showServerErrors"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showServerErrors)?_vm._i(_vm.showServerErrors,null)>-1:(_vm.showServerErrors)},on:{"change":function($event){var $$a=_vm.showServerErrors,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showServerErrors=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showServerErrors=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showServerErrors=$$c}}}}),_vm._v("\n              server errors\n            ")])])]),_vm._v(" "),(_vm.actuatorPath)?_c('div',{staticClass:"field is-narrow"},[_c('div',{staticClass:"control"},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.excludeActuator),expression:"excludeActuator"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.excludeActuator)?_vm._i(_vm.excludeActuator,null)>-1:(_vm.excludeActuator)},on:{"change":function($event){var $$a=_vm.excludeActuator,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.excludeActuator=$$a.concat([$$v]))}else{$$i>-1&&(_vm.excludeActuator=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.excludeActuator=$$c}}}}),_vm._v("\n              exclude "),_c('span',{domProps:{"textContent":_vm._s(_vm.actuatorPath)}}),_vm._v("/**\n            ")])])]):_vm._e()]),_vm._v(" "),_c('sba-traces-chart',{attrs:{"traces":_vm.filteredTraces},on:{"selected":function (d) { return _vm.selection = d; }}}),_vm._v(" "),_c('sba-traces-list',{attrs:{"traces":_vm.selectedTraces}})]:_vm._e()]:_vm._e()],2)}
var httptrace_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/httptrace/index.vue
/* script */


/* template */

/* template functional */
var httptrace___vue_template_functional__ = false
/* styles */
var httptrace___vue_styles__ = null
/* scopeId */
var httptrace___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var httptrace___vue_module_identifier__ = null

var httptrace_Component = Object(component_normalizer["a" /* default */])(
  httptrace,
  httptrace_render,
  httptrace_staticRenderFns,
  httptrace___vue_template_functional__,
  httptrace___vue_styles__,
  httptrace___vue_scopeId__,
  httptrace___vue_module_identifier__
)

/* harmony default export */ var instances_httptrace = __webpack_exports__["default"] = (httptrace_Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/jolokia/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("./node_modules/lodash/sortBy.js");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("./node_modules/lodash/isEqual.js");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("./node_modules/lodash/isEmpty.js");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/fromPairs.js
var fromPairs = __webpack_require__("./node_modules/lodash/fromPairs.js");
var fromPairs_default = /*#__PURE__*/__webpack_require__.n(fromPairs);

// EXTERNAL MODULE: ./node_modules/lodash/toPairs.js
var toPairs = __webpack_require__("./node_modules/lodash/toPairs.js");
var toPairs_default = /*#__PURE__*/__webpack_require__.n(toPairs);

// EXTERNAL MODULE: ./src/main/frontend/directives/sticks-below.js
var sticks_below = __webpack_require__("./src/main/frontend/directives/sticks-below.js");

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./node_modules/vue-clickaway/dist/vue-clickaway.common.js
var vue_clickaway_common = __webpack_require__("./node_modules/vue-clickaway/dist/vue-clickaway.common.js");
var vue_clickaway_common_default = /*#__PURE__*/__webpack_require__.n(vue_clickaway_common);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/jolokia/m-bean-attribute.vue
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var m_bean_attribute = ({
  props: {
    name: {
      type: String,
      required: true
    },
    descriptor: {
      type: Object,
      required: true
    },
    value: {
      type: null,
      default: null
    },
    onSaveValue: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      input: null,
      editing: false,
      saving: false,
      error: null
    };
  },
  computed: {
    hasComplexValue: function hasComplexValue() {
      return this.value !== null && _typeof(this.value) === 'object';
    },
    jsonValue: function jsonValue() {
      return JSON.stringify(this.value, null, 4);
    }
  },
  methods: {
    edit: function edit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.descriptor.rw && !_this.hasComplexValue)) {
                  _context.next = 6;
                  break;
                }

                _this.input = _this.value;
                _this.editing = true;
                _context.next = 5;
                return _this.$nextTick();

              case 5:
                _this.$refs.input.focus();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cancel: function cancel() {
      this.editing = false;
    },
    save: function save() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.saving = true;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.onSaveValue(_this2.input);

              case 4:
                _context2.next = 10;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](1);

                console.warn('Error saving attribute ' + _this2.name, _context2.t0);
                _this2.error = _context2.t0;

              case 10:
                _context2.prev = 10;

                _this2.saving = false;
                _this2.editing = false;
                return _context2.finish(10);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 6, 10, 14]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76645632","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/jolokia/m-bean-attribute.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_c('span',{domProps:{"textContent":_vm._s(_vm.name)}}),_vm._v(" "),_c('small',{staticClass:"is-muted has-text-weight-normal",domProps:{"textContent":_vm._s(_vm.descriptor.type)}})]),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field is-expanded"},[_c('div',{staticClass:"field has-addons"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button",attrs:{"disabled":!_vm.descriptor.rw},on:{"click":_vm.edit}},[_c('font-awesome-icon',{attrs:{"icon":"pencil-alt"}})],1)]),_vm._v(" "),_c('div',{staticClass:"control is-expanded has-icons-right"},[(!_vm.editing)?[(!_vm.hasComplexValue)?_c('input',{staticClass:"input",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.value},on:{"dblclick":_vm.edit}}):_c('textarea',{staticClass:"input m-bean-attribute--text",attrs:{"readonly":""},domProps:{"textContent":_vm._s(_vm.jsonValue)}}),_vm._v(" "),(_vm.error)?_c('span',{staticClass:"icon is-right has-text-warning"},[_c('font-awesome-icon',{attrs:{"icon":"exclamation-triangle"}})],1):_vm._e()]:[(!_vm.hasComplexValue)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input),expression:"input"}],ref:"input",staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.input)},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }return _vm.cancel($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save($event)}],"input":function($event){if($event.target.composing){ return; }_vm.input=$event.target.value}}}):_vm._e()]],2)]),_vm._v(" "),_c('div',{staticClass:"help",domProps:{"textContent":_vm._s(_vm.descriptor.desc)}})])]),_vm._v(" "),(_vm.editing)?_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-light is-small",on:{"click":_vm.cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button is-primary is-small",class:{'is-loading' : _vm.saving},attrs:{"disabled":_vm.value === _vm.input},on:{"click":_vm.save}},[_vm._v("Save\n    ")])]):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/jolokia/m-bean-attribute.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/jolokia/m-bean-attribute.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  m_bean_attribute,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var jolokia_m_bean_attribute = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/jolokia/m-bean-attributes.vue
function m_bean_attributes__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var m_bean_attributes = ({
  props: {
    domain: {
      type: String,
      required: true
    },
    mBean: {
      type: jolokia_MBean,
      required: true
    },
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  components: { mBeanAttribute: jolokia_m_bean_attribute },
  data: function data() {
    return {
      attributeValues: null,
      error: null
    };
  },
  computed: {},
  methods: {
    readAttributes: function readAttributes() {
      var _this = this;

      return m_bean_attributes__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.instance.readMBeanAttributes(_this.domain, _this.mBean.descriptor.raw);

              case 3:
                response = _context.sent;

                _this.attributeValues = response.data.value;
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.warn('Fetching MBean attributes failed:', _context.t0);
                _this.error = _context.t0;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    writeAttribute: function writeAttribute(attribute, value) {
      var _this2 = this;

      return m_bean_attributes__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.instance.writeMBeanAttribute(_this2.domain, _this2.mBean.descriptor.raw, attribute, value);

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return _this2.readAttributes();

              case 6:
                return _context2.finish(3);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0,, 3, 7]]);
      }))();
    }
  },
  created: function created() {
    this.readAttributes();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0867a308","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/jolokia/m-bean-attributes.vue
var m_bean_attributes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n        Fetching attributes failed.\n      ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.mBean.attr),function(attribute,name){return _c('m-bean-attribute',{key:("attr-" + name),attrs:{"name":name,"descriptor":attribute,"value":_vm.attributeValues && _vm.attributeValues[name],"on-save-value":function (value) { return _vm.writeAttribute(name, value); }}})})],2)}
var m_bean_attributes_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/jolokia/m-bean-attributes.vue
/* script */


/* template */

/* template functional */
var m_bean_attributes___vue_template_functional__ = false
/* styles */
var m_bean_attributes___vue_styles__ = null
/* scopeId */
var m_bean_attributes___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var m_bean_attributes___vue_module_identifier__ = null

var m_bean_attributes_Component = Object(component_normalizer["a" /* default */])(
  m_bean_attributes,
  m_bean_attributes_render,
  m_bean_attributes_staticRenderFns,
  m_bean_attributes___vue_template_functional__,
  m_bean_attributes___vue_styles__,
  m_bean_attributes___vue_scopeId__,
  m_bean_attributes___vue_module_identifier__
)

/* harmony default export */ var jolokia_m_bean_attributes = (m_bean_attributes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/jolokia/m-bean-operation.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var m_bean_operation = ({
  props: {
    name: {
      type: String,
      required: true
    },
    descriptor: {
      type: Object,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85729826","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/jolokia/m-bean-operation.vue
var m_bean_operation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-light is-fullwidth",on:{"click":function($event){_vm.$emit('click', $event)}}},[_c('small',{staticClass:"is-light is-muted",domProps:{"textContent":_vm._s(_vm.descriptor.ret)}}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.name)}})]),_vm._v(" "),_c('p',{staticClass:"help",domProps:{"textContent":_vm._s(_vm.descriptor.desc)}})])])}
var m_bean_operation_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/jolokia/m-bean-operation.vue
/* script */


/* template */

/* template functional */
var m_bean_operation___vue_template_functional__ = false
/* styles */
var m_bean_operation___vue_styles__ = null
/* scopeId */
var m_bean_operation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var m_bean_operation___vue_module_identifier__ = null

var m_bean_operation_Component = Object(component_normalizer["a" /* default */])(
  m_bean_operation,
  m_bean_operation_render,
  m_bean_operation_staticRenderFns,
  m_bean_operation___vue_template_functional__,
  m_bean_operation___vue_styles__,
  m_bean_operation___vue_scopeId__,
  m_bean_operation___vue_module_identifier__
)

/* harmony default export */ var jolokia_m_bean_operation = (m_bean_operation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/jolokia/m-bean-operation-invocation.vue
function m_bean_operation_invocation__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var m_bean_operation_invocation = ({
  props: {
    name: {
      type: String,
      required: true
    },
    descriptor: {
      type: Object,
      required: true
    },
    value: {
      type: null,
      default: null
    },
    onClose: {
      type: Function,
      required: true
    },
    onExecute: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      state: null,
      error: null,
      args: null,
      result: null
    };
  },
  computed: {},
  methods: {
    abort: function abort() {
      this.onClose();
    },
    invoke: function invoke(args) {
      this.state = args || this.descriptor.args.length === 0 ? 'prepared' : 'input-args';
      this.args = args || new Array(this.descriptor.args.length);
      this.error = null;
      this.result = null;

      if (this.state === 'prepared') {
        this.execute();
      }
    },
    execute: function execute() {
      var _this = this;

      return m_bean_operation_invocation__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result, error;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.state = 'executing';
                _context.prev = 1;
                _context.next = 4;
                return _this.onExecute(_this.args);

              case 4:
                result = _context.sent;

                if (result.data.status < 400) {
                  _this.result = JSON.stringify(result.data.value, null, 4);
                  _this.state = 'completed';
                } else {
                  error = new Error('Execution failed: ' + result.data.error);

                  error.stacktrace = result.data.stacktrace;
                  _this.state = 'failed';
                  _this.error = error;
                  console.warn('Invocation failed', error);
                }
                _context.next = 13;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                _this.state = 'failed';
                _this.error = _context.t0;
                console.warn('Invocation failed', _context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    keyHandler: function keyHandler(event) {
      if (event.keyCode === 27) {
        this.abort();
      }
    }
  },
  created: function created() {
    this.invoke();
  },
  mounted: function mounted() {
    document.addEventListener('keyup', this.keyHandler);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.keyHandler);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad614886","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/jolokia/m-bean-operation-invocation.vue
var m_bean_operation_invocation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background",on:{"click":_vm.abort}}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title",domProps:{"textContent":_vm._s(_vm.name)}})]),_vm._v(" "),(_vm.state === 'input-args')?[_c('section',{staticClass:"modal-card-body",on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if(!$event.ctrlKey){ return null; }_vm.invoke(_vm.args)}}},_vm._l((_vm.descriptor.args),function(arg,idx){return _c('div',{key:arg.name,staticClass:"field"},[_c('label',{staticClass:"label"},[_c('span',{domProps:{"textContent":_vm._s(arg.name)}}),_vm._v(" "),_c('small',{staticClass:"is-muted has-text-weight-normal",domProps:{"textContent":_vm._s(arg.type)}})]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.args[idx]),expression:"args[idx]"}],staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.args[idx])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.args, idx, $event.target.value)}}})]),_vm._v(" "),_c('p',{staticClass:"help",domProps:{"textContent":_vm._s(arg.desc)}})])})),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('div',{staticClass:"field is-grouped is-grouped-right"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-primary",on:{"click":function($event){_vm.invoke(_vm.args)}}},[_vm._v("Execute")])])])])]:(_vm.state === 'executing')?[_vm._m(0)]:(_vm.state === 'completed')?[_c('section',{staticClass:"modal-card-body"},[_vm._m(1),_vm._v(" "),_c('pre',{domProps:{"textContent":_vm._s(_vm.result)}})]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('div',{staticClass:"field is-grouped is-grouped-right"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-light",on:{"click":_vm.abort}},[_vm._v(" Close")])])])])]:(_vm.state === 'failed')?[_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n                Execution failed.\n              ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]),_vm._v(" "),(_vm.error.stacktrace)?_c('pre',{domProps:{"textContent":_vm._s(_vm.error.stacktrace)}}):_vm._e(),_vm._v(" "),(_vm.error.response && _vm.error.response.data)?_c('pre',{domProps:{"textContent":_vm._s(_vm.error.response.data)}}):_vm._e()]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('div',{staticClass:"field is-grouped is-grouped-right"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-light",on:{"click":_vm.abort}},[_vm._v(" Close")])])])])]:_vm._e()],2)])])}
var m_bean_operation_invocation_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"modal-card-body"},[_c('section',{staticClass:"section is-loading"},[_c('p',[_vm._v("Executing...")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message is-success"},[_c('div',{staticClass:"message-body"},[_c('strong',[_vm._v("Execution successful.")])])])}]

// CONCATENATED MODULE: ./src/main/frontend/views/instances/jolokia/m-bean-operation-invocation.vue
/* script */


/* template */

/* template functional */
var m_bean_operation_invocation___vue_template_functional__ = false
/* styles */
var m_bean_operation_invocation___vue_styles__ = null
/* scopeId */
var m_bean_operation_invocation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var m_bean_operation_invocation___vue_module_identifier__ = null

var m_bean_operation_invocation_Component = Object(component_normalizer["a" /* default */])(
  m_bean_operation_invocation,
  m_bean_operation_invocation_render,
  m_bean_operation_invocation_staticRenderFns,
  m_bean_operation_invocation___vue_template_functional__,
  m_bean_operation_invocation___vue_styles__,
  m_bean_operation_invocation___vue_scopeId__,
  m_bean_operation_invocation___vue_module_identifier__
)

/* harmony default export */ var jolokia_m_bean_operation_invocation = (m_bean_operation_invocation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/jolokia/m-bean-operations.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var m_bean_operations = ({
  props: {
    domain: {
      type: String,
      required: true
    },
    mBean: {
      type: jolokia_MBean,
      required: true
    },
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  components: { mBeanOperation: jolokia_m_bean_operation, mBeanOperationInvocation: jolokia_m_bean_operation_invocation },
  data: function data() {
    return {
      invocation: null
    };
  },
  computed: {},
  methods: {
    closeInvocation: function closeInvocation() {
      this.invocation = null;
    },
    invoke: function invoke(name, descriptor) {
      this.invocation = { name: name, descriptor: descriptor };
    },
    execute: function execute(args) {
      return this.instance.invokeMBeanOperation(this.domain, this.mBean.descriptor.raw, this.invocation.name, args);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06fcf57c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/jolokia/m-bean-operations.vue
var m_bean_operations_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.mBean.op),function(operation,name){return _c('mBeanOperation',{key:("op-" + name),attrs:{"name":name,"descriptor":operation},on:{"click":function($event){_vm.invoke(name, operation)}}})}),_vm._v(" "),(_vm.invocation)?_c('m-bean-operation-invocation',{attrs:{"name":_vm.invocation.name,"descriptor":_vm.invocation.descriptor,"on-execute":_vm.execute,"on-close":_vm.closeInvocation}}):_vm._e()],2)}
var m_bean_operations_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/jolokia/m-bean-operations.vue
/* script */


/* template */

/* template functional */
var m_bean_operations___vue_template_functional__ = false
/* styles */
var m_bean_operations___vue_styles__ = null
/* scopeId */
var m_bean_operations___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var m_bean_operations___vue_module_identifier__ = null

var m_bean_operations_Component = Object(component_normalizer["a" /* default */])(
  m_bean_operations,
  m_bean_operations_render,
  m_bean_operations_staticRenderFns,
  m_bean_operations___vue_template_functional__,
  m_bean_operations___vue_styles__,
  m_bean_operations___vue_scopeId__,
  m_bean_operations___vue_module_identifier__
)

/* harmony default export */ var jolokia_m_bean_operations = (m_bean_operations_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/jolokia/index.vue






var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function jolokia__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var getOperationName = function getOperationName(name, descriptor) {
  var params = descriptor.args.map(function (arg) {
    return arg.type;
  }).join(',');
  return name + '(' + params + ')';
};

var MBeanDescriptor = function () {
  function MBeanDescriptor(raw) {
    _classCallCheck(this, MBeanDescriptor);

    Object.assign(this, MBeanDescriptor.parse(raw));
    this.raw = raw;
  }

  _createClass(MBeanDescriptor, null, [{
    key: 'parse',
    value: function parse(raw) {
      var attributes = raw.split(',').map(function (attribute) {
        return attribute.split('=');
      }).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            value = _ref2[1];

        return { name: name, value: value };
      });
      var displayName = attributes.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      }).join(' ').trim();
      return { attributes: attributes, displayName: displayName };
    }
  }]);

  return MBeanDescriptor;
}();

var jolokia_MBean = function MBean(_ref4) {
  var descriptor = _ref4.descriptor,
      op = _ref4.op,
      mBean = _objectWithoutProperties(_ref4, ['descriptor', 'op']);

  _classCallCheck(this, MBean);

  Object.assign(this, mBean);
  this.descriptor = new MBeanDescriptor(descriptor);
  var flattenedOps = toPairs_default()(op).flatMap(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        name = _ref6[0],
        value = _ref6[1];

    if (Array.isArray(value)) {
      return value.map(function (v) {
        return [name, v];
      });
    } else {
      return [[name, value]];
    }
  }).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        name = _ref8[0],
        operation = _ref8[1];

    return [getOperationName(name, operation), operation];
  });
  this.op = flattenedOps.length > 0 ? fromPairs_default()(flattenedOps) : null;
};

/* harmony default export */ var jolokia = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  components: { mBeanOperations: jolokia_m_bean_operations, mBeanAttributes: jolokia_m_bean_attributes },
  directives: { onClickaway: vue_clickaway_common["directive"], sticksBelow: sticks_below["a" /* default */] },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      domains: [],
      selected: {
        domain: null,
        mBean: null,
        view: null
      }
    };
  },
  computed: {
    selectedDomain: function selectedDomain() {
      var _this = this;

      return this.domains.find(function (d) {
        return d.domain === _this.selected.domain;
      });
    },
    selectedMBean: function selectedMBean() {
      var _this2 = this;

      return this.selectedDomain && this.selectedDomain.mBeans.find(function (b) {
        return b.descriptor.raw === _this2.selected.mBean;
      });
    }
  },
  created: function created() {
    this.fetchMBeans();
  },

  watch: {
    '$route': {
      immediate: true,
      handler: function handler() {
        if (!isEmpty_default()(this.$route.query)) {
          this.selected = this.$route.query;
        } else if (this.domains.length > 0) {
          this.select(this.domains[0]);
        }
      }
    },
    selected: function selected() {
      if (!isEqual_default()(this.selected, this.$route.query)) {
        this.$router.replace({
          name: 'instances/jolokia',
          query: this.selected
        });
      }
    },
    selectedMBean: function selectedMBean(newVal) {
      var _this3 = this;

      return jolokia__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var el, scrollingEl, navigation, navbarOffset, top;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!newVal) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return _this3.$nextTick();

              case 3:
                el = document.getElementById(newVal.descriptor.raw);

                if (el) {
                  scrollingEl = document.scrollingElement;
                  navigation = document.querySelector('#navigation');
                  navbarOffset = (navigation ? navigation.getBoundingClientRect().bottom : 120) + 10;
                  top = scrollingEl.scrollTop + el.getBoundingClientRect().top - navbarOffset;

                  if (scrollingEl.scrollTo) {
                    scrollingEl.scrollTo({ top: top, behavior: 'smooth' });
                  } else {
                    scrollingEl.scrollTop = top;
                  }
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  },
  methods: {
    fetchMBeans: function fetchMBeans() {
      var _this4 = this;

      return jolokia__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, domains;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.error = null;
                _context2.prev = 1;
                _context2.next = 4;
                return _this4.instance.listMBeans();

              case 4:
                res = _context2.sent;
                domains = sortBy_default()(res.data, [function (d) {
                  return d.domain;
                }]);

                _this4.domains = domains.map(function (domain) {
                  return _extends({}, domain, {
                    mBeans: sortBy_default()(domain.mBeans.map(function (mBean) {
                      return new jolokia_MBean(mBean);
                    }), [function (b) {
                      return b.descriptor.displayName;
                    }])
                  });
                });
                if (!_this4.selectedDomain && _this4.domains.length > 0) {
                  _this4.select(_this4.domains[0]);
                }
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](1);

                console.warn('Fetching MBeans failed:', _context2.t0);
                _this4.error = _context2.t0;

              case 14:
                _this4.hasLoaded = true;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[1, 10]]);
      }))();
    },
    select: function select(domain, mBean, view) {
      this.selected = {
        domain: domain && domain.domain,
        mBean: mBean && mBean.descriptor.raw,
        view: view || (mBean ? mBean.attr ? 'attributes' : mBean.op ? 'operations' : null : null)
      };
    }
  },
  install: function install(_ref9) {
    var viewRegistry = _ref9.viewRegistry;

    viewRegistry.addView({
      name: 'instances/jolokia',
      parent: 'instances',
      path: 'jolokia',
      component: this,
      label: 'JMX',
      group: 'JVM',
      order: 350,
      isEnabled: function isEnabled(_ref10) {
        var instance = _ref10.instance;
        return instance.hasEndpoint('jolokia');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ce7680e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/jolokia/index.vue
var jolokia_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:{ 'is-loading' : !_vm.hasLoaded }},[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n        Fetching JMX Beans failed.\n      ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns"},[(_vm.selectedDomain)?_c('div',{staticClass:"column"},[_c('h1',{staticClass:"heading"},[_vm._v("MBeans")]),_vm._v(" "),_vm._l((_vm.selectedDomain.mBeans),function(mBean){return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(function () { return mBean === _vm.selectedMBean && _vm.select(_vm.selectedDomain); }),expression:"() => mBean === selectedMBean && select(selectedDomain)"}],key:mBean.descriptor.raw,staticClass:"m-bean card",class:{'is-active': mBean === _vm.selectedMBean},attrs:{"id":mBean.descriptor.raw}},[_c('header',{staticClass:"m-bean--header hero",class:{'is-primary': mBean === _vm.selectedMBean, 'is-selectable' : mBean !== _vm.selectedMBean },on:{"click":function($event){_vm.select(_vm.selectedDomain, mBean)}}},[_c('div',{staticClass:"level is-clipped"},[_c('div',{staticClass:"level-left"},_vm._l((mBean.descriptor.attributes),function(attribute){return _c('div',{key:("mBean-desc-" + (attribute.name)),staticClass:"level-item is-narrow"},[_c('div',{staticClass:"is-clipped",attrs:{"title":((attribute.name) + " " + (attribute.value))}},[_c('p',{staticClass:"heading",domProps:{"textContent":_vm._s(attribute.name)}}),_vm._v(" "),_c('p',{staticClass:"title is-size-6",domProps:{"textContent":_vm._s(attribute.value)}})])])}))]),_vm._v(" "),(mBean === _vm.selectedMBean)?_c('sba-icon-button',{staticClass:"m-bean--header--close has-text-white",attrs:{"icon":['far', 'times-circle']},on:{"click":function($event){$event.stopPropagation();_vm.select(_vm.selectedDomain)}}}):_vm._e(),_vm._v(" "),(mBean === _vm.selectedMBean)?_c('div',{staticClass:"hero-foot tabs is-boxed"},[_c('ul',[(mBean.attr)?_c('li',{class:{'is-active' : _vm.selected.view === 'attributes' }},[_c('a',{on:{"click":function($event){$event.stopPropagation();_vm.select(_vm.selectedDomain, _vm.selectedMBean, 'attributes')}}},[_vm._v("Attributes")])]):_vm._e(),_vm._v(" "),(mBean.op)?_c('li',{class:{'is-active' : _vm.selected.view === 'operations' }},[_c('a',{on:{"click":function($event){$event.stopPropagation();_vm.select(_vm.selectedDomain, _vm.selectedMBean, 'operations')}}},[_vm._v("Operations")])]):_vm._e()])]):_vm._e()],1),_vm._v(" "),(mBean === _vm.selectedMBean)?_c('div',{staticClass:"card-content"},[(_vm.selected.view === 'attributes')?_c('m-bean-attributes',{attrs:{"instance":_vm.instance,"domain":_vm.selectedDomain.domain,"m-bean":mBean}}):_vm._e(),_vm._v(" "),(_vm.selected.view === 'operations')?_c('m-bean-operations',{attrs:{"instance":_vm.instance,"domain":_vm.selectedDomain.domain,"m-bean":mBean}}):_vm._e()],1):_vm._e()])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[_c('nav',{directives:[{name:"sticks-below",rawName:"v-sticks-below",value:(['#navigation']),expression:"['#navigation']"}],staticClass:"menu"},[_c('p',{staticClass:"menu-label"},[_vm._v("domains")]),_vm._v(" "),_c('ul',{staticClass:"menu-list"},[_c('li',_vm._l((_vm.domains),function(domain){return _c('a',{key:domain.domain,class:{'is-active' : domain === _vm.selectedDomain},domProps:{"textContent":_vm._s(domain.domain)},on:{"click":function($event){_vm.select(domain)}}})}))])])])])])}
var jolokia_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/jolokia/index.vue
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MBean", function() { return jolokia_MBean; });
function jolokia_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/jolokia/index.vue")
}
/* script */


/* template */

/* template functional */
var jolokia___vue_template_functional__ = false
/* styles */
var jolokia___vue_styles__ = jolokia_injectStyle
/* scopeId */
var jolokia___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var jolokia___vue_module_identifier__ = null

var jolokia_Component = Object(component_normalizer["a" /* default */])(
  jolokia,
  jolokia_render,
  jolokia_staticRenderFns,
  jolokia___vue_template_functional__,
  jolokia___vue_styles__,
  jolokia___vue_scopeId__,
  jolokia___vue_module_identifier__
)

/* harmony default export */ var instances_jolokia = __webpack_exports__["default"] = (jolokia_Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/liquibase/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/liquibase/index.vue
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var liquibase = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      contexts: null,
      showDetails: {}
    };
  },
  computed: {},
  created: function created() {
    this.fetchLiquibase();
  },

  methods: {
    fetchLiquibase: function fetchLiquibase() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.error = null;
                _context.prev = 1;
                _context.next = 4;
                return _this.instance.fetchLiquibase();

              case 4:
                res = _context.sent;

                _this.contexts = res.data.contexts;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.warn('Fetching Liquibase changeSets failed:', _context.t0);
                _this.error = _context.t0;

              case 12:
                _this.hasLoaded = true;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    execClass: function execClass(execType) {
      switch (execType) {
        case 'EXECUTED':
          return 'is-success';
        case 'FAILED':
          return 'is-danger';
        case 'SKIPPED':
          return 'is-light';
        case 'RERAN':
        case 'MARK_RAN':
          return 'is-warning';
        default:
          return 'is-info';
      }
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      name: 'instances/liquibase',
      parent: 'instances',
      path: 'liquibase',
      component: this,
      label: 'Liquibase',
      group: 'Data',
      order: 900,
      isEnabled: function isEnabled(_ref2) {
        var instance = _ref2.instance;
        return instance.hasEndpoint('liquibase');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd28b650","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/liquibase/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:{ 'is-loading' : !_vm.hasLoaded }},[(_vm.hasLoaded)?[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching Liquibase migrations failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.contexts),function(context,ctxName){return [_c('h3',{key:ctxName,staticClass:"title",domProps:{"textContent":_vm._s(ctxName)}}),_vm._v(" "),_vm._l((context.liquibaseBeans),function(report,name){return [_c('sba-panel',{key:(ctxName + "-" + name),staticClass:"change-set",attrs:{"title":"name","header-sticks-below":['#navigation']}},[_c('table',{staticClass:"table is-hoverable is-fullwidth"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Id")]),_vm._v(" "),_c('th',[_vm._v("Execution")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Tag")]),_vm._v(" "),_c('th',[_vm._v("Contexts")]),_vm._v(" "),_c('th',[_vm._v("Labels")])])]),_vm._v(" "),_c('tbody',[_vm._l((report.changeSets),function(changeSet){return [_c('tr',{key:(ctxName + "-" + name + "-" + (changeSet.id)),staticClass:"is-selectable",on:{"click":function($event){_vm.showDetails[changeSet.checksum] ? _vm.$delete(_vm.showDetails, changeSet.checksum) : _vm.$set(_vm.showDetails, changeSet.checksum, true)}}},[_c('td',{domProps:{"textContent":_vm._s(changeSet.id)}}),_vm._v(" "),_c('td',[_c('span',{staticClass:"tag",class:_vm.execClass(_vm.execType),domProps:{"textContent":_vm._s(changeSet.execType)}})]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(changeSet.description)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(changeSet.tag)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(changeSet.contexts.join(', '))}}),_vm._v(" "),_c('td',_vm._l((changeSet.labels),function(label){return _c('span',{key:(ctxName + "-" + name + "-" + (changeSet.id) + "-" + label),staticClass:"tag is-info",domProps:{"textContent":_vm._s(label)}})}))]),_vm._v(" "),(_vm.showDetails[changeSet.checksum])?_c('tr',{key:(ctxName + "-" + name + "-" + (changeSet.id) + "-details")},[_c('td',{attrs:{"colspan":"6"}},[_c('table',{staticClass:"table is-fullwidth"},[_c('tr',[_c('th',[_vm._v("Changelog")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"},domProps:{"textContent":_vm._s(changeSet.changeLog)}}),_vm._v(" "),_c('th',[_vm._v("Author")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(changeSet.author)}})]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Checksum")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(changeSet.checksum)}}),_vm._v(" "),_c('th',[_vm._v("Comments")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"},domProps:{"textContent":_vm._s(changeSet.comments)}})]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Execution Order")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(changeSet.orderExecuted)}}),_vm._v(" "),_c('th',[_vm._v("ExecutionDate")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(changeSet.dateExecuted)}}),_vm._v(" "),_c('th',[_vm._v("DeploymentId")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(changeSet.deploymentId)}})])])])]):_vm._e()]})],2)])])]})]})]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/liquibase/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  liquibase,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var instances_liquibase = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/logfile/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/chunk.js
var lodash_chunk = __webpack_require__("./node_modules/lodash/chunk.js");
var chunk_default = /*#__PURE__*/__webpack_require__.n(lodash_chunk);

// EXTERNAL MODULE: ./src/main/frontend/mixins/subscribing.js
var subscribing = __webpack_require__("./src/main/frontend/mixins/subscribing.js");

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/autolink.js
var autolink = __webpack_require__("./src/main/frontend/utils/autolink.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/rxjs.js
var rxjs = __webpack_require__("./src/main/frontend/utils/rxjs.js");

// EXTERNAL MODULE: ./node_modules/ansi_up/ansi_up.js
var ansi_up = __webpack_require__("./node_modules/ansi_up/ansi_up.js");
var ansi_up_default = /*#__PURE__*/__webpack_require__.n(ansi_up);

// EXTERNAL MODULE: ./node_modules/pretty-bytes/index.js
var pretty_bytes = __webpack_require__("./node_modules/pretty-bytes/index.js");
var pretty_bytes_default = /*#__PURE__*/__webpack_require__.n(pretty_bytes);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/logfile/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var logfile = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      atBottom: true,
      atTop: false,
      skippedBytes: null
    };
  },
  created: function created() {
    this.ansiUp = new ansi_up_default.a();
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },

  methods: {
    prettyBytes: pretty_bytes_default.a,
    createSubscription: function createSubscription() {
      var _this = this;

      var vm = this;
      vm.error = null;
      return this.instance.streamLogfile(1000).pipe(Object(rxjs["t" /* tap */])(function (chunk) {
        return vm.skippedBytes = vm.skippedBytes || chunk.skipped;
      }), Object(rxjs["g" /* concatMap */])(function (chunk) {
        return chunk_default()(chunk.addendum.split(/\r?\n/), 250);
      }), Object(rxjs["p" /* map */])(function (lines) {
        return Object(rxjs["r" /* of */])(lines, rxjs["d" /* animationFrameScheduler */]);
      }), Object(rxjs["f" /* concatAll */])()).subscribe({
        next: function next(lines) {
          vm.hasLoaded = true;
          lines.forEach(function (line) {
            var child = document.createElement('pre');
            child.innerHTML = Object(autolink["b" /* default */])(_this.ansiUp.ansi_to_html(line));
            vm.$el.appendChild(child);
          });

          if (vm.atBottom) {
            vm.scrollToBottom();
          }
        },
        error: function error(_error) {
          vm.hasLoaded = true;
          console.warn('Fetching logfile failed:', _error);
          vm.error = _error;
        }
      });
    },
    onScroll: function onScroll() {
      var scrollingEl = document.scrollingElement;
      var visibleHeight = document.documentElement.clientHeight;
      this.atBottom = visibleHeight === scrollingEl.scrollHeight - scrollingEl.scrollTop;
      this.atTop = scrollingEl.scrollTop <= 0;
    },
    scrollToTop: function scrollToTop() {
      document.scrollingElement.scrollTop = 0;
    },
    scrollToBottom: function scrollToBottom() {
      document.scrollingElement.scrollTop = document.scrollingElement.scrollHeight;
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      name: 'instances/logfile',
      parent: 'instances',
      path: 'logfile',
      component: this,
      label: 'Logfile',
      group: 'Logging',
      order: 200,
      isEnabled: function isEnabled(_ref2) {
        var instance = _ref2.instance;
        return instance.hasEndpoint('logfile');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fdbd227","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/logfile/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section logfile-view",class:{ 'is-loading' : !_vm.hasLoaded }},[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n        Fetching logfile failed.\n      ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.hasLoaded)?_c('div',{staticClass:"logfile-view-actions"},[_c('div',{staticClass:"logfile-view-actions__navigation"},[_c('sba-icon-button',{attrs:{"disabled":_vm.atTop,"icon":"step-backward","size":"lg","icon-class":"rotated"},on:{"click":_vm.scrollToTop}}),_vm._v(" "),_c('sba-icon-button',{attrs:{"disabled":_vm.atBottom,"icon":"step-forward","size":"lg","icon-class":"rotated"},on:{"click":_vm.scrollToBottom}})],1),_vm._v(" "),_c('a',{staticClass:"button",attrs:{"href":("instances/" + (_vm.instance.id) + "/actuator/logfile"),"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":"download"}}),_vm._v(" Download\n    ")],1)]):_vm._e(),_vm._v(" "),(_vm.skippedBytes)?_c('p',{domProps:{"textContent":_vm._s(("skipped " + (_vm.prettyBytes(_vm.skippedBytes))))}}):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/logfile/index.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/logfile/index.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  logfile,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var instances_logfile = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/loggers/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/loggers/logger-control.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var logger_control = ({
  props: {
    effectiveLevel: {
      type: String,
      required: true
    },
    configuredLevel: {
      type: String,
      default: null
    },
    levelOptions: {
      type: Array,
      required: true
    },
    allowReset: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: String,
      default: undefined
    }
  },
  computed: {
    level: function level() {
      return this.configuredLevel || this.effectiveLevel;
    },
    configured: function configured() {
      return !!this.configuredLevel;
    }
  },
  methods: {
    selectLevel: function selectLevel(level) {
      this.$emit('input', level);
    },
    cssClass: function cssClass(level) {
      return {
        'logger-control__level--inherited': this.level === level && !this.configured,
        'is-active is-danger': this.level === level && this.level === 'TRACE',
        'is-active is-warning': this.level === level && this.level === 'DEBUG',
        'is-active is-info': this.level === level && this.level === 'INFO',
        'is-active is-success': this.level === level && this.level === 'WARN',
        'is-active is-light': this.level === level && this.level === 'ERROR',
        'is-active is-black': this.level === level && this.level === 'OFF',
        'is-loading': this.isLoading === level
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e031cac","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/loggers/logger-control.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field is-grouped logger-control"},[_c('div',{staticClass:"control buttons has-addons"},_vm._l((_vm.levelOptions),function(level){return _c('button',{key:level,staticClass:"button logger-control__level",class:_vm.cssClass(level),domProps:{"textContent":_vm._s(level)},on:{"click":function($event){$event.stopPropagation();_vm.selectLevel(level)}}})})),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-light",class:{ 'is-loading' : _vm.isLoading === null },attrs:{"disabled":!_vm.configured || !_vm.allowReset},on:{"click":function($event){$event.stopPropagation();_vm.selectLevel(null)}}},[_vm._v("\n      Reset\n    ")])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/loggers/logger-control.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/loggers/logger-control.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  logger_control,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var loggers_logger_control = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/loggers/index.vue
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var isClassName = function isClassName(name) {
  return (/\.[A-Z]/.test(name)
  );
};

var addToFilter = function addToFilter(oldFilter, addedFilter) {
  return !oldFilter ? addedFilter : function (val, key) {
    return oldFilter(val, key) && addedFilter(val, key);
  };
};

/* harmony default export */ var loggers = ({
  components: {
    sbaLoggerControl: loggers_logger_control
  },
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      loggerConfig: null,
      filter: '',
      showClassLoggersOnly: false,
      showConfiguredLoggersOnly: false,
      visibleLimit: 25,
      loading: {},
      failed: {}
    };
  },
  computed: {
    levels: function levels() {
      return this.loggerConfig.levels;
    },
    limitedLoggers: function limitedLoggers() {
      if (this.visibleLimit > 0) {
        return this.filteredLoggers.slice(0, this.visibleLimit);
      } else {
        return this.filteredLoggers;
      }
    },
    filteredLoggers: function filteredLoggers() {
      var filterFn = this.getFilterFn();
      return filterFn ? this.loggerConfig.loggers.filter(filterFn) : this.loggerConfig.loggers;
    }
  },
  methods: {
    configureLogger: function configureLogger(logger, level) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var vm, setLoadingHandle;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = _this;
                setLoadingHandle = setTimeout(function () {
                  return vm.$set(vm.loading, logger.name, level);
                }, 150);
                _context.prev = 2;
                _context.next = 5;
                return _this.instance.configureLogger(logger.name, level);

              case 5:
                vm.$delete(vm.failed, logger.name, level);
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                console.warn('Configuring logger \'' + logger.name + '\' failed:', _context.t0);
                vm.$set(vm.failed, logger.name, level);

              case 12:
                _context.prev = 12;
                _context.next = 15;
                return _this.fetchLoggers();

              case 15:
                _context.prev = 15;

                vm.$delete(vm.loading, logger.name);
                clearTimeout(setLoadingHandle);
                return _context.finish(15);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 8], [12,, 15, 19]]);
      }))();
    },

    fetchLoggers: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.error = null;
                _context2.prev = 1;
                _context2.next = 4;
                return this.instance.fetchLoggers();

              case 4:
                res = _context2.sent;

                this.loggerConfig = res.data;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                console.warn('Fetching loggers failed:', _context2.t0);
                this.error = _context2.t0;

              case 12:
                this.hasLoaded = true;

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function fetchLoggers() {
        return _ref.apply(this, arguments);
      }

      return fetchLoggers;
    }(),
    onScroll: function onScroll() {
      if (this.loggerConfig && this.$el.getBoundingClientRect().bottom - 400 <= window.innerHeight && this.visibleLimit < this.filteredLoggers.length) {
        this.visibleLimit += 25;
      }
    },
    getFilterFn: function getFilterFn() {
      var filterFn = null;

      if (this.showClassLoggersOnly) {
        filterFn = addToFilter(filterFn, function (logger) {
          return isClassName(logger.name);
        });
      }

      if (this.showConfiguredLoggersOnly) {
        filterFn = addToFilter(filterFn, function (logger) {
          return !!logger.configuredLevel;
        });
      }

      if (this.filter) {
        var normalizedFilter = this.filter.toLowerCase();
        filterFn = addToFilter(filterFn, function (logger) {
          return logger.name.toLowerCase().includes(normalizedFilter);
        });
      }

      return filterFn;
    }
  },
  created: function created() {
    this.fetchLoggers();
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  install: function install(_ref2) {
    var viewRegistry = _ref2.viewRegistry;

    viewRegistry.addView({
      name: 'instances/loggers',
      parent: 'instances',
      path: 'loggers',
      component: this,
      label: 'Loggers',
      group: 'Logging',
      order: 300,
      isEnabled: function isEnabled(_ref3) {
        var instance = _ref3.instance;
        return instance.hasEndpoint('loggers');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b4dbcc1","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/loggers/index.vue
var loggers_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:{ 'is-loading' : !_vm.hasLoaded }},[(_vm.hasLoaded)?[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching loggers failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.loggerConfig)?[_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field has-addons"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"input",attrs:{"type":"search","placeholder":"name filter"},domProps:{"value":(_vm.filter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('span',{staticClass:"button is-static"},[_c('span',{domProps:{"textContent":_vm._s(_vm.filteredLoggers.length)}}),_vm._v("\n              /\n              "),_c('span',{domProps:{"textContent":_vm._s(_vm.loggerConfig.loggers.length)}})])])])]),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field is-narrow"},[_c('div',{staticClass:"control"},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showClassLoggersOnly),expression:"showClassLoggersOnly"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showClassLoggersOnly)?_vm._i(_vm.showClassLoggersOnly,null)>-1:(_vm.showClassLoggersOnly)},on:{"change":function($event){var $$a=_vm.showClassLoggersOnly,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showClassLoggersOnly=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showClassLoggersOnly=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showClassLoggersOnly=$$c}}}}),_vm._v("\n              class only\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"field is-narrow"},[_c('div',{staticClass:"control"},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showConfiguredLoggersOnly),expression:"showConfiguredLoggersOnly"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showConfiguredLoggersOnly)?_vm._i(_vm.showConfiguredLoggersOnly,null)>-1:(_vm.showConfiguredLoggersOnly)},on:{"change":function($event){var $$a=_vm.showConfiguredLoggersOnly,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showConfiguredLoggersOnly=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showConfiguredLoggersOnly=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showConfiguredLoggersOnly=$$c}}}}),_vm._v("\n              configured\n            ")])])])])]:_vm._e(),_vm._v(" "),(_vm.loggerConfig)?_c('table',{staticClass:"table is-hoverable is-fullwidth"},[_c('tbody',[_vm._l((_vm.limitedLoggers),function(logger){return _c('tr',{key:logger.name},[_c('td',[_c('span',{staticClass:"is-breakable",domProps:{"textContent":_vm._s(logger.name)}}),_vm._v(" "),(logger.name in _vm.failed)?_c('span',{staticClass:"has-text-danger"},[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(("Configuring " + (_vm.failed[logger.name]) + " failed."))}})],1):_vm._e(),_vm._v(" "),_c('sba-logger-control',{staticClass:"is-pulled-right",attrs:{"level-options":_vm.levels,"effective-level":logger.effectiveLevel,"configured-level":logger.configuredLevel,"is-loading":_vm.loading[logger.name],"has-failed":_vm.failed[logger.name],"allow-reset":logger.name !== 'ROOT'},on:{"input":function (level) { return _vm.configureLogger(logger, level); }}})],1)])}),_vm._v(" "),(_vm.limitedLoggers.length === 0)?_c('tr',[_c('td',{staticClass:"is-muted",attrs:{"colspan":"5"}},[_vm._v("No loggers found.\n          ")])]):_vm._e()],2)]):_vm._e()]:_vm._e()],2)}
var loggers_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/loggers/index.vue
function loggers_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/loggers/index.vue")
}
/* script */


/* template */

/* template functional */
var loggers___vue_template_functional__ = false
/* styles */
var loggers___vue_styles__ = loggers_injectStyle
/* scopeId */
var loggers___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loggers___vue_module_identifier__ = null

var loggers_Component = Object(component_normalizer["a" /* default */])(
  loggers,
  loggers_render,
  loggers_staticRenderFns,
  loggers___vue_template_functional__,
  loggers___vue_styles__,
  loggers___vue_scopeId__,
  loggers___vue_module_identifier__
)

/* harmony default export */ var instances_loggers = __webpack_exports__["default"] = (loggers_Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/mappings/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("./node_modules/lodash/isEmpty.js");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/mappings/DispatcherMappings.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DispatcherMappings = ({
  props: {
    dispatchers: {
      type: Object,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    countNonEmptyArrays: function countNonEmptyArrays(obj) {
      for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        keys[_key - 1] = arguments[_key];
      }

      return keys.map(function (key) {
        return obj[key];
      }).filter(function (a) {
        return a && a.length;
      }).length;
    },
    mediaTypePredicates: function mediaTypePredicates(types) {
      return types.map(function (p) {
        return '' + (p.negate ? '!' : '') + p.mediaType;
      }).join(', ');
    },
    paramPredicates: function paramPredicates(params) {
      return params.map(function (p) {
        return p.name + ': ' + (p.negate ? '!' : '') + p.value;
      }).join(', ');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57291834","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/mappings/DispatcherMappings.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container"},[_c('table',{staticClass:"table is-fullwidth"},[_vm._l((this.dispatchers),function(handlerMappings,dispatcherName){return [_c('thead',{key:("" + dispatcherName)},[_c('tr',[_c('th',{attrs:{"colspan":"99"},domProps:{"textContent":_vm._s(dispatcherName)}})])]),_vm._v(" "),_c('tbody',{key:(dispatcherName + "_mappings")},[_vm._l((handlerMappings),function(mapping,idx){return [(mapping.details)?[_c('tr',{key:(dispatcherName + "_" + idx + "_pattern")},[_c('td',{attrs:{"rowspan":2 + _vm.countNonEmptyArrays(mapping.details.requestMappingConditions, 'methods', 'consumes', 'produces', 'params', 'headers')}},_vm._l((mapping.details.requestMappingConditions.patterns),function(pattern){return _c('div',{key:(dispatcherName + "_" + idx + "_" + pattern)},[_c('code',{domProps:{"textContent":_vm._s(pattern)}})])}))]),_vm._v(" "),(mapping.details.requestMappingConditions.methods.length)?_c('tr',{key:(dispatcherName + "_" + idx + "_methods")},[_vm._m(0,true),_vm._v(" "),_c('td',{staticClass:"monospaced is-breakable",domProps:{"textContent":_vm._s(mapping.details.requestMappingConditions.methods.join(', '))}})]):_vm._e(),_vm._v(" "),(mapping.details.requestMappingConditions.consumes.length)?_c('tr',{key:(dispatcherName + "_" + idx + "_consumes")},[_vm._m(1,true),_vm._v(" "),_c('td',{staticClass:"monospaced is-breakable",domProps:{"textContent":_vm._s(_vm.mediaTypePredicates(mapping.details.requestMappingConditions.consumes))}})]):_vm._e(),_vm._v(" "),(mapping.details.requestMappingConditions.produces.length)?_c('tr',{key:(dispatcherName + "_" + idx + "_produces")},[_vm._m(2,true),_vm._v(" "),_c('td',{staticClass:"monospaced is-breakable",domProps:{"textContent":_vm._s(_vm.mediaTypePredicates(mapping.details.requestMappingConditions.produces))}})]):_vm._e(),_vm._v(" "),(mapping.details.requestMappingConditions.params.length)?_c('tr',{key:(dispatcherName + "_" + idx + "_params")},[_vm._m(3,true),_vm._v(" "),_c('td',{staticClass:"monospaced is-breakable",domProps:{"textContent":_vm._s(_vm.paramPredicates(mapping.details.requestMappingConditions.params))}})]):_vm._e(),_vm._v(" "),(mapping.details.requestMappingConditions.headers.length)?_c('tr',{key:(dispatcherName + "_" + idx + "_headers")},[_vm._m(4,true),_vm._v(" "),_c('td',{staticClass:"monospaced is-breakable",domProps:{"textContent":_vm._s(_vm.paramPredicates(mapping.details.requestMappingConditions.headers))}})]):_vm._e(),_vm._v(" "),_c('tr',{key:(dispatcherName + "_" + idx + "_handler")},[_vm._m(5,true),_vm._v(" "),_c('td',{staticClass:"is-breakable",domProps:{"textContent":_vm._s(mapping.handler)}})])]:_c('tr',{key:(dispatcherName + "_" + idx)},[_c('td',[_c('code',{domProps:{"textContent":_vm._s(mapping.predicate)}})]),_vm._v(" "),_vm._m(6,true),_vm._v(" "),_c('td',{attrs:{"colspan":"4"},domProps:{"textContent":_vm._s(mapping.handler)}})])]})],2)]})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"is-narrow"},[_c('small',[_vm._v("Methods")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"is-narrow"},[_c('small',[_vm._v("Consumes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"is-narrow"},[_c('small',[_vm._v("Produces")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"is-narrow"},[_c('small',[_vm._v("Parameters")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"is-narrow"},[_c('small',[_vm._v("Headers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"is-narrow"},[_c('small',[_vm._v("Handler")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"is-narrow is-breakable"},[_c('small',[_vm._v("Handler")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/mappings/DispatcherMappings.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  DispatcherMappings,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mappings_DispatcherMappings = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/mappings/ServletFilterMappings.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ServletFilterMappings = ({
  props: {
    servletFilters: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d0cab0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/mappings/ServletFilterMappings.vue
var ServletFilterMappings_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container"},[(_vm.servletFilters.length)?_c('table',{staticClass:"table is-fullwidth"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.servletFilters),function(servletFilterMapping){return [_c('tr',{key:("" + (servletFilterMapping.name))},[_c('td',_vm._l((servletFilterMapping.urlPatternMappings),function(mapping){return _c('div',{key:((servletFilterMapping.name) + "_" + mapping)},[_c('code',{domProps:{"textContent":_vm._s(mapping)}})])})),_vm._v(" "),_c('td',_vm._l((servletFilterMapping.servletNameMappings),function(mapping){return _c('div',{key:((servletFilterMapping.name) + "_" + mapping),staticClass:"is-breakable",domProps:{"textContent":_vm._s(mapping)}})})),_vm._v(" "),_c('td',{staticClass:"is-breakable",domProps:{"textContent":_vm._s(servletFilterMapping.name)}}),_vm._v(" "),_c('td',{staticClass:"is-breakable",domProps:{"textContent":_vm._s(servletFilterMapping.className)}})])]})],2)]):_vm._e()])}
var ServletFilterMappings_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Url Pattern")]),_vm._v(" "),_c('th',[_vm._v("Servlet Name")]),_vm._v(" "),_c('th',[_vm._v("Filter Name")]),_vm._v(" "),_c('th',[_vm._v("Class")])])])}]

// CONCATENATED MODULE: ./src/main/frontend/views/instances/mappings/ServletFilterMappings.vue
/* script */


/* template */

/* template functional */
var ServletFilterMappings___vue_template_functional__ = false
/* styles */
var ServletFilterMappings___vue_styles__ = null
/* scopeId */
var ServletFilterMappings___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ServletFilterMappings___vue_module_identifier__ = null

var ServletFilterMappings_Component = Object(component_normalizer["a" /* default */])(
  ServletFilterMappings,
  ServletFilterMappings_render,
  ServletFilterMappings_staticRenderFns,
  ServletFilterMappings___vue_template_functional__,
  ServletFilterMappings___vue_styles__,
  ServletFilterMappings___vue_scopeId__,
  ServletFilterMappings___vue_module_identifier__
)

/* harmony default export */ var mappings_ServletFilterMappings = (ServletFilterMappings_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/mappings/ServletMappings.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ServletMappings = ({
  props: {
    servlets: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a05e87","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/mappings/ServletMappings.vue
var ServletMappings_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container"},[(_vm.servlets.length)?_c('table',{staticClass:"table is-fullwidth"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.servlets),function(servletMapping){return [_c('tr',{key:("" + (servletMapping.name))},[_c('td',_vm._l((servletMapping.mappings),function(mapping){return _c('div',{key:((servletMapping.name) + "_" + mapping)},[_c('code',{domProps:{"textContent":_vm._s(mapping)}})])})),_vm._v(" "),_c('td',{staticClass:"is-breakable",domProps:{"textContent":_vm._s(servletMapping.name)}}),_vm._v(" "),_c('td',{staticClass:"is-breakable",domProps:{"textContent":_vm._s(servletMapping.className)}})])]})],2)]):_vm._e()])}
var ServletMappings_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Url Pattern")]),_vm._v(" "),_c('th',[_vm._v("Servlet Name")]),_vm._v(" "),_c('th',[_vm._v("Class")])])])}]

// CONCATENATED MODULE: ./src/main/frontend/views/instances/mappings/ServletMappings.vue
/* script */


/* template */

/* template functional */
var ServletMappings___vue_template_functional__ = false
/* styles */
var ServletMappings___vue_styles__ = null
/* scopeId */
var ServletMappings___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ServletMappings___vue_module_identifier__ = null

var ServletMappings_Component = Object(component_normalizer["a" /* default */])(
  ServletMappings,
  ServletMappings_render,
  ServletMappings_staticRenderFns,
  ServletMappings___vue_template_functional__,
  ServletMappings___vue_styles__,
  ServletMappings___vue_scopeId__,
  ServletMappings___vue_module_identifier__
)

/* harmony default export */ var mappings_ServletMappings = (ServletMappings_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/mappings/index.vue


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var mappings = ({
  components: { DispatcherMappings: mappings_DispatcherMappings, ServletMappings: mappings_ServletMappings, ServletFilterMappings: mappings_ServletFilterMappings },
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      contexts: null,
      isOldMetrics: false
    };
  },
  created: function created() {
    this.fetchMappings();
  },

  computed: {},
  methods: {
    isEmpty: isEmpty_default.a,
    fetchMappings: function fetchMappings() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.error = null;
                _context.prev = 1;
                _context.next = 4;
                return _this.instance.fetchMappings();

              case 4:
                res = _context.sent;

                if (res.headers['content-type'].includes('application/vnd.spring-boot.actuator.v2')) {
                  _this.contexts = res.data.contexts;
                } else {
                  _this.isOldMetrics = true;
                }
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.warn('Fetching mappings failed:', _context.t0);
                _this.error = _context.t0;

              case 12:
                _this.hasLoaded = true;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      name: 'instances/mappings',
      parent: 'instances',
      path: 'mappings',
      group: 'Web',
      component: this,
      label: 'Mappings',
      order: 450,
      isEnabled: function isEnabled(_ref2) {
        var instance = _ref2.instance;
        return instance.hasEndpoint('mappings');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff0eca9e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/mappings/index.vue
var mappings_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:{ 'is-loading' : !_vm.hasLoaded }},[(_vm.hasLoaded)?[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching mappings failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.isOldMetrics)?_c('div',{staticClass:"message is-warning"},[_c('div',{staticClass:"message-body"},[_vm._v("\n        Mappings are not supported for Spring Boot 1.x applications.\n      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.contexts),function(context,ctxName){return [_c('h3',{key:ctxName,staticClass:"title",domProps:{"textContent":_vm._s(ctxName)}}),_vm._v(" "),(!_vm.isEmpty(context.mappings.dispatcherServlets))?_c('DispatcherMappings',{key:(ctxName + "_dispatcherServlets"),attrs:{"dispatchers":context.mappings.dispatcherServlets}}):_vm._e(),_vm._v(" "),(!_vm.isEmpty(context.mappings.dispatcherHandlers))?_c('DispatcherMappings',{key:(ctxName + "_dispatcherHandlers"),attrs:{"dispatchers":context.mappings.dispatcherHandlers}}):_vm._e(),_vm._v(" "),_c('ServletMappings',{key:(ctxName + "_servlets"),attrs:{"servlets":context.mappings.servlets}}),_vm._v(" "),_c('ServletFilterMappings',{key:(ctxName + "_servletFilters"),attrs:{"servlet-filters":context.mappings.servletFilters}})]})]:_vm._e()],2)}
var mappings_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/mappings/index.vue
/* script */


/* template */

/* template functional */
var mappings___vue_template_functional__ = false
/* styles */
var mappings___vue_styles__ = null
/* scopeId */
var mappings___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mappings___vue_module_identifier__ = null

var mappings_Component = Object(component_normalizer["a" /* default */])(
  mappings,
  mappings_render,
  mappings_staticRenderFns,
  mappings___vue_template_functional__,
  mappings___vue_styles__,
  mappings___vue_scopeId__,
  mappings___vue_module_identifier__
)

/* harmony default export */ var instances_mappings = __webpack_exports__["default"] = (mappings_Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/metrics/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("./node_modules/lodash/sortBy.js");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./src/main/frontend/views/instances/metrics/metric.vue + 2 modules
var metrics_metric = __webpack_require__("./src/main/frontend/views/instances/metrics/metric.vue");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/metrics/index.vue


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var stringify = function stringify(metrics) {
  return { q: metrics.map(JSON.stringify) };
};

var parse = function parse(query) {
  if (!query.q) {
    return [];
  }
  if (query.q instanceof Array) {
    return query.q.map(JSON.parse);
  } else {
    return JSON.parse(query.q);
  }
};

/* harmony default export */ var metrics = ({
  components: { Metric: metrics_metric["a" /* default */] },
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  data: function data() {
    return {
      metrics: [],
      error: null,
      availableMetrics: [],
      selectedMetric: null,
      stateFetchingTags: null,
      availableTags: null,
      selectedTags: null,
      isOldMetrics: false
    };
  },
  created: function created() {
    this.fetchMetricIndex();
  },

  watch: {
    selectedMetric: 'fetchAvailableTags',
    metrics: {
      deep: true,
      handler: function handler() {
        this.$router.replace({
          name: 'instances/metrics',
          query: stringify(this.metrics)
        });
      }
    },
    '$route.query': {
      immediate: true,
      handler: function handler() {
        this.metrics = parse(this.$route.query);
      }
    }
  },
  methods: {
    handleSubmit: function handleSubmit() {
      this.addMetric(this.selectedMetric, this.selectedTags);
    },
    handleTypeSelect: function handleTypeSelect(metricName, statistic, type) {
      var metric = this.metrics.find(function (m) {
        return m.name === metricName;
      });
      if (metric) {
        metric.types = _extends({}, metric.types, _defineProperty({}, statistic, type));
      }
    },
    removeMetric: function removeMetric(metricName, idxTagSelection) {
      var idxMetric = this.metrics.findIndex(function (m) {
        return m.name === metricName;
      });
      if (idxMetric >= 0) {
        var metric = this.metrics[idxMetric];
        if (idxTagSelection < metric.tagSelections.length) {
          metric.tagSelections.splice(idxTagSelection, 1);
        }
        if (metric.tagSelections.length === 0) {
          this.metrics.splice(idxMetric, 1);
        }
      }
    },
    addMetric: function addMetric(metricName) {
      var tagSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (metricName) {
        var metric = this.metrics.find(function (m) {
          return m.name === metricName;
        });
        if (metric) {
          metric.tagSelections = [].concat(_toConsumableArray(metric.tagSelections), [_extends({}, tagSelection)]);
        } else {
          this.metrics = sortBy_default()([].concat(_toConsumableArray(this.metrics), [{
            name: metricName,
            tagSelections: [_extends({}, tagSelection)],
            types: {}
          }]), [function (m) {
            return m.name;
          }]);
        }
      }
    },
    fetchMetricIndex: function fetchMetricIndex() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.error = null;
                _context.prev = 1;
                _context.next = 4;
                return _this.instance.fetchMetrics();

              case 4:
                res = _context.sent;

                if (res.headers['content-type'].includes('application/vnd.spring-boot.actuator.v2')) {
                  _this.availableMetrics = res.data.names;
                  _this.availableMetrics.sort();
                  _this.selectedMetric = _this.availableMetrics[0];
                } else {
                  _this.isOldMetrics = true;
                }
                _context.next = 13;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.warn('Fetching metric index failed:', _context.t0);
                _this.hasLoaded = true;
                _this.error = _context.t0;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    fetchAvailableTags: function fetchAvailableTags(metricName) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.availableTags = null;
                _this2.stateFetchingTags = 'executing';
                _context2.prev = 2;
                _context2.next = 5;
                return _this2.instance.fetchMetric(metricName);

              case 5:
                response = _context2.sent;

                _this2.availableTags = response.data.availableTags;
                _this2.stateFetchingTags = 'completed';
                _this2.selectedTags = {};
                _this2.availableTags.forEach(function (t) {
                  return _this2.selectedTags[t.tag] = undefined;
                });
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](2);

                console.warn('Fetching metric tags failed:', _context2.t0);
                _this2.stateFetchingTags = 'failed';

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 12]]);
      }))();
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      name: 'instances/metrics',
      parent: 'instances',
      path: 'metrics',
      component: this,
      label: 'Metrics',
      group: 'Insights',
      order: 50,
      isEnabled: function isEnabled(_ref2) {
        var instance = _ref2.instance;
        return instance.hasEndpoint('metrics');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f787853","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/metrics/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n        Fetching metrics failed.\n      ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.isOldMetrics)?_c('div',{staticClass:"message is-warning"},[_c('div',{staticClass:"message-body"},[_vm._v("\n      Metrics are not supported for Spring Boot 1.x applications.\n    ")])]):(_vm.availableMetrics.length > 0)?_c('form',{staticClass:"field",on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit($event)}}},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMetric),expression:"selectedMetric"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedMetric=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.availableMetrics),function(metric){return _c('option',{key:metric,domProps:{"textContent":_vm._s(metric)}})}))])])]),_vm._v(" "),_c('div',[(_vm.stateFetchingTags === 'executing')?_c('p',{staticClass:"is-loading"},[_vm._v("Fetching available tags")]):_vm._e(),_vm._v(" "),(_vm.availableTags)?_c('div',{staticClass:"box"},[_vm._l((_vm.availableTags),function(tag){return _c('div',{key:tag.tag,staticClass:"field is-horizontal"},[_c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label",domProps:{"textContent":_vm._s(tag.tag)}})]),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTags[tag.tag]),expression:"selectedTags[tag.tag]"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedTags, tag.tag, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("-")]),_vm._v(" "),_vm._l((tag.values),function(value){return _c('option',{key:value,domProps:{"value":value,"textContent":_vm._s(value)}})})],2)])])])])}),_vm._v(" "),(_vm.availableTags && _vm.availableTags.length === 0)?_c('p',[_vm._v("\n          No tags available.\n        ")]):_vm._e(),_vm._v(" "),_vm._m(0)],2):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._l((_vm.metrics),function(metric){return _c('metric',{key:metric.name,attrs:{"metric-name":metric.name,"tag-selections":metric.tagSelections,"statistic-types":metric.types,"instance":_vm.instance},on:{"remove":_vm.removeMetric,"type-select":_vm.handleTypeSelect}})})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field is-grouped is-grouped-right"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-primary",attrs:{"type":"submit"}},[_vm._v("Add Metric")])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/metrics/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  metrics,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var instances_metrics = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/metrics/metric.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash/entries.js
var entries = __webpack_require__("./node_modules/lodash/entries.js");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./src/main/frontend/mixins/subscribing.js
var subscribing = __webpack_require__("./src/main/frontend/mixins/subscribing.js");

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/rxjs.js
var rxjs = __webpack_require__("./src/main/frontend/utils/rxjs.js");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("./node_modules/moment/moment.js");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/pretty-bytes/index.js
var pretty_bytes = __webpack_require__("./node_modules/pretty-bytes/index.js");
var pretty_bytes_default = /*#__PURE__*/__webpack_require__.n(pretty_bytes);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/metrics/metric.vue


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var metric_formatDuration = function formatDuration(value, baseUnit) {
  var duration = moment_default.a.duration(toMillis(value, baseUnit));
  return Math.floor(duration.asDays()) + 'd ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's';
};

var metric_formatMillis = function formatMillis(value, baseUnit) {
  var duration = moment_default.a.duration(toMillis(value, baseUnit));
  return moment_default.a.duration(duration).asMilliseconds().toFixed(0) + ' ms';
};

var toMillis = function toMillis(value, baseUnit) {
  switch (baseUnit) {
    case 'nanoseconds':
      return value / 1000000;
    case 'microseconds':
      return value / 1000;
    case 'milliseconds':
      return value;
    case 'seconds':
    default:
      return value * 1000;
  }
};

/* harmony default export */ var metric = ({
  name: 'Metric',
  mixins: [subscribing["a" /* default */]],
  props: {
    metricName: {
      type: String,
      required: true
    },
    instance: {
      type: instance["a" /* default */],
      required: true
    },
    tagSelections: {
      type: Array,
      default: function _default() {
        return [{}];
      }
    },
    statisticTypes: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      description: '',
      baseUnit: undefined,
      measurements: [],
      statistics: [],
      errors: []
    };
  },
  methods: {
    handleRemove: function handleRemove(idx) {
      this.$emit('remove', this.metricName, idx);
    },
    getValue: function getValue(measurements, statistic) {
      var measurement = measurements && measurements.find(function (m) {
        return m.statistic === statistic;
      });
      if (!measurement) {
        return undefined;
      }
      var type = this.statisticTypes[statistic];
      switch (type) {
        case 'integer':
          return measurement.value.toFixed(0);
        case 'float':
          return measurement.value.toFixed(4);
        case 'duration':
          return metric_formatDuration(measurement.value);
        case 'millis':
          return metric_formatMillis(measurement.value);
        case 'bytes':
          return pretty_bytes_default()(measurement.value);
        default:
          return measurement.value;
      }
    },
    getLabel: function getLabel(tags) {
      return entries_default()(tags).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            value = _ref2[1];

        return typeof value !== 'undefined';
      }).map(function (pair) {
        return pair.join(':');
      }).join('\n') || '(no tags)';
    },
    fetchMetric: function fetchMetric(tags, idx) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.instance.fetchMetric(_this.metricName, tags);

              case 3:
                response = _context.sent;

                _this.$set(_this.errors, idx, null);
                _this.$set(_this.measurements, idx, response.data.measurements);
                if (idx === 0) {
                  _this.description = response.data.description;
                  _this.baseUnit = response.data.baseUnit;
                  _this.statistics = response.data.measurements.map(function (m) {
                    return m.statistic;
                  });
                }
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                console.warn('Fetching metric ' + _this.metricName + ' failed:', _context.t0);
                _this.$set(_this.errors, idx, _context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    fetchAllTags: function fetchAllTags() {
      return Object(rxjs["m" /* from */])(this.tagSelections).pipe(Object(rxjs["g" /* concatMap */])(this.fetchMetric));
    },
    createSubscription: function createSubscription() {
      var vm = this;
      return Object(rxjs["u" /* timer */])(0, 2500).pipe(Object(rxjs["g" /* concatMap */])(vm.fetchAllTags)).subscribe({
        next: function next() {}
      });
    }
  },
  watch: {
    tagSelections: function tagSelections(newVal, oldVal) {
      var _this2 = this;

      newVal.map(function (v, i) {
        return [v, i];
      }).filter(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            v = _ref4[0];

        return !oldVal.includes(v);
      }).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            v = _ref6[0],
            i = _ref6[1];

        return _this2.fetchMetric(v, i);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4041e74a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/metrics/metric.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"metrics table is-fullwidth"},[_c('thead',[_c('tr',[_c('th',{staticClass:"metrics__label",attrs:{"title":_vm.description},domProps:{"textContent":_vm._s(_vm.metricName)}}),_vm._v(" "),_vm._l((_vm.statistics),function(statistic){return _c('th',{key:("head-" + statistic),staticClass:"metrics__statistic-name"},[_c('span',{domProps:{"textContent":_vm._s(statistic)}}),_vm._v(" "),_c('div',{staticClass:"select is-small is-pulled-right"},[_c('select',{domProps:{"value":_vm.statisticTypes[statistic]},on:{"change":function($event){_vm.$emit('type-select', _vm.metricName, statistic, $event.target.value)}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("-")]),_vm._v(" "),_c('option',{attrs:{"value":"integer"}},[_vm._v("Integer")]),_vm._v(" "),_c('option',{attrs:{"value":"float"}},[_vm._v("Float")]),_vm._v(" "),_c('option',{attrs:{"value":"duration"}},[_vm._v("Duration")]),_vm._v(" "),_c('option',{attrs:{"value":"millis"}},[_vm._v("Milliseconds")]),_vm._v(" "),_c('option',{attrs:{"value":"bytes"}},[_vm._v("Bytes")])])])])}),_vm._v(" "),_c('td')],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.tagSelections),function(tags,idx){return _c('tr',{key:idx},[_c('td',{staticClass:"metrics__label"},[_c('span',{domProps:{"textContent":_vm._s(_vm.getLabel(tags))}}),_vm._v(" "),(_vm.errors[idx])?_c('span',{staticClass:"has-text-warning",attrs:{"title":_vm.errors[idx]}},[_c('font-awesome-icon',{attrs:{"icon":"exclamation-triangle"}})],1):_vm._e()]),_vm._v(" "),_vm._l((_vm.statistics),function(statistic){return _c('td',{key:("value-" + idx + "-" + statistic),staticClass:"metrics__statistic-value",domProps:{"textContent":_vm._s(_vm.getValue(_vm.measurements[idx], statistic))}})}),_vm._v(" "),_c('td',{staticClass:"metrics__actions"},[_c('sba-icon-button',{attrs:{"icon":'trash'},on:{"click":function($event){$event.stopPropagation();_vm.handleRemove(idx)}}})],1)],2)}))])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/metrics/metric.vue
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return toMillis; });
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/metrics/metric.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  metric,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var metrics_metric = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/scheduledtasks/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/scheduledtasks/index.vue
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var scheduledtasks = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      cron: null,
      fixedDelay: null,
      fixedRate: null
    };
  },
  computed: {
    hasCronData: function hasCronData() {
      return this.cron && this.cron.length;
    },
    hasFixedDelayData: function hasFixedDelayData() {
      return this.fixedDelay && this.fixedDelay.length;
    },
    hasFixedRateData: function hasFixedRateData() {
      return this.fixedRate && this.fixedRate.length;
    },
    hasData: function hasData() {
      return this.hasCronData || this.hasFixedDelayData || this.hasFixedRateData;
    }
  },
  created: function created() {
    this.fetchScheduledTasks();
  },

  methods: {
    fetchScheduledTasks: function fetchScheduledTasks() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.error = null;
                _context.prev = 1;
                _context.next = 4;
                return _this.instance.fetchScheduledTasks();

              case 4:
                res = _context.sent;

                _this.cron = res.data.cron;
                _this.fixedDelay = res.data.fixedDelay;
                _this.fixedRate = res.data.fixedRate;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                console.warn('Fetching scheduled tasks failed:', _context.t0);
                _this.error = _context.t0;

              case 14:
                _this.hasLoaded = true;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 10]]);
      }))();
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      name: 'instances/scheduledtasks',
      parent: 'instances',
      path: 'scheduledtasks',
      component: this,
      label: 'Scheduled Tasks',
      group: 'Insights',
      order: 950,
      isEnabled: function isEnabled(_ref2) {
        var instance = _ref2.instance;
        return instance.hasEndpoint('scheduledtasks');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cba19fb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/scheduledtasks/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:{ 'is-loading' : !_vm.hasLoaded }},[(_vm.hasLoaded)?[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching scheduled tasks failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):(!_vm.hasData)?_c('div',{staticClass:"message is-warning"},[_c('div',{staticClass:"message-body"},[_vm._v("No scheduled tasks present.")])]):_vm._e(),_vm._v(" "),(_vm.hasCronData)?[_c('h3',{staticClass:"title"},[_vm._v("Cron")]),_vm._v(" "),_c('table',{staticClass:"table is-fullwidth"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.cron),function(task){return _c('tbody',{key:task.runnable.target},[_c('tr',[_c('td',{domProps:{"textContent":_vm._s(task.runnable.target)}}),_vm._v(" "),_c('td',{staticClass:"monospaced",domProps:{"textContent":_vm._s(task.expression)}})])])})],2)]:_vm._e(),_vm._v(" "),(_vm.hasFixedDelayData)?[_c('h3',{staticClass:"title"},[_vm._v("Fixed Delay")]),_vm._v(" "),_c('table',{staticClass:"metrics table is-fullwidth"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.fixedDelay),function(task){return _c('tbody',{key:task.runnable.target},[_c('tr',[_c('td',{domProps:{"textContent":_vm._s(task.runnable.target)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(task.initialDelay)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(task.interval)}})])])})],2)]:_vm._e(),_vm._v(" "),(_vm.hasFixedRateData)?[_c('h3',{staticClass:"title"},[_vm._v("Fixed Rate")]),_vm._v(" "),_c('table',{staticClass:"metrics table is-fullwidth"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.fixedRate),function(task){return _c('tbody',{key:task.runnable.target},[_c('tr',[_c('td',{domProps:{"textContent":_vm._s(task.runnable.target)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(task.initialDelay)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(task.interval)}})])])})],2)]:_vm._e()]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Runnable")]),_vm._v(" "),_c('th',[_vm._v("Expression")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Runnable")]),_vm._v(" "),_c('th',[_vm._v("Initial Delay (ms)")]),_vm._v(" "),_c('th',[_vm._v("Interval (ms)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Runnable")]),_vm._v(" "),_c('th',[_vm._v("Initial Delay (ms)")]),_vm._v(" "),_c('th',[_vm._v("Interval (ms)")])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/scheduledtasks/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  scheduledtasks,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var instances_scheduledtasks = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/sessions/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("./node_modules/lodash/isEqual.js");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/entries.js
var entries = __webpack_require__("./node_modules/lodash/entries.js");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__("./node_modules/lodash/debounce.js");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("./node_modules/moment/moment.js");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/main/frontend/utils/rxjs.js
var rxjs = __webpack_require__("./src/main/frontend/utils/rxjs.js");

// EXTERNAL MODULE: ./node_modules/pretty-bytes/index.js
var pretty_bytes = __webpack_require__("./node_modules/pretty-bytes/index.js");
var pretty_bytes_default = /*#__PURE__*/__webpack_require__.n(pretty_bytes);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/sessions/sessions-list.vue
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var sessions_list = ({
  props: {
    sessions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    instance: {
      type: instance["a" /* default */],
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      deletingAll: null,
      deleting: {}
    };
  },
  methods: {
    prettyBytes: pretty_bytes_default.a,
    deleteAllSessions: function deleteAllSessions() {
      var vm = this;
      vm.deletingAll = 'deleting';
      vm.subscription = Object(rxjs["m" /* from */])(vm.sessions).pipe(Object(rxjs["p" /* map */])(function (session) {
        return session.id;
      }), Object(rxjs["g" /* concatMap */])(vm._deleteSession)).subscribe({
        complete: function complete() {
          vm.deletingAll = 'deleted';
          vm.$emit('deleted', '*');
        },
        error: function error() {
          vm.deletingAll = 'failed';
        }
      });
    },
    deleteSession: function deleteSession(sessionId) {
      var vm = this;
      vm._deleteSession(sessionId).subscribe({
        complete: function complete() {
          return vm.$emit('deleted', sessionId);
        }
      });
    },
    _deleteSession: function _deleteSession(sessionId) {
      var _this = this;

      var vm = this;
      vm.$set(vm.deleting, sessionId, 'deleting');
      return Object(rxjs["r" /* of */])(sessionId).pipe(Object(rxjs["g" /* concatMap */])(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(sessionId) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return vm.instance.deleteSession(sessionId);

                case 2:
                  return _context.abrupt('return', sessionId);

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()), Object(rxjs["t" /* tap */])({
        next: function next(sessionId) {
          return vm.$set(vm.deleting, sessionId, 'deleted');
        },
        error: function error(_error) {
          console.warn('Deleting session ' + sessionId + ' failed:', _error);
          vm.$set(vm.deleting, sessionId, 'failed');
        }
      }));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03ee4e36","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/sessions/sessions-list.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"sessions table is-fullwidth"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Session Id")]),_vm._v(" "),_c('th',[_vm._v("Created at")]),_vm._v(" "),_c('th',[_vm._v("Last accessed at")]),_vm._v(" "),_c('th',[_vm._v("Expiry")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('th',[_vm._v("Attributes")]),_vm._v(" "),_c('th',[(_vm.sessions.length > 1)?_c('sba-confirm-button',{staticClass:"button",class:{ 'is-loading' : _vm.deletingAll === 'deleting', 'is-danger' : _vm.deletingAll === 'failed' },attrs:{"disabled":_vm.deletingAll !== null},on:{"click":function($event){_vm.deleteAllSessions()}}},[(_vm.deletingAll === 'deleted')?_c('span',[_vm._v("Deleted")]):(_vm.deletingAll === 'failed')?_c('span',[_vm._v("Failed")]):_c('span',[_c('font-awesome-icon',{attrs:{"icon":"trash"}}),_vm._v(" Delete")],1)]):_vm._e()],1)])]),_vm._v(" "),_vm._l((_vm.sessions),function(session){return _c('tr',{key:session.id},[_c('td',[_c('router-link',{attrs:{"to":{ name: 'instances/sessions', params: { 'instanceId' : _vm.instance.id}, query: { sessionId : session.id } }},domProps:{"textContent":_vm._s(session.id)}})],1),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(session.creationTime.format('L HH:mm:ss.SSS'))}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(session.lastAccessedTime.format('L HH:mm:ss.SSS'))}}),_vm._v(" "),_c('td',[(session.expired)?_c('span',{staticClass:"tag is-info"},[_vm._v("Expired")]):_vm._e()]),_vm._v(" "),_c('td',[(session.maxInactiveInterval >= 0)?_c('span',{domProps:{"textContent":_vm._s(((session.maxInactiveInterval) + "s"))}}):_c('span',[_vm._v("unlimited")])]),_vm._v(" "),_c('td',_vm._l((session.attributeNames),function(name){return _c('span',{key:((session.id) + "-" + name),staticClass:"tag",domProps:{"textContent":_vm._s(name)}})})),_vm._v(" "),_c('td',[_c('button',{staticClass:"button",class:{ 'is-loading' : _vm.deleting[session.id] === 'deleting', 'is-info' : _vm.deleting[session.id] === 'deleted', 'is-danger' : _vm.deleting[session.id] === 'failed' },attrs:{"disabled":session.id in _vm.deleting},on:{"click":function($event){_vm.deleteSession(session.id)}}},[(_vm.deleting[session.id] === 'deleted')?_c('span',[_vm._v("Deleted")]):(_vm.deleting[session.id] === 'failed')?_c('span',[_vm._v("Failed")]):_c('span',[_c('font-awesome-icon',{attrs:{"icon":"trash"}}),_vm._v(" Delete")],1)])])])}),_vm._v(" "),(_vm.sessions.length === 0)?_c('tr',[_c('td',{staticClass:"is-muted",attrs:{"colspan":"7 "}},[(_vm.isLoading)?_c('p',{staticClass:"is-loading"},[_vm._v("Loading Sessions...")]):_c('p',[_vm._v("No Sessions found.")])])]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_vm._v("Max. inactive"),_c('br'),_vm._v("interval\n      ")])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/sessions/sessions-list.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/sessions/sessions-list.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sessions_list,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var sessions_sessions_list = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/sessions/index.vue




var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sessions__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var regexUuid = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;

var sessions_Session = function Session(_ref) {
  var creationTime = _ref.creationTime,
      lastAccessedTime = _ref.lastAccessedTime,
      session = _objectWithoutProperties(_ref, ['creationTime', 'lastAccessedTime']);

  _classCallCheck(this, Session);

  Object.assign(this, session);
  this.creationTime = moment_default()(creationTime);
  this.lastAccessedTime = moment_default()(lastAccessedTime);
};

/* harmony default export */ var sessions = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  components: { sbaSessionsList: sessions_sessions_list },
  data: function data() {
    return {
      error: null,
      filter: { value: '', type: null },
      sessions: [],
      isLoading: false
    };
  },
  methods: {
    fetch: debounce_default()(sessions__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.error = null;

              if (this.filter.value) {
                _context.next = 4;
                break;
              }

              this.sessions = [];
              return _context.abrupt('return');

            case 4:

              this.isLoading = true;
              _context.prev = 5;

              if (!(this.filter.type === 'sessionId')) {
                _context.next = 12;
                break;
              }

              _context.next = 9;
              return this.fetchSession();

            case 9:
              this.sessions = _context.sent;
              _context.next = 15;
              break;

            case 12:
              _context.next = 14;
              return this.fetchSessionsByUsername();

            case 14:
              this.sessions = _context.sent;

            case 15:
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](5);

              console.warn('Fetching sessions failed:', _context.t0);
              this.error = _context.t0;

            case 21:
              this.isLoading = false;

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[5, 17]]);
    })), 250),
    fetchSession: function fetchSession() {
      var _this = this;

      return sessions__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this.instance.fetchSession(_this.filter.value);

              case 3:
                response = _context2.sent;
                return _context2.abrupt('return', [new sessions_Session(response.data)]);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                if (!(_context2.t0.response.status === 404)) {
                  _context2.next = 13;
                  break;
                }

                return _context2.abrupt('return', []);

              case 13:
                throw _context2.t0;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[0, 7]]);
      }))();
    },
    fetchSessionsByUsername: function fetchSessionsByUsername() {
      var _this2 = this;

      return sessions__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.instance.fetchSessionsByUsername(_this2.filter.value);

              case 2:
                response = _context3.sent;
                return _context3.abrupt('return', response.data.sessions.map(function (session) {
                  return new sessions_Session(session);
                }));

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    handlePaste: function handlePaste(event) {
      var looksLikeSessionId = event.clipboardData.getData('text').match(regexUuid);
      if (looksLikeSessionId) {
        this.filter.type = 'sessionId';
      }
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler: function handler() {
        this.filter = entries_default()(this.$route.query).reduce(function (acc, _ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              name = _ref4[0],
              value = _ref4[1];

          acc.type = name;
          acc.value = value;
          return acc;
        }, { type: 'username', value: '' });
      }
    },
    filter: {
      deep: true,
      immediate: true,
      handler: function handler() {
        var query = _defineProperty({}, this.filter.type, this.filter.value);
        if (!isEqual_default()(query, !this.$route.query)) {
          this.$router.replace({
            name: 'instances/sessions',
            query: query
          });
        }
        this.fetch();
      }
    }
  },
  install: function install(_ref5) {
    var viewRegistry = _ref5.viewRegistry;

    viewRegistry.addView({
      name: 'instances/sessions',
      parent: 'instances',
      path: 'sessions',
      component: this,
      label: 'Sessions',
      group: 'Security',
      order: 700,
      isEnabled: function isEnabled(_ref6) {
        var instance = _ref6.instance;
        return instance.hasEndpoint('sessions');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f42c192a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/sessions/index.vue
var sessions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"field has-addons"},[_c('div',{staticClass:"control"},[_c('span',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.type),expression:"filter.type"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filter, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"username"}},[_vm._v("Username")]),_vm._v(" "),_c('option',{attrs:{"value":"sessionId"}},[_vm._v("SessionId")])])])]),_vm._v(" "),_c('div',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.value),expression:"filter.value"}],staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.filter.value)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.fetchSessionsByUsername()},"paste":_vm.handlePaste,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filter, "value", $event.target.value)}}})])]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n        Fetching sessions failed.\n      ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),_c('sba-sessions-list',{attrs:{"instance":_vm.instance,"sessions":_vm.sessions,"is-loading":_vm.isLoading},on:{"deleted":_vm.fetch}})],1)}
var sessions_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/sessions/index.vue
/* script */


/* template */

/* template functional */
var sessions___vue_template_functional__ = false
/* styles */
var sessions___vue_styles__ = null
/* scopeId */
var sessions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sessions___vue_module_identifier__ = null

var sessions_Component = Object(component_normalizer["a" /* default */])(
  sessions,
  sessions_render,
  sessions_staticRenderFns,
  sessions___vue_template_functional__,
  sessions___vue_styles__,
  sessions___vue_scopeId__,
  sessions___vue_module_identifier__
)

/* harmony default export */ var instances_sessions = __webpack_exports__["default"] = (sessions_Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/shell/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/main/frontend/directives/sticks-below.js
var sticks_below = __webpack_require__("./src/main/frontend/directives/sticks-below.js");

// EXTERNAL MODULE: ./src/main/frontend/services/application.js
var application = __webpack_require__("./src/main/frontend/services/application.js");

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/collections.js
var collections = __webpack_require__("./src/main/frontend/utils/collections.js");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/shell/sidebar.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var sidebar = ({
  props: {
    views: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    instance: {
      type: instance["a" /* default */],
      default: null
    },
    application: {
      type: application["a" /* default */],
      default: null
    }
  },
  directives: { sticksBelow: sticks_below["a" /* default */] },
  data: function data() {
    return {
      isStuck: false
    };
  },
  computed: {
    enabledViews: function enabledViews() {
      var _this = this;

      if (!this.instance) {
        return [];
      }

      return [].concat(_toConsumableArray(this.views)).filter(function (view) {
        return typeof view.isEnabled === 'undefined' || view.isEnabled({ instance: _this.instance });
      }).sort(Object(collections["a" /* compareBy */])(function (v) {
        return v.order;
      }));
    },
    enabledGroupedViews: function enabledGroupedViews() {
      var groups = new Map();
      this.enabledViews.forEach(function (view) {
        var groupName = view.group || view.label;
        var group = groups.get(groupName) || {
          name: groupName,
          order: Number.MAX_SAFE_INTEGER,
          views: []
        };
        groups.set(groupName, _extends({}, group, {
          order: Math.min(group.order, view.order),
          views: [].concat(_toConsumableArray(group.views), [view])
        }));
      });
      return Array.from(groups.values());
    }
  },
  methods: {
    isActiveGroup: function isActiveGroup(group) {
      return group.views.includes(this.$route.meta.view);
    },
    hasMultipleViews: function hasMultipleViews(group) {
      return group.views.length > 1;
    },
    onScroll: function onScroll() {
      this.isStuck = this.$el.getBoundingClientRect().top <= 52;
    },
    showFlyout: function showFlyout(event) {
      var groupEl = event.target;
      groupEl.classList.add('is-showing-flyout');
      var boundingRect = groupEl.getBoundingClientRect();

      var itemsEl = event.target.querySelector('.sidebar-group-items');
      itemsEl.style.top = boundingRect.top + 'px';
      itemsEl.style.left = boundingRect.right + 1 + 'px';
    },
    hideFlyout: function hideFlyout(event) {
      var groupEl = event.target;
      groupEl.classList.remove('is-showing-flyout');
      var itemsEl = event.target.querySelector('.sidebar-group-items');
      itemsEl.style = undefined;
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c83dae4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/shell/sidebar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar"},[(_vm.instance)?_c('div',{directives:[{name:"sticks-below",rawName:"v-sticks-below",value:(['#navigation']),expression:"['#navigation']"}]},[_c('router-link',{staticClass:"instance-summary",class:("instance-summary--" + (_vm.instance.statusInfo.status)),attrs:{"to":{name: 'instances/details', params: {instanceId: _vm.instance.id}}}},[_c('div',{staticClass:"instance-summary__name",domProps:{"textContent":_vm._s(_vm.instance.registration.name)}}),_vm._v(" "),_c('div',{staticClass:"instance-summary__id",domProps:{"textContent":_vm._s(_vm.instance.id)}})]),_vm._v(" "),_c('ul',_vm._l((_vm.enabledGroupedViews),function(group){return _c('li',{key:group.name,staticClass:"sidebar-group",class:{'is-active' : _vm.isActiveGroup(group)},on:{"mouseenter":function($event){_vm.hasMultipleViews(group) && !_vm.isActiveGroup(group) && _vm.showFlyout($event)},"mouseleave":function($event){_vm.hasMultipleViews(group) && !_vm.isActiveGroup(group) && _vm.hideFlyout($event)}}},[_c('router-link',{class:{'is-active' : _vm.isActiveGroup(group) },attrs:{"to":{ name: group.views[0].name, params: { 'instanceId' : _vm.instance.id } },"active-class":"","exact-active-class":""},domProps:{"textContent":_vm._s(_vm.hasMultipleViews(group) ? group.name : group.views[0].label)}}),_vm._v(" "),(_vm.hasMultipleViews(group))?_c('ul',{staticClass:"sidebar-group-items"},_vm._l((group.views),function(view){return _c('li',{key:view.name},[_c('router-link',{attrs:{"to":{ name: view.name, params: { 'instanceId' : _vm.instance.id } }}},[_c(view.handle,{tag:"component"})],1)],1)})):_vm._e()],1)}))],1):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/shell/sidebar.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/shell/sidebar.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sidebar,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var shell_sidebar = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/shell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var shell = ({
  components: { InstanceSidebar: shell_sidebar },
  props: {
    instanceId: {
      type: String,
      required: true
    },
    views: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    applications: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: null,
      default: null
    }
  },
  computed: {
    instance: function instance() {
      return this.applications.findInstance(this.instanceId);
    },
    application: function application() {
      return this.applications.findApplicationForInstance(this.instanceId);
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      name: 'instances',
      path: '/instances/:instanceId',
      component: this,
      props: true
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7606788","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/shell/index.vue
var shell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instances"},[_c('div',{staticClass:"instances__body"},[_c('div',{staticClass:"instances__sidebar"},[_c('instance-sidebar',{attrs:{"views":_vm.views,"instance":_vm.instance,"application":_vm.application}})],1),_vm._v(" "),_c('div',{staticClass:"instances__view"},[(_vm.instance)?_c('router-view',{attrs:{"instance":_vm.instance,"application":_vm.application}}):_vm._e()],1)])])}
var shell_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/shell/index.vue
function shell_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/shell/index.vue")
}
/* script */


/* template */

/* template functional */
var shell___vue_template_functional__ = false
/* styles */
var shell___vue_styles__ = shell_injectStyle
/* scopeId */
var shell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var shell___vue_module_identifier__ = null

var shell_Component = Object(component_normalizer["a" /* default */])(
  shell,
  shell_render,
  shell_staticRenderFns,
  shell___vue_template_functional__,
  shell___vue_styles__,
  shell___vue_scopeId__,
  shell___vue_module_identifier__
)

/* harmony default export */ var instances_shell = __webpack_exports__["default"] = (shell_Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/instances/threaddump/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/remove.js
var remove = __webpack_require__("./node_modules/lodash/remove.js");
var remove_default = /*#__PURE__*/__webpack_require__.n(remove);

// EXTERNAL MODULE: ./node_modules/lodash/entries.js
var entries = __webpack_require__("./node_modules/lodash/entries.js");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./src/main/frontend/mixins/subscribing.js
var subscribing = __webpack_require__("./src/main/frontend/mixins/subscribing.js");

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/rxjs.js
var rxjs = __webpack_require__("./src/main/frontend/utils/rxjs.js");

// EXTERNAL MODULE: ./node_modules/moment-shortformat/moment-shortformat.js
var moment_shortformat = __webpack_require__("./node_modules/moment-shortformat/moment-shortformat.js");
var moment_shortformat_default = /*#__PURE__*/__webpack_require__.n(moment_shortformat);

// EXTERNAL MODULE: ./src/main/frontend/utils/d3.js
var d3 = __webpack_require__("./src/main/frontend/utils/d3.js");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("./node_modules/moment/moment.js");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/threaddump/thread-tag.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var thread_tag = ({
  props: {
    threadState: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84982cc2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/threaddump/thread-tag.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag thread-tag",class:("thread-tag--" + (_vm.threadState.toLowerCase())),attrs:{"title":_vm.threadState}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/instances/threaddump/thread-tag.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/threaddump/thread-tag.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  thread_tag,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var threaddump_thread_tag = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/threaddump/threads-list.vue


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var maxPixelsPerSeconds = 15;

/* harmony default export */ var threads_list = ({
  props: {
    threadTimelines: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showDetails: {},
      lastEndPosition: 0
    };
  },
  components: {
    threadTag: threaddump_thread_tag
  },
  watch: {
    threadTimelines: {
      deep: true,
      handler: 'drawTimelines',
      immediate: true
    }
  },
  methods: {
    getTimeExtent: function getTimeExtent(timelines) {
      return entries_default()(timelines).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            value = _ref2[1];

        return value.timeline;
      }).map(function (timeline) {
        return {
          start: timeline[0].start,
          end: timeline[timeline.length - 1].end
        };
      }).reduce(function (current, next) {
        return {
          start: Math.min(current.start, next.start),
          end: Math.max(current.end, next.end)
        };
      }, { start: Number.MAX_SAFE_INTEGER, end: Number.MIN_SAFE_INTEGER });
    },
    drawTimelines: function drawTimelines(timelines) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var wasInView, _getTimeExtent, start, end, width, totalSeconds, x, scrollable;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!timelines) {
                  _context.next = 12;
                  break;
                }

                wasInView = _this.isInView(_this.lastEndPosition);
                _context.next = 4;
                return _this.$nextTick();

              case 4:
                _getTimeExtent = _this.getTimeExtent(timelines), start = _getTimeExtent.start, end = _getTimeExtent.end;
                width = _this.$el.querySelector('.threads__timeline').getBoundingClientRect().width;
                totalSeconds = Math.floor(width / maxPixelsPerSeconds);
                x = d3["a" /* default */].scaleTime().range([0, width]).domain([start, Math.max(start + (totalSeconds + 1) * 1000, end)]);


                d3["a" /* default */].select('.threads__scale').attr('width', width).call(d3["a" /* default */].axisBottom(x).ticks(Math.max(2, Math.floor(width / 50))).tickFormat(function (d) {
                  return moment_default()(d).format('HH:mm:ss');
                }));

                entries_default()(timelines).forEach(function (_ref3) {
                  var _ref4 = _slicedToArray(_ref3, 2),
                      threadId = _ref4[0],
                      value = _ref4[1];

                  var svg = d3["a" /* default */].select('#thread-' + threadId).attr('width', width);
                  var d = svg.selectAll('rect').data(value.timeline);

                  d.enter().append('rect').merge(d).attr('class', function (d) {
                    return 'thread--' + d.threadState.toLowerCase();
                  }).attr('height', '2em').attr('x', function (d) {
                    return x(d.start);
                  }).transition(150).attr('width', function (d) {
                    return Math.max(x(d.end) - x(d.start), x(d.start + 500) - x(d.start));
                  });
                });

                _this.lastEndPosition = x(end);
                if (wasInView && !_this.isInView(_this.lastEndPosition)) {
                  scrollable = _this.$el;

                  scrollable.scroll(_this.lastEndPosition, scrollable.scrollHeight);
                }

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    isInView: function isInView(xPos) {
      var scrollable = this.$el;
      return scrollable && xPos >= scrollable.scrollLeft && xPos <= scrollable.scrollLeft + scrollable.clientWidth;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df74880","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/threaddump/threads-list.vue
var threads_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"threads table is-fullwidth is-hoverable"},[_c('thead',[_c('tr',[_c('th',{staticClass:"threads__thread-name"},[_vm._v("Name")]),_vm._v(" "),_c('th',{staticClass:"threads__timeline"},[_c('svg',{staticClass:"threads__scale",attrs:{"height":"24px"}})])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.threadTimelines),function(thread){return [_c('tr',{key:thread.threadId,staticClass:"is-selectable",on:{"click":function($event){_vm.showDetails[thread.threadId] ? _vm.$delete(_vm.showDetails, thread.threadId) : _vm.$set(_vm.showDetails, thread.threadId, true)}}},[_c('td',{staticClass:"threads__thread-name"},[_c('thread-tag',{attrs:{"thread-state":thread.threadState}}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(thread.threadName)}})],1),_vm._v(" "),_c('td',{staticClass:"threads__timeline"},[_c('svg',{attrs:{"id":("thread-" + (thread.threadId)),"height":"26px"}})])]),_vm._v(" "),(_vm.showDetails[thread.threadId])?_c('tr',{key:((thread.threadId) + "-detail")},[_c('td',{attrs:{"colspan":"2"}},[_c('table',{staticClass:"threads__thread-details table is-narrow is-fullwidth has-background-white-ter"},[_c('tr',[_c('td',[_vm._v("Thread Id")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(thread.threadId)}})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Thread name")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(thread.threadName)}})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Thread state")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(thread.threadState)}})]),_vm._v(" "),(thread.details !== null)?[_c('tr',[_c('td',[_vm._v("Blocked count")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(thread.details.blockedCount)}})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Blocked time")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(thread.details.blockedTime)}})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Waited count")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(thread.details.waitedCount)}})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Waited time")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(thread.details.waitedTime)}})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Lock name")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(thread.details.lockName)}})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Lock owner id")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(thread.details.lockOwnerId)}})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Lock owner name")]),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(thread.details.lockOwnerName)}})]),_vm._v(" "),(thread.details.stackTrace.length > 0)?_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v("Stacktrace\n                  "),_c('pre',{staticClass:"threads__thread-stacktrace"},[_vm._l((thread.details.stackTrace),function(frame,idx){return [_c('span',{key:("frame-" + (thread.threadId) + "-" + idx),domProps:{"textContent":_vm._s(((frame.className) + "." + (frame.methodName) + "(" + (frame.fileName) + ":" + (frame.lineNumber) + ")"))}}),_vm._v(" "),(frame.nativeMethod)?_c('span',{key:("frame-" + (thread.threadId) + "-" + idx + "-native"),staticClass:"tag is-dark"},[_vm._v("native")]):_vm._e(),_vm._v("\n                  ")]})],2)])]):_vm._e()]:_vm._e()],2)])]):_vm._e()]})],2)])}
var threads_list_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/threaddump/threads-list.vue
function threads_list_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/instances/threaddump/threads-list.vue")
}
/* script */


/* template */

/* template functional */
var threads_list___vue_template_functional__ = false
/* styles */
var threads_list___vue_styles__ = threads_list_injectStyle
/* scopeId */
var threads_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var threads_list___vue_module_identifier__ = null

var threads_list_Component = Object(component_normalizer["a" /* default */])(
  threads_list,
  threads_list_render,
  threads_list_staticRenderFns,
  threads_list___vue_template_functional__,
  threads_list___vue_styles__,
  threads_list___vue_scopeId__,
  threads_list___vue_module_identifier__
)

/* harmony default export */ var threaddump_threads_list = (threads_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/instances/threaddump/index.vue



var threaddump__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function threaddump__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var threaddump = ({
  props: {
    instance: {
      type: instance["a" /* default */],
      required: true
    }
  },
  mixins: [subscribing["a" /* default */]],
  components: {
    threadsList: threaddump_threads_list
  },
  data: function data() {
    return {
      hasLoaded: false,
      error: null,
      threads: null
    };
  },
  computed: {},
  methods: {
    updateTimelines: function updateTimelines(threads) {
      var vm = this;
      var now = moment_shortformat_default()().valueOf();
      vm.threads = vm.threads || {};
      //initialize with all known live threads, which will be removed from the list if still alive
      var terminatedThreads = entries_default()(vm.threads).filter(function (_ref) {
        var _ref2 = threaddump__slicedToArray(_ref, 2),
            value = _ref2[1];

        return value.threadState !== 'TERMINATED';
      }).map(function (_ref3) {
        var _ref4 = threaddump__slicedToArray(_ref3, 1),
            threadId = _ref4[0];

        return parseInt(threadId);
      });

      threads.forEach(function (thread) {
        if (!vm.threads[thread.threadId]) {
          vm.$set(vm.threads, thread.threadId, {
            threadId: thread.threadId,
            threadState: thread.threadState,
            threadName: thread.threadName,
            details: thread,
            timeline: [{
              start: now,
              end: now,
              threadState: thread.threadState
            }]
          });
        } else {
          var entry = vm.threads[thread.threadId];
          entry.details = thread;
          if (entry.threadState !== thread.threadState) {
            entry.threadState = thread.threadState;
            entry.timeline.push({
              start: entry.timeline[entry.timeline.length - 1].end,
              end: now,
              threadState: thread.threadState
            });
          } else {
            entry.timeline[entry.timeline.length - 1].end = now;
          }
        }
        remove_default()(terminatedThreads, function (threadId) {
          return threadId === thread.threadId;
        });
      });

      terminatedThreads.forEach(function (threadId) {
        var entry = vm.threads[threadId];
        entry.threadState = 'TERMINATED';
        entry.details = null;
        entry.timeline[entry.timeline.length - 1].end = now;
      });
    },
    fetchThreaddump: function fetchThreaddump() {
      var _this = this;

      return threaddump__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.instance.fetchThreaddump();

              case 2:
                response = _context.sent;
                return _context.abrupt('return', response.data.threads);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createSubscription: function createSubscription() {
      var vm = this;
      vm.error = null;
      return Object(rxjs["u" /* timer */])(0, 1000).pipe(Object(rxjs["g" /* concatMap */])(vm.fetchThreaddump)).subscribe({
        next: function next(threads) {
          vm.hasLoaded = true;
          vm.updateTimelines(threads);
        },
        error: function error(_error) {
          vm.hasLoaded = true;
          console.warn('Fetching threaddump failed:', _error);
          vm.error = _error;
        }
      });
    }
  },
  install: function install(_ref5) {
    var viewRegistry = _ref5.viewRegistry;

    viewRegistry.addView({
      name: 'instances/threaddump',
      parent: 'instances',
      path: 'threaddump',
      component: this,
      label: 'Threads',
      group: 'JVM',
      order: 400,
      isEnabled: function isEnabled(_ref6) {
        var instance = _ref6.instance;
        return instance.hasEndpoint('threaddump');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4585354c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/threaddump/index.vue
var threaddump_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:{ 'is-loading' : !_vm.hasLoaded }},[(_vm.hasLoaded)?[(_vm.error)?_c('div',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Fetching threaddump failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),(_vm.threads)?_c('threads-list',{attrs:{"thread-timelines":_vm.threads}}):_vm._e()]:_vm._e()],2)}
var threaddump_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/instances/threaddump/index.vue
/* script */


/* template */

/* template functional */
var threaddump___vue_template_functional__ = false
/* styles */
var threaddump___vue_styles__ = null
/* scopeId */
var threaddump___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var threaddump___vue_module_identifier__ = null

var threaddump_Component = Object(component_normalizer["a" /* default */])(
  threaddump,
  threaddump_render,
  threaddump_staticRenderFns,
  threaddump___vue_template_functional__,
  threaddump___vue_styles__,
  threaddump___vue_scopeId__,
  threaddump___vue_module_identifier__
)

/* harmony default export */ var instances_threaddump = __webpack_exports__["default"] = (threaddump_Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/journal/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("./node_modules/lodash/assign.js");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__("./node_modules/lodash/omit.js");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: ./src/main/frontend/mixins/subscribing.js
var subscribing = __webpack_require__("./src/main/frontend/mixins/subscribing.js");

// EXTERNAL MODULE: ./src/main/frontend/services/instance.js + 1 modules
var instance = __webpack_require__("./src/main/frontend/services/instance.js");

// EXTERNAL MODULE: ./src/main/frontend/utils/collections.js
var collections = __webpack_require__("./src/main/frontend/utils/collections.js");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("./node_modules/moment/moment.js");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/journal/index.vue



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var journal_Event = function () {
  function Event(event) {
    _classCallCheck(this, Event);

    this.instance = event.instance;
    this.version = event.version;
    this.type = event.type;
    this.timestamp = moment_default()(event.timestamp);
    this.payload = omit_default()(event, ['instance', 'version', 'timestamp', 'type']);
  }

  _createClass(Event, [{
    key: 'key',
    get: function get() {
      return this.instance + '-' + this.version;
    }
  }]);

  return Event;
}();

/* harmony default export */ var journal = ({
  mixins: [subscribing["a" /* default */]],
  data: function data() {
    return {
      events: [],
      showPayload: {},
      instanceNames: {},
      error: null
    };
  },
  methods: {
    toJson: function toJson(obj) {
      return JSON.stringify(obj, null, 4);
    },
    addEvents: function addEvents(data) {
      var converted = data.map(function (event) {
        return new journal_Event(event);
      });
      converted.reverse();
      this.events = converted.concat(this.events);

      var newInstanceNames = converted.filter(function (event) {
        return event.type === 'REGISTERED';
      }).reduce(function (names, event) {
        return _extends({}, names, _defineProperty({}, event.instance, event.payload.registration.name));
      }, {});
      assign_default()(this.instanceNames, newInstanceNames);
    },
    createSubscription: function createSubscription() {
      var _this = this;

      return instance["a" /* default */].getEventStream().subscribe({
        next: function next(message) {
          _this.error = null;
          _this.addEvents([message.data]);
        },
        error: function error(_error) {
          console.warn('Listening for events failed:', _error);
          _this.error = _error;
        }
      });
    }
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return instance["a" /* default */].fetchEvents();

            case 3:
              response = _context.sent;

              _this2.addEvents(response.data.sort(Object(collections["a" /* compareBy */])(function (v) {
                return v.timestamp;
              })));
              _this2.error = null;
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

              console.warn('Fetching events failed:', _context.t0);
              _this2.error = _context.t0;

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 8]]);
    }))();
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      path: '/journal',
      name: 'journal',
      label: 'Journal',
      order: 100,
      component: this
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c09a3d8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/journal/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Event Journal")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"message is-warning"},[_c('div',{staticClass:"message-body"},[_c('strong',[_c('font-awesome-icon',{staticClass:"has-text-warning",attrs:{"icon":"exclamation-triangle"}}),_vm._v("\n          Server connection failed.\n        ")],1),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.error.message)}})])]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table is-fullwidth"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.events),function(event){return [_c('tr',{key:event.key,staticClass:"is-selectable",on:{"click":function($event){_vm.showPayload[event.key] ? _vm.$delete(_vm.showPayload, event.key) : _vm.$set(_vm.showPayload, event.key, true)}}},[_c('td',{domProps:{"textContent":_vm._s(_vm.instanceNames[event.instance] || '?')}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(event.instance)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(event.timestamp.format('L HH:mm:ss.SSS'))}}),_vm._v(" "),_c('td',[_c('span',{domProps:{"textContent":_vm._s(event.type)}}),_vm._v(" "),(event.type === 'STATUS_CHANGED')?_c('span',{domProps:{"textContent":_vm._s(("(" + (event.payload.statusInfo.status) + ")"))}}):_vm._e()])]),_vm._v(" "),(_vm.showPayload[event.key])?_c('tr',{key:((event.key) + "-detail")},[_c('td',{attrs:{"colspan":"4"}},[_c('pre',{domProps:{"textContent":_vm._s(_vm.toJson(event.payload))}})])]):_vm._e()]})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Application")]),_vm._v(" "),_c('th',[_vm._v("Instance")]),_vm._v(" "),_c('th',[_vm._v("Time")]),_vm._v(" "),_c('th',[_vm._v("Event")])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/journal/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  journal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_journal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "./src/main/frontend/views/wallboard/index.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__("./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js");

// CONCATENATED MODULE: ./src/main/frontend/directives/on-resize.js
/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var observers = new WeakMap();

var on_resize_bind = function bind(el, binding) {
  unbind(el);
  var observer = new ResizeObserver_es["a" /* default */](binding.value);
  observer.observe(el);
  observers.set(el, observer);
};

var unbind = function unbind(el) {
  var observer = observers.get(el);
  if (observer) {
    observer.disconnect();
    observers.delete(el);
  }
};

/* harmony default export */ var on_resize = ({
  bind: on_resize_bind,
  update: function update(el, binding) {
    if (binding.value === binding.oldValue) {
      return;
    }
    on_resize_bind(el, binding);
  },

  unbind: unbind
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/wallboard/hex-mesh.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var tileCount = function tileCount(cols, rows) {
  var shorterRows = Math.floor(rows / 2);
  return rows * cols - shorterRows;
};

var calcSideLength = function calcSideLength(width, height, cols, rows) {
  var fitToWidth = width / cols / Math.sqrt(3);
  var fitToHeight = height * 2 / (3 * rows + 1);
  return Math.min(fitToWidth, fitToHeight);
};

var calcLayout = function calcLayout(minTileCount, width, height) {
  var cols = 1,
      rows = 1;
  var sideLength = calcSideLength(width, height, cols, rows);

  while (minTileCount > tileCount(cols, rows)) {
    var sidelengthExtraCol = calcSideLength(width, height, cols + 1, rows);
    var sidelengthExtraRow = calcSideLength(width, height, cols, rows + 1);
    if (sidelengthExtraCol > sidelengthExtraRow) {
      sideLength = sidelengthExtraCol;
      cols++;
    } else {
      sideLength = sidelengthExtraRow;
      rows++;
    }
  }
  return {
    cols: cols,
    rows: rows,
    sideLength: sideLength
  };
};

/* harmony default export */ var hex_mesh = ({
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    classForItem: {
      type: Function,
      default: function _default() {}
    }
  },
  directives: { onResize: on_resize },
  data: function data() {
    return {
      cols: 1,
      rows: 1,
      sideLength: 1
    };
  },
  methods: {
    translate: function translate(col, row) {
      var x = (col - 1) * this.hexWidth + (row % 2 ? 0 : this.hexWidth / 2);
      var y = (row - 1) * this.sideLength * 1.5;
      return 'translate(' + x + ',' + y + ')';
    },
    item: function item(col, row) {
      var rowOffset = (row - 1) * this.cols - Math.max(Math.floor((row - 1) / 2), 0);
      var index = rowOffset + col - 1;
      return this.items[index];
    },
    point: function point(i) {
      var innerSideLength = this.sideLength * 0.95;
      var marginTop = this.hexHeight / 2;
      var marginLeft = this.hexWidth / 2;
      return marginLeft + innerSideLength * Math.cos((1 + i * 2) * Math.PI / 6) + ',' + (marginTop + innerSideLength * Math.sin((1 + i * 2) * Math.PI / 6));
    },
    click: function click(event, col, row) {
      var item = this.item(col, row);
      if (item) {
        this.$emit('click', item, event);
      }
    },
    updateLayout: function updateLayout() {
      if (this.$el) {
        var boundingClientRect = this.$el.getBoundingClientRect();
        var layout = calcLayout(this.itemCount, boundingClientRect.width, boundingClientRect.height);
        this.cols = layout.cols;
        this.rows = layout.rows;
        this.sideLength = layout.sideLength;
      }
    },
    onResize: function onResize(entries) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var e = _step.value;

          if (e.target === this.$el) {
            this.updateLayout();
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  computed: {
    itemCount: function itemCount() {
      return this.items.length;
    },
    hexPath: function hexPath() {
      return this.point(0) + ' ' + this.point(1) + ' ' + this.point(2) + ' ' + this.point(3) + ' ' + this.point(4) + ' ' + this.point(5);
    },
    hexHeight: function hexHeight() {
      return this.sideLength * 2;
    },
    hexWidth: function hexWidth() {
      return this.sideLength * Math.sqrt(3);
    },
    meshWidth: function meshWidth() {
      return this.hexWidth * this.cols;
    },
    meshHeight: function meshHeight() {
      return this.sideLength * (2 + (this.rows - 1) * 1.5);
    }
  },
  watch: {
    sideLength: function sideLength(newVal) {
      this.$el.style['font-size'] = newVal / 9.5 + 'px';
    },

    itemCount: {
      handler: 'updateLayout',
      immediate: true
    }
  }
});


// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50a2e702","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/wallboard/hex-mesh.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"on-resize",rawName:"v-on-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"hex-mesh"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.meshWidth,"height":_vm.meshHeight}},[_c('defs',[_c('clipPath',{attrs:{"id":"hex-clip"}},[_c('polygon',{attrs:{"points":_vm.hexPath}})])]),_vm._v(" "),[_vm._l((_vm.rows),function(row){return _vm._l((_vm.cols + (row % 2 ? 0 : -1)),function(col){return _c('g',{key:(col + "-" + row),staticClass:"hex",class:_vm.classForItem(_vm.item(col,row)),attrs:{"transform":_vm.translate(col, row)},on:{"click":function($event){_vm.click($event,col,row)}}},[_c('polygon',{attrs:{"points":_vm.hexPath}}),_vm._v(" "),(_vm.item(col,row))?_c('foreignObject',{staticStyle:{"pointer-events":"none"},attrs:{"x":"0","y":"0","width":_vm.hexWidth,"height":_vm.hexHeight}},[_vm._t("item",null,null,_vm.item(col,row))],2):_vm._e()],1)})})]],2)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./src/main/frontend/views/wallboard/hex-mesh.vue
function injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/wallboard/hex-mesh.vue")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  hex_mesh,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var wallboard_hex_mesh = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main/frontend/views/wallboard/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var wallboard = ({
  components: { hexMesh: wallboard_hex_mesh },
  props: {
    applications: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: null,
      default: null
    }
  },
  methods: {
    classForApplication: function classForApplication(application) {
      if (!application) {
        return null;
      }
      if (application.status === 'UP') {
        return 'is-selectable is-primary';
      }
      if (application.status === 'RESTRICTED') {
        return 'is-selectable is-warning';
      }
      if (application.status === 'DOWN') {
        return 'is-selectable is-danger';
      }
      if (application.status === 'OUT_OF_SERVICE') {
        return 'is-selectable is-danger';
      }
      if (application.status === 'OFFLINE') {
        return 'is-selectable is-light';
      }
      return 'is-selectable is-light';
    },
    select: function select(application) {
      if (application.instances.length === 1) {
        this.$router.push({ name: 'instances/details', params: { instanceId: application.instances[0].id } });
      } else {
        this.$router.push({ name: 'applications', params: { selected: application.name } });
      }
    }
  },
  install: function install(_ref) {
    var viewRegistry = _ref.viewRegistry;

    viewRegistry.addView({
      path: '/wallboard',
      name: 'wallboard',
      label: 'Wallboard',
      order: -100,
      component: this
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4316128","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/wallboard/index.vue
var wallboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wallboard section"},[_c('hex-mesh',{attrs:{"items":_vm.applications,"class-for-item":_vm.classForApplication},on:{"click":_vm.select},scopedSlots:_vm._u([{key:"item",fn:function(application){return _c('div',{key:application.name,staticClass:"hex__body application"},[_c('div',{staticClass:"application__header application__time-ago is-muted"},[_c('sba-time-ago',{attrs:{"date":application.statusTimestamp}})],1),_vm._v(" "),_c('div',{staticClass:"application__body"},[_c('h1',{staticClass:"application__name",domProps:{"textContent":_vm._s(application.name)}}),_vm._v(" "),_c('p',{staticClass:"application__instances is-muted"},[_c('span',{domProps:{"textContent":_vm._s(application.instances.length)}}),_vm._v(" instances")])]),_vm._v(" "),_c('h2',{staticClass:"application__footer application__version",domProps:{"textContent":_vm._s(application.buildVersion)}})])}}])})],1)}
var wallboard_staticRenderFns = []

// CONCATENATED MODULE: ./src/main/frontend/views/wallboard/index.vue
function wallboard_injectStyle (context) {
  __webpack_require__("./node_modules/css-hot-loader/index.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!./node_modules/style-loader/index.js!./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?{\"includePaths\":[\"/home/travis/build/codecentric/spring-boot-admin/spring-boot-admin-server-ui/node_modules\"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/views/wallboard/index.vue")
}
/* script */


/* template */

/* template functional */
var wallboard___vue_template_functional__ = false
/* styles */
var wallboard___vue_styles__ = wallboard_injectStyle
/* scopeId */
var wallboard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var wallboard___vue_module_identifier__ = null

var wallboard_Component = Object(component_normalizer["a" /* default */])(
  wallboard,
  wallboard_render,
  wallboard_staticRenderFns,
  wallboard___vue_template_functional__,
  wallboard___vue_styles__,
  wallboard___vue_scopeId__,
  wallboard___vue_module_identifier__
)

/* harmony default export */ var views_wallboard = __webpack_exports__["default"] = (wallboard_Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-polyfill/lib/index.js");
module.exports = __webpack_require__("./src/main/frontend/index.js");


/***/ })

},[0]);


// WEBPACK FOOTER //
// assets/js/sba-core.js